"use strict";

function _ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { _ownKeys(Object(source), true).forEach(function (key) { _defineProperty2(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { _ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper2(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e3) { throw _e3; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e4) { didErr = true; err = _e4; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray2(o, minLen); }

function _arrayLikeToArray2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator2(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { _asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { _asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = o[Symbol.iterator]();
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}
/**==Polyfill==**/
//TODO: see if this is needed: I tried to use the $().trigger to avoid this, but versions of this out in the wild seem to have had that replaced with new CustomEvent(), so maybe that doesn't work either?
//PICK A CONSISTENT EVENT MODEL
//BETTER: write an event model that runs on animationFrame, limits the amount of work it does per frame.
// - see also https://github.com/wilsonpage/fastdom
// - move DOM manipulation out of the UI response
// - issues: disabling a button via addClass('disabled') would need another, internal disable to prevent a second click coming in before the UI update runs


(function () {
  if (typeof window.CustomEvent === "function") return false; //If not IE

  function CustomEvent(event, params) {
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: undefined
    };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;
  window.CustomEvent = CustomEvent;
})(); //Currency Modal


theme.currencyModal = {
  open: function open() {
    var BodyElement = $('body');
    var CurrencyElement = $('.currency__popup');
    BodyElement.addClass('popup--opened');
    CurrencyElement.addClass('is--opened');
  },
  close: function close() {
    var BodyElement = $('body');
    var CurrencyElement = $('.currency__popup');
    BodyElement.removeClass('popup--opened');
    CurrencyElement.removeClass('is--opened');
  }
}; //Currency change helper

theme.currencyChange = function (CountryName) {
  if (CountryName == 'usa') {
    $('[data-currency-name]').html('USA');
  } else {
    $('[data-currency-name]').html('EUR');
  }

  theme.currencyModal.close();
};
/*
* debounce
* @method
* @summary Returns a function, that, as long as it continues to be invoked, will not
*   be triggered. The function will be called after it stops being called for
*   N milliseconds. If `immediate` is passed, trigger the function on the
*   leading edge, instead of the trailing.
*
* @param {Object} func - function to debounce
* @param {Number} wait - time in ms to delay the function call. Passed to setTimeout
* @param {Boolean} immediate - should function get called immediately
* @return {Object} new function set in a setTimeout 
*/


theme.debounce = function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
        args = arguments;

    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};
/*================ Slate ================*/

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */


slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function pageLinkFocus($element) {
    var focusClass = 'js-focus-hidden';
    $element.first().attr('tabIndex', '-1').focus().addClass(focusClass).one('blur', callback);

    function callback() {
      $element.first().removeClass(focusClass).removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function focusHash() {
    var hash = window.location.hash; // is there a hash in the url? is it an element on the page?

    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function bindInPageLinks() {
    $('a[href*=#]').on('click', function (evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function trapFocus(options) {
    var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();
    $(document).on(eventName, function (evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function removeTrapFocus(options) {
    var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  },

  /**
   * modifyErrorsElem
   * @method
   * @summary add accessibility attributes to form error containers
   * @param {string} elemSelector - jQuery selector
   * @return {undefined}
   */
  addLiveAlert: function addLiveAlertToElem(elemSelector) {
    var $elem = $(elemSelector);
    $elem.attr('aria-live', 'assertive');
    $elem.attr('role', 'alert');
  },

  /**
  * toggleAriaExpandedVal
  * @method
  * @summary updates an element's aria-expanded attribute value
  * @param {string|object} elemSelector - string for jQuery selector of target
  * element or jQuery element
  * @return {undefined}
  */
  toggleAriaExpandedVal: function toggleAriaExpandedVal(elemSelector) {
    var $elem = elemSelector.jquery ? elemSelector : $(elemSelector);
    var curExpandedVal = $elem ? $elem.attr('aria-expanded') : '';
    var newExpandedVal;

    if ($elem && curExpandedVal) {
      newExpandedVal = curExpandedVal === 'true' ? 'false' : 'true';
      $elem.attr('aria-expanded', newExpandedVal);
    }
  },

  /*
  * removeFocusOrder
  * @method
  * @summary adds an attribute of tabindex with value of -1 to remove element
  * from normal focus order
  */
  removeFocusOrder: function removeFocusOrder($elems) {
    $elems.attr('tabindex', '-1');
  },

  /**
   * getKeyValue
   * @method
   * @summary return event key value
   * @param {Object} e - DOM event object
   * @return {string} key value
  */
  getKeyValue: function getKeyValue(e) {
    return e.key || e.keyCode || e.which;
  },

  /**
   * isEnterKey
   * @method
   * @summary checks if input is Enter key
   * @param {string} key - DOM event object key or keycode
   * @return {boolean}
  */
  isEnterKey: function isEnterKey(key) {
    return key === 'Enter' || key === 13;
  },

  /**
   * isSpaceKey
   * @method
   * @summary checks if input is Space key
   * @param {string} key - DOM event object key or keycode
   * @return {boolean}
  */
  isSpaceKey: function isSpaceKey(key) {
    return key === 'Space' || key === 32 || key === " ";
  },

  /**
   * isTrigger
   * @method
   * @summary checks if key is Space key or Enter key
   * @param {string} key - DOM event object key or keycode
   * @return {boolean}
  */
  isTrigger: function isTrigger(key) {
    return slate.a11y.isEnterKey(key) || slate.a11y.isSpaceKey(key);
  },

  /**
   * triggerCb
   * @method
   * @summary invokes callback if key is Enter key or Space key
   * @param {Obejct} e - DOM event object
   * @param {Obejct} cb - callback to invoke
   * @return {Boolean | undefined} returns true if callback invoked
  */
  triggerCb: function triggerProcess(e, cb) {
    var a11y = slate.a11y,
        key = a11y.getKeyValue(e),
        trigger = a11y.isTrigger(key);

    if (trigger && typeof cb === 'function') {
      cb();
      return true;
    }
  },

  /**
   * isTabKey
   * @method
   * @summary checks if input is Tab key
   * @param {string} key - DOM event object key or keycode
   * @return {boolean}
  */
  isTabKey: function isTabKey(key) {
    return key === 'Tab' || key === 9;
  },

  /**
   * isEscapeKey
   * @method
   * @summary checks if input is Escape key
   * @param {string} key - DOM event object key or keycode
   * @return {boolean}
  */
  isEscapeKey: function isEscapeKey(key) {
    return key === 'Escape' || key === 27;
  },

  /**
   * isDownArrow
   * @method
   * @summary checks if input is DownArrow key
   * @param {string} key - DOM event object key or keycode
   * @return {boolean}
  */
  isDownArrow: function isDownArrow(key) {
    return key === 'ArrowDown' || key === 40;
  },

  /**
   * isUpArrow
   * @method
   * @summary checks if input is UpArrow key
   * @param {string} key - DOM event object key or keycode
   * @return {boolean}
    */
  isUpArrow: function isUpArrow(key) {
    return key === 'ArrowUp' || key === 38;
  },

  /**
   * isLArrow
   * @method
   * @summary checks if input is LeftArrow key
   * @param {string} key - DOM event object key or keycode
   * @return {boolean}
    */
  isLArrow: function isLArrow(key) {
    return key === 'ArrowLeft' || key === 37;
  },

  /**
   * isRArrow
   * @method
   * @summary checks if input is RightArrow key
   * @param {string} key - DOM event object key or keycode
   * @return {boolean}
    */
  isRArrow: function isRArrow(key) {
    return key === 'ArrowRight' || key === 39;
  },

  /**
   * isTabBack
   * @method
   * @summary checks if key press is shift + tab
   * @param {string} key - DOM event object key or keycode
   * @return {boolean}
    */
  isTabBack: function isTabBack(e, key) {
    return e.shiftKey && slate.a11y.isTabKey(key);
  },
  isTabOnly: function isTabOnly(e, key) {
    return slate.a11y.isTabKey(key) && !slate.a11y.isTabBack(e, key);
  },

  /**
   * altTrapFocus
   * @method
   * @summary Traps the focus in a particular container
   *
   * @param {object} $container - jQuery object. Container to trap focus 
   * @param {string} handlerTarget - target of event handler
   * @param {string} selectors - Comma separted selectors to focus within container
   * @return {undefined}
   */
  altTrapFocus: function altTrapFocus(opts) {
    // altTrapFocus: function altTrapFocus($container, handlerTarget, selectors) {
    var focusableElements = opts.focusSelectors || 'a, button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'; // Get all focusable elements

    var $focusableElems = opts.$container.find(focusableElements).not(':hidden').not('.visually-hidden'); // Get first element to be focused inside container

    var $firstFocusableElement = $focusableElems.first(); // Get last element to be focused inside container

    var $lastFocusableElement = $focusableElems.last();
    var focusFirst = opts.focusFirst === undefined ? true : opts.focusFirst;

    if (focusFirst) {
      console.log("altTrapFocus -> $firstFocusableElement", $firstFocusableElement);
      $firstFocusableElement.focus();
    }

    $(document).on('keydown', opts.handlerTarget, function (e) {
      var keycode = slate.a11y.getKeyValue(e),
          isTabPressed = slate.a11y.isTabKey(keycode);

      if (!isTabPressed) {
        return;
      }

      if (e.shiftKey) {
        // if shift key pressed for shift + tab combination
        if (document.activeElement === $firstFocusableElement[0]) {
          // add focus for the last focusable element
          $lastFocusableElement.focus();
          e.preventDefault();
        }
      } else {
        // if tab key is pressed
        // if focused has reached to last focusable element then focus first focusable element after pressing tab
        if (document.activeElement === $lastFocusableElement[0]) {
          // add focus for the first focusable element
          $firstFocusableElement.focus();
          e.preventDefault();
        }
      }
    });
  },

  /**
   * altRemoveTrapFocus
   * @method
   * @summary Removes trap the focus in a particular container
   *
   * @param {object} $container - jQuery object. Container to remove trap focus from
   * @param {string} handlerTarget - target of event handler
   * @return {undefined}
   */
  altRemoveTrapFocus: function altRemoveTrapFocus($container, handlerTarget) {
    $container.removeAttr('tabindex');
    $(document).off('keydown', handlerTarget);
  },

  /**
   * isExpanded
   * @method
   * @summary Return boolean if element aria-expanded attribute is true
   *
   * @param {object} $elem - jQuery object. Element to check
   * @return {Boolean} is element aria-expanded attribute value 'true'
   */
  isExpanded: function isExpanded($elem) {
    return $elem.attr('aria-expanded') === 'true';
  },

  /**
   * stopEmit
   * @method
   * @summary calls preventDefault and stopPropagation on an event and returns false
   *
   * @param {object} e - event object
   * @return {Boolean} false
   */
  stopEmit: function stopEmit(e) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }
};
/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function cookiesEnabled() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
    }

    return cookieEnabled;
  }
};
/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function findInstance(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function removeInstance(array, key, value) {
    var i = array.length;

    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function compact(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];

      if (value) {
        result[resIndex++] = value;
      }
    }

    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  },
  isObjEmpty: function isObjEmpty(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }

    return true;
  },
  _get: function _get(object, pathString) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var delimiter = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '&&';
    // Coerce pathString to a string (even it turns into "[object Object]").
    var parts = (pathString + '').split(delimiter);
    var length = parts.length;
    var i = 0; // In case object isn't a real object, set it to undefined.

    var value = object === Object(object) ? object : undefined;

    while (value != null && i < length) {
      value = value[parts[i++]];
    }
    /**
     * lodash.get() returns the resolved value if
     * 1. iteration happened (i > 0)
     * 2. iteration completed (i === length)
     * 3. the value at the path is found in the data structure (not undefined). Note that if the path is found but the
     *    value is null, then null is returned.
     * If any of those checks fails, return the defaultValue param, if provided.
     */


    return i && i === length && value !== undefined ? value : defaultValue;
  },
  getLowestPrice: function getLowestPrice(object) {
    return Object.keys(object).reduce(function (acc, v) {
      var loc = object[v];
      return acc && acc.min < loc.min ? acc : loc;
    }, {});
  },
  checkShadeTitle: function checkShadeTitle() {
    var shade = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var last = shade.slice(-1);
    return shade = last === "$" ? last + shade.substr(0, shade.length - 1) : shade;
  }
};
/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function wrapTable(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;
    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function wrapIframe(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;
    options.$iframes.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>'); // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar

      this.src = this.src;
    });
  }
};
/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = function () {
  var moneyFormat = '${{amount}}';
  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;

      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;

      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;

      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;

      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
}();
/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */


slate.Image = function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */
  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }
  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */


  function loadImage(path) {
    new Image().src = path;
  }
  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */


  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }
  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */


  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];
      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
}(); // no slate/sections.js

/**
 * Variant Selection scripts - Custom for KjaerWeis, using: Child Variant Merchandising (CVM)
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */


slate.Variants = function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(product, options) {
    this.product = product;
    this.$container = options.$container;
    this.singleOptionSelector = options.singleOptionSelector; // this.originalSelectorId = options.originalSelectorId;

    this.masterSelect = $(options.originalSelectorId, this.$container)[0]; // might plugins change that? Making it better to search every time?

    this.enableHistoryState = options.enableHistoryState;
    this.optionTypes = options.optionTypes;
    this.currentVariant = 'not init-d'; //not null, which is not selected, but not yet initialized

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }
  /**
   * Find variant based on selected values.
   * Update: don't return a first variant, either, only hard matches. Let the first_or_selected deal with that concept.
   *
   * @return {event}  restriction  - all the variants that match the selections. Could be 0, 1, or more. Listen for this if you need to produce content for only active variants.
   * @return {object || undefined} found - Variant object from product.variants
   */


  Variants.prototype._getVariantFromOptions = function () {
    var found = false;
    var selectedValues = this.optionTypes;

    if (slate.utils.isObjEmpty(selectedValues)) {
      return null;
    }

    var variants = this.product.variants;
    found = slate.utils._get(variants, "".concat(selectedValues.shade, "&&").concat(selectedValues.type));
    return found || null;
  };
  /**
   * Event handler for when a variant input changes.
   * @return {event}  variantChange
   */


  Variants.prototype._onSelectChange = function () {
    var variant = this._getVariantFromOptions();

    if (this.currentVariant === variant) {
      return;
    }

    this.$container.trigger({
      type: 'variantChange',
      variant: variant
    });

    if (!variant) {
      this.currentVariant = variant;
      return;
    } else if (slate.utils.isObjEmpty(this.currentVariant) && !slate.utils.isObjEmpty(variant)) {
      this.currentVariant = variant;
    }

    this._updateMasterSelect(variant);

    this._updateVariantTitle(variant);

    this._updateImages(variant);

    this._updatePrice(variant);

    this._updateFromPrice(variant);

    this._updateProductType(variant);

    this._updateVariantLink(variant);

    this._updateProductAdditionalDetails(variant);

    this.currentVariant = variant;

    if (this.enableHistoryState) {
      this._updateHistoryState(variant);
    }
  };

  Variants.prototype._updateVariantTitle = function (variant) {
    if (this.currentVariant.title !== variant.title) {
      this.$container.trigger({
        type: 'variantTitleChange',
        variant: variant
      });
    }
  };

  Variants.prototype._updateVariantLink = function (variant) {
    if (this.currentVariant.handle !== variant.handle) {
      this.$container.trigger({
        type: 'variantLinkChange',
        variant: variant
      });
    }
  };

  Variants.prototype._updateProductAdditionalDetails = function (variant) {
    if (this.currentVariant.handle !== variant.handle) {
      this.$container.trigger({
        type: 'variantAdditionalDetailsChange',
        variant: variant
      });
    }
  };
  /**
   * Trigger event when variant image changes
   *
   * @param  {object} variant - Currently selected variant
   * @return {event}  variantImageChange
   */


  Variants.prototype._updateImages = function (variant) {
    if (this.currentVariant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage === currentVariantImage) {
        return;
      }
    }

    this.$container.trigger({
      type: 'variantImageChange',
      variant: variant
    });
  };
  /**
   * Trigger event when variant price changes.
   *
   * @param  {object} variant - Currently selected variant
   * @return {event} variantPriceChange
   */


  Variants.prototype._updatePrice = function (variant) {
    if (this.currentVariant && variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
      return;
    }

    this.$container.trigger({
      type: 'variantPriceChange',
      variant: variant
    });
  };

  Variants.prototype._updateFromPrice = function (variant) {
    if (this.product && this.product.priceRanges && this.currentVariant.constructor.name === "Object" && variant.type.split('-')[0].trim() === this.currentVariant.type.split('-')[0].trim()) {
      return;
    }

    this.$container.trigger({
      type: 'variantFromPriceChange',
      variant: variant
    });
  };

  Variants.prototype._updateProductType = function (variant) {
    if (this.currentVariant && this.currentVariant.constructor.name === "Object" && variant.title.split('-').pop().trim() === this.currentVariant.title.split('-').pop().trim()) {
      return;
    }

    this.$container.trigger({
      type: 'variantTypesChange',
      variant: variant
    });
  };
  /**
   * Update history state for product deeplinking
   *
   * @param {object} variant - Currently selected variant
   */


  Variants.prototype._updateHistoryState = function (variant) {
    if (!this.currentVariant || !history.replaceState || !variant || !theme.product) {
      return;
    }

    var location = window.location;
    var search = Variants.prototype._stripVariantId(location.search);
    var newurl = "".concat(location.protocol, "//").concat(location.host).concat( theme.product.currentCollectionHandle ? '/collections/' + theme.product.currentCollectionHandle + "/products/" : "/products/").concat(variant.handle).concat(search ? '/' + search : ''); //Issue with theme editor while updating the URL break customization option. 

    if (!location.search.includes('editor_domain')) {
      window.history.replaceState({ 
        path: newurl
      }, '', newurl);
    }
  };
  /**
   * _stripVariantId
   * @summary remove variant search parameter from url on pdp per client request. See KW-90.
   * @param {String} search - window.location search value
  */


  Variants.prototype._stripVariantId = function (search) {
    var newSearch = search;

    if (search) {
      // Check if variant is a search param. If it is, grab the start and end index
      var indStart = search.indexOf('variant');
      var indEnd = search.indexOf('&', indStart); // If we don't encounter another '&', there are not other search params.
      // If this is the case, set the end index to the end of the search string.

      if (indEnd === -1) indEnd = search.length; // If variant is part of the search parameters, remove it

      if (indStart !== -1) {
        newSearch = "".concat(search.slice(0, indStart)).concat(search.slice(indEnd));
      }
    }

    return newSearch;
  };
  /**
   * Update hidden master select of variant change
   *
   * @param {object} variant - Currently selected variant
   */


  Variants.prototype._updateMasterSelect = function (variant) {
    if (this.masterSelect && this.masterSelect.value) this.masterSelect.value = variant.variants[0].id;
  };

  return Variants;
}();
/*================ Sections ================*/
// using sections/product.js for the custom KW product bundle logic

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 * CUSTOM for KjaerWeis, using: Child Variant Merchandising (CVM)
 *
   * @namespace product
 */


theme.Product = function () {
  var selectors = {
    addToCart: '.add-to-cart',
    //addToCartText: '[data-add-to-cart-text]',
    //comparePrice: '[data-compare-price]',
    //comparePriceText: '[data-compare-text]',
    originalSelectorId: '.product-select',
    priceWrapper: '.price',
    //productFeaturedImage: '[data-product-featured-image]',
    productJson: '.data-product-json',
    //productPrice: '[data-product-price]',
    singleOptionSelector: '.single-option-selector',
    shadeSelector: '.shade',
    featuredImagesSelector: '.featured-images',
    slickSlideContainer: '[data-slick-slider-cont]',
    stickySidebarContainer: '.stickySidebar',
    typeSelector: '.product-type',
    productTitle: '#product-title',
    variantTitle: '#variant-title',
    variantBadge: '.variant__badge',
    fromPrice: '.from-price',
    certifications: '.certifications',
    productDescription: '.product-description',
    ingredients: '.ingredients',
    productImages: '.pslider__img-container',
    shadesComponent: '.shade-selector',
    shadesWrapper: '.shade-selector__wrapper',
    shadesContainer: '.shade-selector .shades-container',
    shades: '.shade-selector .shades, .product-info .shades, .kit-item .shades',
    shadeTitleQuickAddSlider: '.shade-title--slider',
    shadeHeightSelector: '.shade-selector.open .accordion-body.shades-container',
    typesComponent: '.type-selector',
    shadeSelectedTitleContainer: '.shade-info-container',
    shadeTitle: '#shade-title, [data-variant-title]',
    types: '.types-selector .types',
    typesContainer: '.types-selector',
    singleVariantPanel: '.single-variant-panel',
    kitItem: '.kit-item',
    typesHeightSelector: '.type-selector.open .accordion-body.types-selector',
    outOfStockMessage: '.oos-message',
    pdpFavoriteContainer: '.product-favorite',
    pdpDesktopCtaContainer: '.atc-container',
    pdpQuickAddCtaConatiner: '.atc-container',
    plpItemImage: '.prod-image .default img',
    plpBadge: '.badge',
    plpFavoriteContainer: '.product-favorite',
    plpTypes: '.types',
    plpVariantInfo: '.variantInfo',
    plpVariantLink: '.variantLink',
    plpFromPrice: '.price .variantPrice',
    quickAdd: '.quickAdd',
    closeModal: '#FgModal > .closer',
    previousBtn: '.previous',
    shadeFinderTrigger: '.shadefinder-modal-opener',
    shadeFinder: '#FgModal .shadeFinder-container',
    skintone: '.skintone',
    skintoneFilter: '#skin-tone, [data-skintone]',
    starRating: '.star-ratings',
    typeContinue: '.continue',
    undertone: '.undertone',
    undertoneFilter: '#undertone, [data-undertone]',
    recommendation: '.recommendation',
    recommendedShade: 'a[data-recommended-shade]',
    pdpVariantAdditionalDetails: '.js-additional-details',
    swaInitializationTriggers: ['#product-loop', '#section-product-bundle'],
    pdpYotpoGallery: '[data-yotpo-gallery="pdp"]',
    yotpoGallerySlider: '.yotpo-display-wrapper.yotpo-slider',
    yotpoGalleryHeader: '.brow-text',
    klaviyoBisModal: '#klaviyo-bis-modal'
  };
  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */

  function Product() {
    return _Product.apply(this, arguments);
  }

  function _Product() {
    _Product = _asyncToGenerator2( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var _this11 = this;

      var container,
          products,
          bundle,
          product,
          component,
          clone,
          continueCta,
          addCta,
          $ctaContainer,
          options,
          context,
          _args3 = arguments;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              container = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : "";
              products = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : [];
              bundle = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : {};
              product = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
              component = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : "pdp";
              clone = _args3.length > 5 && _args3[5] !== undefined ? _args3[5] : {};
              this.component = component;
              this.products = products;
              this.container = container;
              this.$container = $(container);
              this.bundleProduct = {
                variants: {},
                priceRanges: {}
              };
              this.currentShade = "";
              this.currentType = "";
              this.skintone = "All";
              this.undertone = "All";
              this.settings = {
                imageSize: null,
                placeholder: 'https://via.placeholder.com/1080',
                extApp: 'https://kjaerweis.roswellstudios.com/',
                inventoryEndPoint: 'inventory/all',
                inventoryByLocation: {
                  usa: "Axcess Point",
                  europe: "Prime Cargo"
                }
              };
              this.namespace = '.product';
              this.inventoryBySku = {};
              this.shades = [];
              this.types = [];
              this.currentCollectionHandle = bundle.handle || '';
              this.quickAddConfig = bundle.quickAddConfig || {};
              this.bundleUpsells = bundle.bundleUpsells || [];
              this.cachedElems = {}; // Use for resize handlers

              this.windowSize = $(window).width();
              this.addBisModalHandlers();
              this.initYotpoGallery(); // NOTE: re-check inventory levels and update the ATC btn when the currency changes:

              $(document).on('locale.changed', this.setAddToCartState.bind(this));

              if (!(this.component !== 'quickAdd')) {
                _context3.next = 40;
                break;
              }

              if (!(products && Array.isArray(products))) {
                _context3.next = 40;
                break;
              }

              products.forEach(function (p) {
                var shade = "";

                if (p.title.split("-").length === 2) {
                  shade = p.title.split("-").pop().trim();
                }

                var type = p.type.split("-")[0].trim();

                if (_this11.bundleProduct.variants[shade]) {
                  if (_this11.bundleProduct.variants[shade][type]) {
                    _this11.bundleProduct.variants[shade][type] = p;
                    if (!_this11.bundleProduct.variants[shade][type].media) _this11.bundleProduct.variants[shade][type].media = [{
                      src: _this11.settings.placeholder
                    }];

                    _this11.checkPrice(type, p.price, "USA");

                    _this11.checkPrice(type, p.compare_at_price, "EUR");
                  } else {
                    _this11.bundleProduct.variants[shade][type] = {};
                    _this11.bundleProduct.variants[shade][type] = p;
                    if (!_this11.bundleProduct.variants[shade][type].media) _this11.bundleProduct.variants[shade][type].media = [{
                      src: _this11.settings.placeholder
                    }];

                    _this11.checkPrice(type, p.price, "USA");

                    _this11.checkPrice(type, p.compare_at_price, "EUR");
                  }
                } else {
                  _this11.bundleProduct.variants[shade] = {};
                  _this11.bundleProduct.variants[shade][type] = {};
                  _this11.bundleProduct.variants[shade][type] = p;
                  if (!_this11.bundleProduct.variants[shade][type].media) _this11.bundleProduct.variants[shade][type].media = [{
                    src: _this11.settings.placeholder
                  }];

                  _this11.checkPrice(type, p.price, "USA");

                  _this11.checkPrice(type, p.compare_at_price, "EUR");
                }

                if (_this11.shades.indexOf(shade) === -1) _this11.shades.push(shade);
                if (_this11.types.indexOf(type) === -1) _this11.types.push(type);
              });
              this.bundleProduct = _objectSpread2(_objectSpread2(_objectSpread2({}, this.bundleProduct), bundle.metafields), {
                title: bundle.title
              }); // tag handler: (tags metafield on the collection bundle)

              if (this.bundleProduct.tags) this.bundleProduct.tags = this.bundleProduct.tags.split(",");
              this.bundleProduct.step1SelectorTitle = bundle.metafields.step1SelectorTitle || 'Choose Shade';
              this.bundleProduct.step2SelectorTitle = bundle.metafields.step2SelectorTitle || 'Refill or Case';
              this.bundleProduct.klaviyoBisUrl = bundle.klaviyoBisUrl || '';
              this.numShades = this.shades.length; // Object.keys(this.bundleProduct.variants).length;

              this.numTypes = this.types.length;
              _context3.next = 39;
              return this.fetchInventory(products);

            case 39:
              this.inventoryBySku = _context3.sent;

            case 40:
              if (this.component === 'pdp') {
                continueCta = $(selectors.typeContinue, this.$container);
                addCta = $(selectors.addToCart, this.$container);
                $ctaContainer = $(selectors.pdpDesktopCtaContainer, this.$container);
                this.cachedElems = _objectSpread2(_objectSpread2({}, this.cachedElems), {}, {
                  continueCta: continueCta,
                  addCta: addCta,
                  ctaContainer: $ctaContainer
                });
                this.setShade(product);
                this.setType(product);
                this.renderProductTitle(bundle.title);
                this.renderCertifications();
                this.renderDescription(); // this.renderIngredients();

                this.renderProductImages();
                this.skinToneHandlers();
                this.initFeaturedProductsSlider();
                this.featProductSliderHandlers();

                if (this.numShades > 1) {
                  this.renderShades();
                } else {
                  this.cachedElems.continueCta.remove();
                  this.enableAddToCartCta();
                  this.destroyShades();
                }

                if (this.numTypes > 1) {
                  this.renderProductTypes();
                } else {
                  this.cachedElems.continueCta.remove();
                  this.enableAddToCartCta();
                  this.destroyTypes();
                  this.removeContinueButton();
                }

                if (this.bundleProduct.singleVariantOption && this.bundleProduct.singleVariantOption.image) {
                  this.renderSingleVariantPanel();
                }

                this.initAccordionStates();
                options = {
                  $container: this.$container,
                  optionTypes: {
                    shade: this.currentShade,
                    type: this.currentType
                  },
                  enableHistoryState: this.$container.data('enable-history-state') || false,
                  singleOptionSelector: selectors.singleOptionSelector,
                  originalSelectorId: selectors.originalSelectorId
                };
                context = this;
                this.variants = new slate.Variants(this.bundleProduct, options);
                this.$container.on('click', selectors.shadeSelector, this.changer.bind(this));
                this.$container.on('click', selectors.typeSelector, this.changer.bind(this));
                this.$container.on('click', selectors.shadeFinderTrigger, this.shadeFinder.bind(this));
                this.$container.on('click', selectors.quickAdd, function (e) {
                  context.quickAdd(e, bundle.quickAddConfig, 'pdp-form');
                });
                this.$container.on('click', '.accordion-banner:not(".locked")', this.updateAccordionStates.bind(this));
                this.$container.on('click', selectors.typeContinue, this.continueCtaHandler.bind(this));
                this.$container.on('click change', selectors.skintoneFilter, this.toneFilter.bind(this));
                this.$container.on('click change', selectors.undertoneFilter, this.toneFilter.bind(this));
                this.$container.on('variantChange' + this.namespace, this.setAddToCartState.bind(this));
                this.$container.on('variantChange' + this.namespace, this.setVariantBadge.bind(this));
                this.$container.on('variantChange' + this.namespace, this.showMobileAddToCart.bind(this));
                this.$container.on('variantChange' + this.namespace, this.refreshOOSMessage.bind(this));
                this.$container.on('variantTitleChange' + this.namespace, this.setVariantTitle.bind(this));
                this.$container.on('variantTitleChange' + this.namespace, this.setFavoriteButton.bind(this)); //this.$container.on('variantTitleChange' + this.namespace, this.updateReviews.bind(this));

                this.$container.on('variantTitleChange' + this.namespace, this.refreshStarRatings.bind(this));
                this.$container.on('variantTitleChange' + this.namespace, this.updateYotpoGallery.bind(this));
                this.$container.on('variantFromPriceChange' + this.namespace, this.setFromPrice.bind(this));
                this.$container.on('variantTypesChange' + this.namespace, this.setProductTypes.bind(this));
                this.$container.on('variantImageChange' + this.namespace, this.setProductImages.bind(this));
                this.initQuickAddSlider();
                this.$container.on('variantAdditionalDetailsChange' + this.namespace, this.setVariantAdditionalDetails.bind(this));
                setTimeout(function () {
                  //need this to run after the rest of the inits.
                  this.variants._onSelectChange(); //might not have this bound either

                }.bind(this), 1);
                this.setTooltips();
                $(document).trigger({
                  type: 'bundleProduct.loaded',
                  bundleProduct: this
                });
                theme.pdpStickySidebar = this.initStickySidebar();
                this.setImageContainerHeight();
                this.$container.on('click', selectors.stickySidebarContainer, this.initStickySidebarHandlers);
                $(window).on('resize', this.initStickySidebarHandlers);
                $(window).on('resize', this.setImageContainerHeight);
              } else if (this.component === 'plp') {
                this.currentShade = products && products.length ? products[0].title.split('-').length === 2 ? products[0].title.split('-').pop().trim() : "" : null;
                this.currentType = products && products.length ? products[0].type.split('-')[0].trim() : null;
                this.variants = {};
                this.plpTypesInputSelector = "input[name=\"product-type-".concat(this.handelize(this.bundleProduct.title), "\"]");
                $(document).on('rs-navigator.loaded', this.initPlpItem.bind(this));
              } else if (this.component === 'quickAdd') {
                continueCta = $(selectors.typeContinue, this.$container);
                addCta = $(selectors.addToCart, this.$container);
                $ctaContainer = $(selectors.pdpQuickAddCtaConatiner, this.$container);
                this.cachedElems = {
                  continueCta: continueCta,
                  addCta: addCta,
                  ctaContainer: $ctaContainer
                };
                this.bundleProduct = clone.bundleProduct;
                this.currentShade = clone.currentShade;
                this.currentType = clone.currentType;
                this.numShades = clone.numShades;
                this.numTypes = clone.numTypes;
                this.inventoryBySku = clone.inventoryBySku;
                this.enableTypesContinue();

                if (this.numShades > 1) {
                  this.renderShades();
                } else {
                  this.destroyShades();
                }

                if (this.numTypes > 1) {
                  this.renderProductTypes();
                } else {
                  this.destroyTypes();
                }

                this.initQuickAddSlider();
                this.setTooltips();
                options = {
                  $container: this.$container,
                  optionTypes: {
                    shade: this.currentShade,
                    type: this.currentType
                  },
                  enableHistoryState: this.$container.data('enable-history-state') || false,
                  singleOptionSelector: selectors.singleOptionSelector,
                  originalSelectorId: selectors.originalSelectorId
                };
                this.variants = new slate.Variants(this.bundleProduct, options);
                this.$container.on('click', selectors.shadeSelector, this.changer.bind(this));
                this.$container.on('click', selectors.typeSelector, this.changer.bind(this));
                this.$container.on('click', selectors.closeModal, this.onUnload.bind(this));
                this.$container.on('click', selectors.shadeFinderTrigger, this.shadeFinder.bind(this));
                this.$container.on('click change', selectors.skintoneFilter, this.toneFilter.bind(this));
                this.$container.on('click change', selectors.undertoneFilter, this.toneFilter.bind(this));
                this.$container.on('variantChange' + this.namespace, this.setAddToCartState.bind(this));
                this.$container.on('variantChange' + this.namespace, this.refreshOOSMessage.bind(this));
                this.$container.on('variantTitleChange' + this.namespace, this.setVariantTitle.bind(this));
                this.$container.on('variantTitleChange' + this.namespace, this.refreshQuickAddImages.bind(this));
                this.$container.on('variantFromPriceChange' + this.namespace, this.setFromPrice.bind(this));
                this.$container.on('variantTypesChange' + this.namespace, this.setProductTypes.bind(this));
                this.$container.on('variantImageChange' + this.namespace, this.setProductImages.bind(this));
                setTimeout(function () {
                  //need this to run after the rest of the inits.
                  this.variants._onSelectChange(); //might not have this bound either

                }.bind(this), 1);
              } else if (this.component === 'quickAddTrigger') {
                context = this;
                this.currentShade = products && products.length ? products[0].title.split('-').length === 2 ? products[0].title.split('-').pop().trim() : "" : null;
                this.currentType = products && products.length ? products[0].type.split('-')[0].trim() : null;
                this.$container.on('click', selectors.closeModal, this.onUnload.bind(this));
                this.$container.on('click', selectors.quickAdd, function (e) {
                  context.quickAdd(e, bundle.quickAddConfig);
                });
                this.$container.on('click', selectors.shadeFinderTrigger, this.shadeFinder.bind(this));
                this.enableTypesContinue();
              }

              return _context3.abrupt("return", this);

            case 42:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));
    return _Product.apply(this, arguments);
  }

  Product.prototype.fetchInventory = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator2( /*#__PURE__*/regeneratorRuntime.mark(function _callee(products) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(sessionStorage.getItem('inventory') || theme.inventory)) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", theme.inventory || JSON.parse(sessionStorage.getItem('inventory')));

            case 4:
              _context.prev = 4;
              _context.next = 7;
              return $.getJSON("".concat(this.settings.extApp).concat(this.settings.inventoryEndPoint));

            case 7:
              theme.inventory = _context.sent;
              sessionStorage.setItem('inventory', JSON.stringify(theme.inventory));
              return _context.abrupt("return", theme.inventory);

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](4);
              console.log(_context.t0);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[4, 12]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();

  Product.prototype.initPlpItem = function (evt) {
    this.$container = $(this.container);

    if (this.numShades > 0) {
      this.renderShades();
    } else {
      this.destroyShades();
    }

    if (this.numTypes > 1) {
      this.renderProductTypes();
    } else {
      this.destroyTypes();
    }

    this.renderPlpProductTypes();
    this.initQuickAddSlider();
    var options = {
      $container: this.$container,
      optionTypes: {
        shade: this.currentShade,
        type: this.currentType
      },
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId
    };
    var context = this;
    this.variants = new slate.Variants(this.bundleProduct, options);
    this.$container.on('click', selectors.shadeSelector, this.changer.bind(this));
    this.$container.on('click', selectors.typeSelector, this.changer.bind(this));
    this.$container.on('variantChange' + this.namespace, this.setAddToCartState.bind(this));
    this.$container.on('variantChange' + this.namespace, this.setKitVariantId.bind(this));
    this.$container.on('variantChange' + this.namespace, this.refreshOOSMessage.bind(this));
    this.$container.on('variantLinkChange' + this.namespace, this.setPlpVariantLink.bind(this));
    this.$container.on('variantTitleChange' + this.namespace, this.setPlpVariantTitle.bind(this));
    this.$container.on('variantTitleChange' + this.namespace, this.setFavoriteButton.bind(this));
    this.$container.on('variantTitleChange' + this.namespace, this.refreshStarRatings.bind(this));
    this.$container.on('variantTitleChange' + this.namespace, this.refreshVariantBadge.bind(this));
    this.$container.on('variantFromPriceChange' + this.namespace, this.setPlpFromPrice.bind(this));
    this.$container.on('variantTypesChange' + this.namespace, this.setPlpProductTypes.bind(this));
    this.$container.on('variantImageChange' + this.namespace, this.setPlpItemImage.bind(this)); // "Quick" add:

    this.$container.on('click', selectors.quickAdd, function (e) {
      context.quickAdd(e, context.quickAddConfig);
    });
    setTimeout(function () {
      //need this to run after the rest of the inits.
      this.variants._onSelectChange(); //might not have this bound either

    }.bind(this), 1);
  };

  Product.prototype.updateReviews = function (evt) {
    var product = evt.variant;
    var storeUrl = "https://store.kjaerweis.com";
    var container = "<div class=\"yotpo yotpo-main-widget\" \n    data-product-id=\"".concat(product.id, "\" \n    data-name=\"").concat(product.title, "\" \n    data-url=\"").concat(storeUrl).concat(product.url, "\" \n    data-image-url=\"").concat(product.featured_image, "\" \n    data-description=\"").concat(product.description, "\"\n    ></div>");
    $('.reviews-widget__wrapper').html(container);
    var api = new Yotpo.API(yotpo);
    api.refreshWidgets();
  };

  Product.prototype.changer = function (evt) {
    evt.stopPropagation();
    var currShade = this.currentShade;
    var currType = this.currentType;
    var target = $(evt.currentTarget);

    if (target.hasClass('shade')) {
      currShade = target.data('shade');
    } else if (target.hasClass('product-type')) {
      if (this.component === 'plp') {
        currType = $("".concat(this.plpTypesInputSelector, ":checked")).val();
      } else {
        currType = target.data('type');
      }
    }

    var product = slate.utils._get(this.bundleProduct.variants, "".concat(currShade, "&&").concat(currType));

    if (currShade) this.setShade(currShade);
    if (currType) this.setType(currType);
    this.variants.optionTypes = {
      shade: this.currentShade,
      type: this.currentType
    };

    this.variants._onSelectChange();
  };

  Product.prototype.setVariantAdditionalDetails = function (evt) {
    var variant = evt.variant;
    var $variantAdditionalDetails = $(selectors.pdpVariantAdditionalDetails, this.$container);
    var AdditionalDetails = this.bundleProduct.variants[this.currentShade][this.currentType].metafields['additional-details'];

    if (AdditionalDetails) {
      $variantAdditionalDetails.html(AdditionalDetails);
    } else {
      $variantAdditionalDetails.html('');
    }
  };

  Product.prototype.showMobileAddToCart = function (evt) {
    var variant = null;

    if (evt.variant) {
      variant = evt.variant;
    } else {
      variant = slate.utils._get(this.bundleProduct.variants, "".concat(this.currentShade, "&&").concat(this.currentType));
    } // Null option feature should addClass('disabled'), let that do the hide/show/gray out work.
    //  might  want to make that something that can be applied to the option area to hightlight it.


    if (variant) {//$(selectors.priceWrapper, this.$container).removeClass('hide');
    } else {
      $(selectors.addToCart, this.$container).prop('disabled', true).text(theme.strings.unavailable); //$(selectors.priceWrapper, this.$container).addClass('hide'); show range?

      return;
    } //NOTE: inventory logic:


    var location = sessionStorage.getItem('countrySelected');

    if (location) {
      var inventoryLocation = this.settings.inventoryByLocation[location];
      var product = this.inventoryBySku[variant.variants[0].sku];
      var inventory;
      if (product) inventory = product.find(function (l) {
        return l.location === inventoryLocation;
      });
      if (inventory) variant.available = inventory && inventory.available && inventory.available > 8 ? true : false;
    }

    console.log({
      "var": variant
    });

    if (!variant.available) {
      $('.atc-container--mobile .pdp__quick-add-trigger').hide(function () {
        $('.atc-container--mobile .bis-trigger').show();
      });
    } else {
      $('.atc-container--mobile .bis-trigger').hide(function () {
        $('.atc-container--mobile .pdp__quick-add-trigger').show();
      });
    }
  };

  Product.prototype.checkPrice = function (type, price, locale) {
    if (!this.bundleProduct.priceRanges[locale]) {
      this.bundleProduct.priceRanges[locale] = {};
      this.bundleProduct.priceRanges[locale][type] = {};
      this.bundleProduct.priceRanges[locale][type].min = this.bundleProduct.priceRanges[locale][type].max = price;
    } else if (!this.bundleProduct.priceRanges[locale][type]) {
      this.bundleProduct.priceRanges[locale][type] = {};
      this.bundleProduct.priceRanges[locale][type].min = this.bundleProduct.priceRanges[locale][type].max = price;
    } else {
      if (price < this.bundleProduct.priceRanges[locale][type].min) {
        this.bundleProduct.priceRanges[locale][type].min = price;
      }

      if (price > this.bundleProduct.priceRanges[locale][type].max) {
        this.bundleProduct.priceRanges[locale][type].max = price;
      }
    }
  };

  Product.prototype.initFeaturedProductsSlider = function () {
    var initialized = $("".concat(selectors.slickSlideContainer, ".slick-initialized"));

    if (!initialized.length) {
      var $pdpSlider = $(selectors.slickSlideContainer, this.$container);
      $pdpSlider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: true,
        draggable: true,
        swipe: true,
        mobileFirst: true,
        responsive: [{
          breakpoint: 1023,
          settings: 'unslick'
        }]
      });
      var sliderTimeout = setTimeout(function () {
        $(selectors.slickSlideContainer).addClass('loaded');
        clearTimeout(sliderTimeout);
      }, 1000);
    } else {
      initialized.slick('refresh');
    }
  };

  Product.prototype.debouncedInitFeatProdSlider = theme.debounce(function (context) {
    context.initFeaturedProductsSlider();
  }, 600);

  Product.prototype.featProductSliderHandlers = function () {
    var context = this;
    $(window).on('resize', function () {
      context.debouncedInitFeatProdSlider(context);
    });
    $(document).on('shopify:section:load', function (e) {
      context.initFeaturedProductsSlider();
    });
  };

  Product.prototype.initQuickAddSlider = function (config) {
    var $shadeSelectorSlider = $('.shade-selector__slider', this.$container);
    var $shadeTitle = $("".concat(selectors.shadeTitleQuickAddSlider), this.$container);
    var $shadeTitleAppended = $shadeSelectorSlider.find("".concat(selectors.shadeTitleQuickAddSlider), this.$container);
    var defaults = {
      infinite: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true
    };
    var options = config ? config : defaults;
    $shadeSelectorSlider.slick(options); // Only append if doesn't not already moved

    if (!$shadeTitleAppended.length) {
      $("".concat(selectors.shadeTitleQuickAddSlider), this.$container).appendTo($shadeSelectorSlider);
    }
  };

  Product.prototype.setDynamicHeight = function (element, width, selector) {
    var $this = $('<div>').attr('id', 'fakeEl').css('width', width + 'px').appendTo(document.body);
    $this.append(element);
    var height = $this.outerHeight() + 200; // account for padding

    $this.remove();
    var style = document.createElement('style');
    style.textContent = "".concat(selectors[selector], " {\n      max-height: ").concat(height, "px!important;\n    }");
    document.head.append(style);
  };

  Product.prototype.handelize = function (str) {
    if (typeof str != 'string' || str == "") {
      return ""; // should probably return an informative error
    }

    str = str.toLowerCase();
    var toRemoveEnd = ['"', "'", "\\", "(", ")", "[", "]", ".", "-"];
    var toReplace = ["'", "\\", "(", ")", "[", "]", "."];
    var toRemove = ['"'];
    var strLength = str.length; // For the old browsers

    for (var i = 0; i < toReplace.length; ++i) {
      str = str.replace(toReplace[i], "-");
    }

    for (var i = 0; i < toRemoveEnd.length; ++i) {
      if (str.charAt(strLength - 1) == toRemoveEnd[i]) {
        str = str.substring(0, str.length - 1);
      }

      if (str.charAt(0) == toRemoveEnd[i]) {
        str = str.slice(1);
      }
    }

    for (var i = 0; i < toRemove.length; ++i) {
      str = str.replace(toRemove[i], "");
    }

    str = str.replace(/\W+/g, "-");

    if (str.charAt(str.length - 1) == "-") {
      str = str.replace(/-+\z/, "");
    }

    if (str.charAt(0) == "-") {
      str = str.replace(/\A-+/, "");
    }

    if (!isNaN(str.charAt(0))) {
      str = 'n'.concat(str);
    }

    return str;
  };

  Product.prototype.setShade = function (param) {
    var $shadeSelector = $(selectors.shadeSelector, this.$container);
    $shadeSelector.removeClass('selected');

    if (_typeof2(param) === "object") {
      if (param.title.split("-").length === 2) {
        this.currentShade = param.title.split("-").pop().trim();
      }
    } else if (typeof param === "string") {
      this.currentShade = param;
      this.setVariantTitle({
        variant: {
          title: param
        }
      });
      this.setProductTypes({
        variant: {
          title: param
        }
      });
    }

    var $thisShade = $("".concat(selectors.shadeSelector, "[data-shade=\"").concat(this.currentShade, "\"]"), this.$container);
    var $thisShadeTitle = $("".concat(selectors.shadeTitle), this.$container);
    var $quickAddSliderTitle = $("".concat(selectors.shadeTitleQuickAddSlider), this.$container);
    $thisShade.addClass('selected');
    $thisShadeTitle.html("".concat(slate.utils.checkShadeTitle(this.currentShade)));
    $quickAddSliderTitle.html("".concat(this.currentShade));
  };

  Product.prototype.setType = function (param) {
    var $typeSelector = $(selectors.typeSelector, this.$container);
    $typeSelector.removeClass('selected');

    if (_typeof2(param) === "object") {
      this.currentType = param.type.split("-")[0].trim();
    } else if (typeof param === "string") {
      this.currentType = param;
    }

    var $thisType = $("".concat(selectors.typeSelector, "[data-type=\"").concat(this.currentType, "\"]"), this.$container);
    $thisType.addClass('selected');
  };

  Product.prototype.enableTypesSelector = function () {
    var $typesContainer = $(selectors.typesContainer, this.$container);
    var $shadesContainer = $(selectors.shadesWrapper, this.$container);
    var $shadeWrapper = $(selectors.shadesComponent + ':not(.parent-selector)', this.$container); //this.setQuickAddPanelHeight(selectors.typesContainer);

    $typesContainer.addClass('enabled');
    $shadeWrapper.addClass('disabled');
    $shadesContainer.addClass('disabled');
    $typesContainer.removeClass('disabled');
    this.$container.attr('data-step', 2);
    $('.shade-or-type__subtitle', this.$container).text(this.bundleProduct.step2SelectorTitle);
  };

  Product.prototype.enableTypesContinue = function () {
    var $typesContinue = $(selectors.typeContinue, this.$container);
    $typesContinue.attr('disabled', false);
    $typesContinue.on('click', this.enableTypesSelector.bind(this));
  };

  Product.prototype.returnToShadesSelector = function () {
    var $previous = $(selectors.previousBtn, this.container);
    var $shadesContainer = $(selectors.shadesWrapper, this.container);
    var $slickSlider = $('.shade-selector__slider', this.container);
    var context = this;

    if ($previous.length) {
      $previous.on('click', function (e) {
        e.preventDefault();
        context.$container.attr('data-step', 1);
        $shadesContainer.removeClass('disabled');
        $slickSlider.slick('refresh');
        $slickSlider.append('<div class="shade-title shade-title--slider"></div>');
        context.setShade(context.currentShade);
        context.enableTypesContinue(); //context.setQuickAddPanelHeight('.shade-selector');
      });
    }
  };

  Product.prototype.renderProductTitle = function (title) {
    var $productTitle = $(selectors.productTitle, this.$container);
    $productTitle.html(title);
  };

  Product.prototype.setVariantTitle = function (evt) {
    var variant = evt.variant;
    var $variantTitle = $(selectors.variantTitle, this.$container);
    $variantTitle.html(slate.utils.checkShadeTitle(variant.title.split("-").pop().trim()));
  };

  Product.prototype.setVariantBadge = function (evt) {
    var variant = null;

    if (evt.variant) {
      variant = evt.variant;
    } else {
      variant = slate.utils._get(this.bundleProduct.variants, "".concat(this.currentShade, "&&").concat(this.currentType));
    }

    if (variant) {} else {
      return;
    }

    var $badgeElem = $("".concat(selectors.variantBadge), this.$container);
    var badgeText = variant && variant.metafields && variant.metafields.sticker ? variant.metafields.sticker : '';
    console.log(variant);

    //Bing Product Event
    window.uetq = window.uetq || [];
    //Here variant is the product hence product.id = variant.id do console for more information 
    window.uetq.push('event', '', {'ecomm_prodid': variant.id , 'ecomm_pagetype': 'product'});

    if (badgeText) {
      $badgeElem.html(badgeText);
      $badgeElem.fadeIn();
    } else {
      $badgeElem.html('');
      $badgeElem.fadeOut();
    }
  };

  Product.prototype.refreshVariantBadge = function (evt) {
    var curVariant = evt.variant;
    var $badgeElem = $("".concat(selectors.plpBadge), this.$container);
    var badgeText = curVariant && curVariant.metafields && curVariant.metafields.sticker ? curVariant.metafields.sticker : false;

    if (badgeText) {
      $badgeElem.html(badgeText).removeClass('notsticker'); //$badgeElem.fadeIn(0);
    } else {
      $badgeElem.html('').addClass('notsticker'); // $badgeElem.fadeOut(0);
    }
  };

  Product.prototype.refreshOOSMessage = function (evt) {
    var variant = evt.variant;
    var $messageContainer = $(selectors.outOfStockMessage, this.container);

    if (variant && variant.metafields.out_of_stock) {
      $messageContainer.html("<span class=\"out-of-stock-message\">".concat(variant.metafields.out_of_stock, "</span>"));
    } else {
      $messageContainer.html('&nbsp;');
    }
  };

  Product.prototype.setPlpVariantTitle = function (evt) {
    var variant = evt.variant;
    var $variantInfo = $(selectors.plpVariantInfo, this.$container);
    $variantInfo.html(variant.title.split("-").pop().trim());
  };

  Product.prototype.refreshStarRatings = function (evt) {
    var variant = evt.variant;
    var totalPoints = '';
    var $starRatings = $(selectors.starRating, this.$container);
    $.ajax({
      url: "https://api.yotpo.com/products/".concat(theme.yotpo_key, "/").concat(variant.id, "/bottomline"),
      success: function success(result) {
        totalPoints = 'ratings-' + result.response.bottomline.average_score;
        $starRatings.removeClass(function (index, css) {
          return (css.match(/\bratings-\S+/g) || []).join(' '); // removes anything that starts with "page-"
        });
        $starRatings.addClass(totalPoints);
      }
    });
  };

  Product.prototype.refreshQuickAddImages = function (evt) {
    $('.shade-selector__slider').slick('unslick');
    var context = this;
    var variant = evt.variant;
    var html = '';
    var defaults = {
      infinite: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      lazyLoad: 'progressive'
    };
    variant.images.forEach(function (element) {
      html += "<img src=\"".concat(slate.Image.getSizedImageUrl(element, '200x200'), "\" data-lazy=\"").concat(element, "\" />");
    });
    $('.shade-selector__slider').html(html).slick(defaults);
    $('.shade-selector__slider').append('<div class="shade-title shade-title--slider"></div>');
    context.setShade(context.currentShade);
  };

  Product.prototype.setFavoriteButton = function (evt) {
    var variant = evt.variant;
    var $plpFavorite = $(selectors.plpFavoriteContainer, this.$container);
    var button = "<button \n  data-product-url=\"https://kjaerweis.com/products/" + variant.handle + "\"  data-with-epi=\"true\" \n    data-variant-id=\"".concat(variant.variants[0].id, "\"  \n    class=\"product_").concat(variant.id, "\" \n    data-swaction=\"addToWishlist\" \n    data-product-id=\"").concat(variant.id, "\"\n    aria-label=\"Move to Saved Items\">                  \n    <svg class=\"icon icon-bookmark-checked\"><use href=\"#icon-bookmark-checked\"></use></svg>\n    <svg class=\"icon icon-bookmark\"><use href=\"#icon-bookmark\"></use></svg>\n\n  </button>");
    $plpFavorite.find('button').remove();
    $plpFavorite.append(button);

    this._swatInitialize();
  };
  /**
   * _swatInitialize
   * @summary initializes wishlist buttons
  */


  Product.prototype._swatInitialize = function () {
    // If window._swat is already initialized
    if (window._swat) {
      selectors.swaInitializationTriggers.forEach(function (trigger) {
        // If the element exists, initialize button
        if ($(trigger).length) {
          window._swat.initializeActionButtons(trigger, '[data-swaction]');
        }
      }); // Add button initialization to callback array to run once window._swat is
      // initialized
    } else {
      window.SwymCallbacks = window.SwymCallbacks || [];
      selectors.swaInitializationTriggers.forEach(function (trigger) {
        if ($(trigger).length) {
          window.SwymCallbacks.push(function () {
            window._swat.initializeActionButtons(trigger, '[data-swaction]');
          });
        }
      });
    }
  };

  Product.prototype.setPlpVariantLink = function (evt) {
    var variant = evt.variant;
    var $variantLink = $(selectors.plpVariantLink, this.$container);
    $variantLink.attr('href', "/collections/" + this.currentCollectionHandle + "/products/".concat(variant.handle));
  };

  Product.prototype.setFromPrice = function (evt) {
    var variant = evt.variant;
    var $fromPrice = $(selectors.fromPrice, this.$container);
    var fromPriceUSD = slate.utils.getLowestPrice(this.bundleProduct.priceRanges['USA']).min;
    $fromPrice.html("from ".concat(slate.Currency.formatMoney(fromPriceUSD, theme.moneyFormat))); //Currency change helper
    // var ComparePrice = this.bundleProduct.variants[this.currentShade][this.currentType].compare_at_price;
    // var normalPrice = this.bundleProduct.variants[this.currentShade][this.currentType].price;

    $fromPrice.attr('data-price-usd', "from ".concat(slate.Currency.formatMoney(fromPriceUSD, theme.moneyFormat)));
  };

  Product.prototype.setPlpFromPrice = function (evt) {
    var variant = evt.variant;
    var $fromPrice = $(selectors.plpFromPrice, this.$container);
    var fromPriceUSD = slate.utils.getLowestPrice(this.bundleProduct.priceRanges['USA']).min;
    $fromPrice.html("from ".concat(slate.Currency.formatMoney(fromPriceUSD, theme.moneyFormat))); //Currency change helper

    $fromPrice.attr('data-price-usd', "from ".concat(slate.Currency.formatMoney(fromPriceUSD, theme.moneyFormat)));
  };

  Product.prototype.renderCertifications = function () {
    var $certifications = $(selectors.certifications, this.$container),
        productCerts = this.bundleProduct.certifications;

    if (productCerts && productCerts.length) {
      var html = productCerts.reduce(function (a, v, i) {
        a += "<div class=\"certification__item\">".concat(v, "</div>");

        if (i !== productCerts.length - 1) {
          a += "<div class=\"certification__divider\"></div>";
        }

        return a;
      }, "");
      $certifications.html("".concat(html));
    }
  };

  Product.prototype.renderDescription = function () {
    var $productDescription = $(selectors.productDescription, this.$container);

    if (this.bundleProduct.description) {
      $productDescription.html(this.bundleProduct.description);
    }
  }; // Need to add slider and mode code here 


  Product.prototype.renderIngredients = function () {
    var _this = this;

    var $ingredients = $(selectors.ingredients, this.$container);

    if (this.bundleProduct.topIngredients && this.bundleProduct.ingredients) {
      var html = this.bundleProduct.topIngredients.reduce(function (a, ingredient) {
        if (_this.bundleProduct.ingredients[ingredient]) {
          a += "<div>\n            <div></div>\n            <div class=\"ingredient-label\">".concat(_this.bundleProduct.ingredients[ingredient].fullname, "</div>\n          </div>");
        }

        return a;
      }, "");
      $ingredients.html(html);
    }
  };

  Product.prototype.renderProductImages = function () {
    var $productImages = $(selectors.productImages, this.$container);
    var html = this.buildProductImagesHtml();
    var context = this;

    if (html) {
      $productImages.html(html);
      context.initFeaturedProductsSlider();
    }
  };

  Product.prototype.renderShades = function () {
    var _this2 = this;

    var $shades = $(selectors.shades, this.$container);
    var shadeTotal = Object.keys(this.bundleProduct.variants).length - 4;
    var shadeCounter = 0;
    var currentShade = this.currentShade;

    if (this.bundleProduct.variants && !slate.utils.isObjEmpty(this.bundleProduct.variants)) {
      var shades = Object.keys(this.bundleProduct.variants).reduce(function (a, shade) {
        var variantData = _this2.bundleProduct.variants[shade][_this2.currentType].variants[0];
        var shadeHandle = shade ? _this2.handelize(shade) : _this2.handelize(_this2.bundleProduct.title);

        if (shadeCounter < 3) {
          a += "<div data-originalsku=\"".concat(variantData.sku, "\" class=\"shade").concat(shade == currentShade ? ' selected' : '', " visible first-four\" data-shade=\"").concat(shade, "\"><div class=\"shade-middle\"><div class=\"shade-inner\"><div class=\"shade-bg ").concat(_this2.handelize(_this2.bundleProduct.title), " ").concat(shadeHandle, "\" data-shade=\"").concat(shadeHandle, "\" /></div></div></div>");
        } else if (shadeCounter == 3) {
          a += "<div data-originalsku=\"".concat(variantData.sku, "\" class=\"shade").concat(shade == currentShade ? ' selected' : '', " visible first-four\" data-shade=\"").concat(shade, "\"><div class=\"shade-middle\"><div class=\"shade-inner\"><div class=\"shade-bg ").concat(_this2.handelize(_this2.bundleProduct.title), " ").concat(shadeHandle, "\" data-shade=\"").concat(shadeHandle, "\" /></div></div></div>").concat(shadeTotal > 0 && _this2.component == 'plp' ? "<span class=\"shade-counter\">+".concat(shadeTotal, "</span>") : "");
        } else {
          a += "<div data-originalsku=\"".concat(variantData.sku, "\" class=\"shade").concat(shade == currentShade ? ' selected' : '', "\" data-shade=\"").concat(shade, "\"><div class=\"shade-middle\"><div class=\"shade-inner\"><div class=\"shade-bg ").concat(_this2.handelize(_this2.bundleProduct.title), " ").concat(shadeHandle, "\" data-shade=\"").concat(shadeHandle, "\" /></div></div></div>");
        }

        shadeCounter++;
        return a;
      }, "");
      $shades.html(shades);

      if (shadeTotal > 0) {
        if (this.component !== "pdp") {//$shades.append(`<span class="shade-counter">+${shadeTotal}</span>`);
        }
      } // dynamically set the height of the shade container


      if (this.component === "pdp") {
        var $shadesContainer = $(selectors.shadesContainer, this.$container);
        this.setDynamicHeight($shadesContainer.clone(), $shadesContainer.outerWidth(), 'shadeHeightSelector');
      }
    }
  };

  Product.prototype.destroyShades = function () {
    var $shadesComponent = $(selectors.shadesComponent, this.$container);
    var $typesContainer = $(selectors.typesContainer, this.$container);
    $shadesComponent.hide().addClass('disabled'); //$typesContainer.css('width', '100%');

    this.enableTypesSelector();
  };

  Product.prototype.disableAddToCartButton = function () {
    var $ctaContainer = this.cachedElems.ctaContainer;
    $ctaContainer.addClass('disabled');
    $('.atc-container--mobile .pdp__quick-add-trigger').attr('disabled', true).addClass('disabled');
  };

  Product.prototype.removeContinueButton = function () {
    console.log('remove');
    $('.kit-item__nextStep').remove();
  };

  Product.prototype.destroyTypes = function () {
    var $shadesContainer = $(selectors.shadesContainer, this.$container);
    var $typesComponent = $(selectors.typesComponent, this.$container);
    $shadesContainer.addClass('enabled'); // $shadesContainer.css('width', '100%');

    $typesComponent.hide().addClass('disabled');
  };

  Product.prototype.renderProductTypes = function () {
    var _this3 = this;

    var $types = $(selectors.types, this.$container),
        html = "";
    $types.html(html);

    if (this.bundleProduct.variants && this.bundleProduct.variants[this.currentShade]) {
      html = Object.keys(this.bundleProduct.variants[this.currentShade]).reduce(function (a, type) {
        var product = _this3.bundleProduct.variants[_this3.currentShade][type];
        var numTypes = Object.keys(_this3.bundleProduct.variants[_this3.currentShade]).length;

        if (product && product.media) {
          var sizedImgUrl = slate.Image.getSizedImageUrl(product.media[0].src, _this3.settings.imageSize);
          var typeHandle = "".concat(_this3.handelize(type), "-").concat(_this3.handelize(_this3.bundleProduct.title));
          a += "<div style=\"width: calc(100% / ".concat(numTypes === 1 ? 2 : numTypes, "); ").concat(numTypes === 1 ? 'margin: 0 auto;' : '', "\" class=\"product-type ").concat(type === _this3.currentType ? 'selected' : '', "\" data-type=\"").concat(type, "\" data-pid=\"").concat(product.id, "\" data-vid=\"").concat(product.variants[0].id, "\"><div class=\"product-type-image\"><img src=\"").concat(sizedImgUrl, "\" alt=\"").concat(product.media[0].alt, "\" /></div><div class=\"product-info\"><div class=\"product-type-label\">").concat(type, "</div><div class=\"product-type-price\" data-price-element data-price-usd=\"").concat(slate.Currency.formatMoney(product.price, theme.moneyFormat), "\">").concat(slate.Currency.formatMoney(product.price, theme.moneyFormat), "</div></div></div>");
        } else {
          a += '';
        }

        return a;
      }, "");
    } else {
      var shade = Object.keys(this.bundleProduct.variants)[0];
      html = Object.keys(this.bundleProduct.variants[shade]).reduce(function (a, type) {
        var product = _this3.bundleProduct.variants[shade][type];
        var numTypes = Object.keys(_this3.bundleProduct.variants[shade]).length;

        if (product && product.media) {
          var sizedImgUrl = slate.Image.getSizedImageUrl(product.media[0].src, _this3.settings.imageSize);
          var typeHandle = "".concat(_this3.handelize(type), "-").concat(_this3.handelize(_this3.bundleProduct.title));
          a += "<div style=\"width: calc(100% / ".concat(numTypes, ");\" class=\"product-type\" data-type=\"").concat(type, "\" data-pid=\"").concat(product.id, "\" data-vid=\"").concat(product.variants[0].id, "\"><div class=\"product-type-image\"><img src=\"").concat(sizedImgUrl, "\" alt=\"").concat(product.media[0].alt, "\" /></div><div class=\"product-info\"><div class=\"product-type-label\">").concat(type, "</div><div class=\"product-type-price\" data-price-element data-price-usd=\"").concat(slate.Currency.formatMoney(product.price, theme.moneyFormat), "\">").concat(slate.Currency.formatMoney(product.price, theme.moneyFormat), "</div></div></div>");
        } else {
          a += '';
        }

        return a;
      }, "");
    }

    $types.html(html); // dynamically set the height of the shade container

    if (this.component === "pdp") {
      var $typesContainer = $(selectors.typesContainer, this.$container);
      this.setDynamicHeight($typesContainer.clone(), $typesContainer.outerWidth(), 'typesHeightSelector');
    }
  };

  Product.prototype.renderSingleVariantPanel = function () {
    var $panel = $(selectors.singleVariantPanel, this.$container),
        html = "",
        product = this.bundleProduct.variants[this.currentShade][this.currentType];
    var sizedImgUrl = slate.Image.getSizedImageUrl(this.bundleProduct.singleVariantOption.image, this.settings.imageSize);
    html += "<div class=\"product-single selected\" data-type=\"".concat(this.currentType, "\" data-pid=\"").concat(product.id, "\" data-vid=\"").concat(product.variants[0].id, "\">\n              <div class=\"product-single-image\">\n                <img src=\"").concat(sizedImgUrl, "\" alt=\"").concat(product.title, "\" />\n              </div>\n              <div class=\"product-info\">\n                <div class=\"product-single-label\">").concat(this.currentType, "</div>\n                <div class=\"product-single-price\" data-price-element data-price-usd=\"").concat(slate.Currency.formatMoney(product.price, theme.moneyFormat), "\">").concat(slate.Currency.formatMoney(product.price, theme.moneyFormat), "</div>\n              </div>\n            </div>");
    $panel.html(html);
    $panel.show();
  };

  Product.prototype.renderPlpProductTypes = function () {
    var _this4 = this;

    var $types = $(selectors.plpTypes, this.$container);

    if (this.bundleProduct.variants && this.bundleProduct.variants[this.currentShade]) {
      var html = Object.keys(this.bundleProduct.variants[this.currentShade]).reduce(function (a, type) {
        var product = _this4.bundleProduct.variants[_this4.currentShade][type];
        var typeHandle = "".concat(_this4.handelize(type), "-").concat(_this4.handelize(_this4.bundleProduct.title));
        a += "<div><div><label for=\"".concat(typeHandle, "\">").concat(type, "</label></div><div><input type=\"radio\" id=\"").concat(typeHandle, "\" name=\"product-type-").concat(_this4.handelize(_this4.bundleProduct.title), "\" class=\"product-type\" value=\"").concat(type, "\" ").concat(type === _this4.currentType ? 'checked' : '', " /></div></div>");
        return a;
      }, "");
      $types.html(html);
    }
  };

  Product.prototype.enableBisCta = function () {
    var $ctaContainer = this.cachedElems.ctaContainer;
    $ctaContainer.removeClass('enable--add-to-cart').removeClass('enable--continue').addClass('enable--bis');
  };

  Product.prototype.enableContinueCta = function () {
    var $ctaContainer = this.cachedElems.ctaContainer;
    $ctaContainer.removeClass('enable--add-to-cart').removeClass('enable--bis').addClass('enable--continue');
  };

  Product.prototype.enableAddToCartCta = function () {
    var $ctaContainer = this.cachedElems.ctaContainer;
    $ctaContainer.removeClass('enable--continue').removeClass('enable--bis').addClass('enable--add-to-cart');
  };
  /**
   * Updates the DOM state of the add to cart button
   *
   * @param {boolean} enabled - Decides whether cart is enabled or disabled
   * @param {string} text - Updates the text notification content of the cart
   */
  //Those are not the actual parameters!
  //will need this for the unselected prodcut option
  // probably have to manually trigger this with a fake object.


  Product.prototype.setAddToCartState = function (evt) {
    var variant = null;

    if (evt.variant) {
      variant = evt.variant;
    } else {
      variant = slate.utils._get(this.bundleProduct.variants, "".concat(this.currentShade, "&&").concat(this.currentType));
    } // Null option feature should addClass('disabled'), let that do the hide/show/gray out work.
    //  might  want to make that something that can be applied to the option area to hightlight it.


    if (variant) {//$(selectors.priceWrapper, this.$container).removeClass('hide');
    } else {
      $(selectors.addToCart, this.$container).prop('disabled', true).text(theme.strings.unavailable); //$(selectors.priceWrapper, this.$container).addClass('hide'); show range?

      return;
    } //NOTE: inventory logic:


    var location = sessionStorage.getItem('countrySelected');

    if (location) {
      var inventoryLocation = this.settings.inventoryByLocation[location];
      var product = this.inventoryBySku[variant.variants[0].sku];
      var inventory;
      if (product) inventory = product.find(function (l) {
        return l.location === inventoryLocation;
      });
      if (inventory) variant.available = inventory && inventory.available && inventory.available > 8 ? true : false;
    }

    var $shadeContainer = $('.shade-selector.open', this.$container).not('.disabled');
    console.log({
      state: this
    });

    if (variant.available) {
      var $cta = $(selectors.addToCart, this.$container);
      $cta.prop('disabled', false).text(theme.strings.addToCart);

      if (this.component === 'pdp') {
        if ($shadeContainer.length && this.numShades > 1) {
          if (this.numTypes <= 1) {
            this.enableAddToCartCta();
          } else {
            this.enableAddToCartCta();
            this.disableAddToCartButton();
          }
        } else {
          this.enableAddToCartCta();
        }
      } else if (this.component === 'quickAdd' && this.quickAddConfig.enableBis) {
        this.enableAddToCartCta();
      }
    } else {
      if (this.component === 'pdp') {
        if ($shadeContainer.length) {
          if (this.numTypes <= 1) {
            this.enableBisCta();
          } else {
            this.enableBisCta();
            this.disableAddToCartButton();
          }
        } else {
          this.enableBisCta();
        }
      } else if (this.component === 'quickAdd' && this.quickAddConfig.enableBis && theme.bisModal) {
        this.enableBisCta();
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true).text(theme.strings.soldOut);
      }
    }
  };

  Product.prototype.initAccordionStates = function () {
    var $shadeAccord = $('.accordion-panel.shade-selector', this.$container);
    var $typeAccord = $('.accordion-panel.type-selector', this.$container);

    if (this.numShades <= 1) {
      $shadeAccord.hide();
      $shadeAccord.removeClass('open is--active');
      $typeAccord.addClass('open is--active');
    } else {
      $shadeAccord.addClass('open is--active');
      $typeAccord.removeClass('open is--active');
    }
  };

  Product.prototype.updateAccordionStates = function (e) {
    var $this = $(e.target);
    var $panel = $this.closest('.accordion-panel');
    var $typesSelector = $('.accordion-panel.type-selector', this.$container);
    var $shadeSelector = $('.accordion-panel.shade-selector', this.$container);
    var $updateElem;

    if ($panel.hasClass('open')) {
      $panel.removeClass('open is--active');
    } else {
      $panel.addClass('open is--active');
    } // Update CTA


    if ($panel.hasClass('open')) {
      if ($panel.hasClass('shade-selector')) {
        $typesSelector.removeClass('open is--active');
        $updateElem = $shadeSelector;
      } else {
        $shadeSelector.removeClass('open is--active');
        $updateElem = $typesSelector;
      }
    } else {
      if ($panel.hasClass('shade-selector')) {
        $shadeSelector.removeClass('open is--active');
        $updateElem = $typesSelector;
      } else {
        $typesSelector.removeClass('open is--active');
        $updateElem = $shadeSelector;
      }
    }

    var variants = {
      variant: this.variants.currentVariant
    };
    var context = this;
    var timeout = setTimeout(function () {
      $updateElem.addClass('open is--active');
      context.setAddToCartState(variants);
      clearTimeout(timeout);
    }, 860);
  };

  Product.prototype.continueCtaHandler = function (e) {
    var $typesSelector = $('.accordion-panel.type-selector', this.$container);
    var $shadeSelector = $('.accordion-panel.shade-selector', this.$container);
    $shadeSelector.removeClass('open is--active');
    var variants = {
      variant: this.variants.currentVariant
    };
    var context = this;
    var timeout = setTimeout(function () {
      $typesSelector.addClass('open is--active');
      context.setAddToCartState(variants);
      clearTimeout(timeout);
    }, 860);
  };
  /**
   * Updates the DOM with specified prices
   *
   * @param {string} productPrice - The current price of the product
   * @param {string} comparePrice - The original price of the product
   */


  Product.prototype.setProductPrices = function (evt) {
    //un-used
    var variant = evt.variant;
    var $comparePrice = $(selectors.comparePrice, this.$container);
    var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);
    $(selectors.productPrice, this.$container).html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

    if (variant.compare_at_price > variant.price) {
      $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
      $compareEls.removeClass('hide');
    } else {
      $comparePrice.html('');
      $compareEls.addClass('hide');
    }
  };
  /**
   * Updates the DOM with the specified image URL
   *
   * @param {string} src - Image src URL
   */


  Product.prototype.setProductImages = function (evt) {
    var variant = evt.variant;

    if (this.bundleProduct.variants && !slate.utils.isObjEmpty(this.bundleProduct.variants)) {
      var $productCarousel = $(selectors.productImages, this.$container);

      if ($productCarousel.hasClass('slick-initialized')) {
        $productCarousel.slick('unslick');
        this.updateProductImages(variant);
        this.initFeaturedProductsSlider();
        $productCarousel.slick('resize');
      } else {
        this.updateProductImages(variant);
      }
    }
  };

  Product.prototype.updateProductImages = function (variant) {
    var _this5 = this;

    var $productImages = $("".concat(selectors.productImages, "  img"), this.$container);
    $productImages.each(function (i, v) {
      if (variant.media[i]) {
        var sizedImgUrl = slate.Image.getSizedImageUrl(variant.media[i].src, _this5.settings.imageSize);
        $(v).attr('src', sizedImgUrl);
        $(v).attr('alt', variant.media[i].alt);
      } else {
        // get rid of any additional images beyond the number of images available for the current product
        $(v).remove();
      }
    }); // add any images available for the product beyond the number of images currently showing

    if (variant.media && variant.media.length && $productImages.length < variant.media.length) {
      for (var _i = $productImages.length; _i < variant.media.length; _i++) {
        var media = variant.media[_i];
        var sizedImgUrl = slate.Image.getSizedImageUrl(media.src, this.settings.imageSize);
        var loadImg = slate.Image.getSizedImageUrl(media.src, this.settings.imageSize);
        var mediaAlt = media.alt || "";
        var html = '<img class="featured-images lazyload" src="' + loadImg + '" data-type="' + this.currentType + '" data-src="' + sizedImgUrl + '" alt="' + mediaAlt + '" />';
        $(selectors.slickSlideContainer, this.$container).append(html);
      }
    } // if the number of images has changed, scroll to top of document to avoid problems w viewport scrolling up/down


    var $productImagesNew = $("".concat(selectors.productImages, " img"), this.$container);
    $(window).scrollTop(0);
  };

  Product.prototype.setPlpItemImage = function (evt) {
    var variant = evt.variant;
    var $plpImgContainer = $(selectors.plpItemImage, this.$container);

    if (this.bundleProduct.variants && !slate.utils.isObjEmpty(this.bundleProduct.variants)) {
      var product = this.bundleProduct.variants[this.currentShade][this.currentType];

      if (product && product.media) {
        var sizedImgUrl = slate.Image.getSizedImageUrl(product.media[0].src, this.settings.imageSize);
        $plpImgContainer.attr('src', sizedImgUrl);
        $plpImgContainer.attr('alt', product.media[0].alt);
      }
    }
  };

  Product.prototype.setKitVariantId = function (evt) {
    var variantID = evt.variant.variants[0].id;
    var $kitItem = $(selectors.kitItem, this.$container);
    $kitItem.attr('data-variant', variantID);
  };

  Product.prototype.setProductTypes = function (evt) {
    var _this6 = this;

    var variant = evt.variant;
    var $productVariantTypes = $("".concat(selectors.typeSelector, ":visible"), this.$container);
    var productVariants = Object.keys(this.bundleProduct.variants[this.currentShade]); // check that all the necessary types are rendered first, and then show/hide accordingly:

    if ($productVariantTypes.length >= productVariants.length) {
      $productVariantTypes.each(function (i, type) {
        var $type = $(type);

        if (productVariants.indexOf($type.data('type')) === -1) {
          $type.hide();
        } else {
          $type.show();
        }
      });
    } else {
      // else re-render the types selector:
      this.renderProductTypes();
    }

    if (this.bundleProduct.variants && this.bundleProduct.variants[this.currentShade]) {
      Object.keys(this.bundleProduct.variants[this.currentShade]).forEach(function (type) {
        var $productTypes = $("".concat(selectors.typeSelector, "[data-type=\"").concat(type, "\"]"), _this6.$container);
        var product = _this6.bundleProduct.variants[_this6.currentShade][type];
        var typeHandle = "".concat(_this6.handelize(type), "-").concat(_this6.handelize(_this6.bundleProduct.title));

        if (product && product.media) {
          var sizedImgUrl = slate.Image.getSizedImageUrl(product.media[0].src, _this6.settings.imageSize);
          $productTypes.attr('data-pid', product.id).attr('data-vid', product.variants[0].id);
          $productTypes.find(".product-type-image img").attr('src', sizedImgUrl).attr('alt', product.media[0].alt);
          $productTypes.find(".product-info .product-type-label").html(type);
          $productTypes.find(".product-info .product-type-price").html(slate.Currency.formatMoney(product.price, theme.moneyFormat));
          $productTypes.find(".product-info .product-type-price").attr({
            "data-price-element": "",
            "data-price-usd": slate.Currency.formatMoney(product.price, theme.moneyFormat)
          });
        }
      });
    }
  };

  Product.prototype.buildProductImagesHtml = function () {
    var _this7 = this;

    var html = "";

    if (this.bundleProduct.variants && !slate.utils.isObjEmpty(this.bundleProduct.variants)) {
      var product = this.bundleProduct.variants[this.currentShade][this.currentType];

      if (product && product.media) {
        html = product.media.reduce(function (a, media) {
          var sizedImgUrl = slate.Image.getSizedImageUrl(media.src, _this7.settings.imageSize);
          var loadImg = slate.Image.getSizedImageUrl(media.src, _this7.settings.imageSize);
          a += "<img class=\"featured-images lazyload\" src=".concat(loadImg, " data-type=\"").concat(_this7.currentType, "\" data-src=\"").concat(sizedImgUrl, "\" alt=\"").concat(media.alt ? media.alt : '', "\" />");
          return a;
        }, html);
      }
    }

    return html;
  };

  Product.prototype.renderSkinToneSelector = function () {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var product = slate.utils._get(this.bundleProduct.variants, "".concat(this.currentShade, "&&").concat(this.currentType));

    return "<div class=\"quickAdd-container ".concat(opts.componentClass, "\" data-quick-product=\"").concat(this.bundleProduct.title, "\">\n      <form class=\"quickAdd__form\" action=\"/cart/add\" method=\"post\" enctype=\"multipart/form-data\">\n        <select name=\"id\" class=\"no-js product-select\">\n          ").concat(this.products.reduce(function (a, product) {
      a += "<option ".concat(!product.available ? 'disabled="disabled"' : '', " value=\"").concat(product.variants[0].id, "\">").concat(product.title, "</option>");
      return a;
    }, ""), "\n        </select>\n        <div class=\"shade-selector\">\n          <div class=\"shade-selector__container\">\n          <div class=\"shade-selector__header\">\n            <div class=\"shade-selector__title h5\">").concat(this.bundleProduct.title, "</div>\n            <div class=\"shade-selector__subtitle label milano\">").concat(this.productBundle.step1SelectorTitle, "</div>                      \n          </div>\n          <div class=\"shade-selector__images medium-down--show medium-up--hide\">\n            <div class=\"shade-selector__slider\">\n              ").concat(this.buildProductImagesHtml(), "\n            </div>\n          </div>\n          <div class=\"shade-selector__wrapper\">\n            <div class=\"flex shade-selector__field skin-tone\" style=\"").concat(!this.bundleProduct.shadeFinder ? 'display:none' : '', "\">\n              <label class=\"shade-selector__label\" for=\"skin-tone\">Skin Tone:</label>\n              <div class=\"label__container\">\n                <span class=\"shade-selector__single--skin-tone selected\" data-skintone=\"All\">All</span>\n                <span class=\"shade-selector__single--skin-tone\" data-skintone=\"Deep\">Deep</span>\n                <span class=\"shade-selector__single--skin-tone\" data-skintone=\"Medium Dark\">Medium Dark</span>\n                <span class=\"shade-selector__single--skin-tone\" data-skintone=\"Medium\">Medium</span>\n                <span class=\"shade-selector__single--skin-tone\" data-skintone=\"Light\">Light</span>\n                <span class=\"shade-selector__single--skin-tone\" data-skintone=\"Fair\">Fair</span>\n              </div>\n            </div>\n            <div class=\"flex shade-selector__field undertone\" style=\"").concat(!this.bundleProduct.shadeFinder ? 'display:none' : '', "\">\n              <label class=\"shade-selector__label\" for=\"undertone\">Undertone:</label>\n              <span class=\"shade-selector__single--undertone selected\" data-undertone=\"All\">All</span>\n              <span class=\"shade-selector__single--undertone\" data-undertone=\"Cool\">Cool</span>\n              <span class=\"shade-selector__single--undertone\" data-undertone=\"Neutral\">Neutral</span>\n              <span class=\"shade-selector__single--undertone\" data-undertone=\"Warm\">Warm</span>\n            </div>\n            <div class=\"shades flex\"></div>\n            <div class=\"shade-info-container flex\"><div data-variant-title id=\"variant-title\" class=\"shade-title\">").concat(this.currentShade, "</div><div>\n            <div class=\"shade-selector__link \" style=\"").concat(!this.bundleProduct.shadeFinder ? 'display:none' : '', "\" ><a href=\"/pages/shadefinder\" target=\"_blank\" class=\"link--underlined\">Find my shade</a></div></div></div>\n            <div class=\"continue-container center\">\n              <button type=\"button\" name=\"continue\" class=\"continue cta btn\" ").concat(!this.currentShade ? 'disabled="disabled"' : '', "><span class=\"medium-up--show medium-down--hide\">Continue</span><span class=\"medium-down--show medium-up--hide\">Next</span></button>\n            </div>\n          </div>\n          </div>\n        </div>\n        <div class=\"types-selector disabled\">\n          <div class=\"types-selector__wrapper\">\n\n          <div class=\"types-selector__header\">\n            <div class=\"shade-selector__title h5\">").concat(this.bundleProduct.title, " - ").concat(this.currentShade, "</div>\n            <div class=\"shade-selector__subtitle label milano\">").concat(this.bundleProduct.step2SelectorTitle, "</div>                      \n          </div>                    \n          <div class=\"types-selector__subtitle milano\">").concat(this.bundleProduct.step2SelectorTitle, "</div>\n          <div class=\"types-selector__swatches types flex\"></div>\n          <div class=\"oos-message center\"></div>\n          <div class=\"types-selector__tooltip center\"><a href=\"#\" class=\"link--underlined\">More Information</a></div>\n          <div class=\"flex flex-center atc-container\">\n            <div class=\"quantity\">\n              <label for=\"Quantity\">Quantity</label>\n              <input type=\"number\" id=\"Quantity\" name=\"quantity\" value=\"1\" min=\"1\">\n            </div>\n            <button type=\"submit\" name=\"add\" class=\"add-to-cart cta btn\" ").concat(!product.available ? 'disabled="disabled"' : '', ">\n              ").concat(product.available ? 'Add to Cart' : 'Sold Out', "\n            </button>\n          </div>                      \n          \n          </div>\n        </div>\n      </form>\n    </div>");
  };

  Product.prototype.skinToneHandlers = function () {
    // Skin Tone Seection Ui
    $('body').on('click', '.shade-selector__single--skin-tone', function () {
      var type = $(this).attr('data-type');
      $(this).closest('.skin-tone').find('select').val(type);
      $(this).addClass('selected').siblings().removeClass('selected');
    }); // Undetone Selection UI 

    $('body').on('click', '.shade-selector__single--undertone', function () {
      var type = $(this).attr('data-type');
      $(this).closest('.undertone').find('select').val(type);
      $(this).addClass('selected').siblings().removeClass('selected');
    });
  };

  Product.prototype.setPlpProductTypes = function (evt) {
    var variant = evt.variant;

    if (this.bundleProduct.variants && this.bundleProduct.variants[this.currentShade]) {
      var product = this.bundleProduct.variants[this.currentShade][this.currentType];
      var typeHandle = "".concat(this.handelize(this.currentType), "-").concat(this.handelize(this.bundleProduct.title));
      var $thisType = $("".concat(this.plpTypesInputSelector, "#").concat(typeHandle), this.$container);
      $thisType.prop('checked', true);
    }
  };
  /**
   * Event callback for Theme Editor `section:unload` event
   */


  Product.prototype.onUnload = function () {
    //un-used foc actual product?
    this.$container.off(this.namespace);
  };
  /*
  * Render Shade Finder with Select List
  */


  Product.prototype.shadeFinderSelectList = function () {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return "<div class=\"shades-container ".concat(config.shadeFinderSelectClass || '', "\">\n    <div class=\"flex shades-select-container\">\n      <div class=\"shade-selector--select-list\">\n        <div class=\"flex skin-tone-container\">\n          <label class=\"shade-selector__label shade-selector__label--select-list\" for=\"skin-tone\">Skin Tone</label>\n          <div class=\"flex field shade-selector__list-container\">\n            <select id=\"skin-tone\" class=\"shade-select__list\">\n              <option>All</option>\n              <option>Deep</option>\n              <option>Medium Dark</option>\n              <option>Medium</option>\n              <option>Light</option>\n              <option>Fair</option>\n            </select>\n          </div>\n          <!-- <div class=\"link\">&nbsp;</div> -->\n        </div>\n        <div class=\"flex undertone-container\">\n          <label class=\"shade-selector__label shade-selector__label--select-list\" for=\"undertone\">Undertone</label>\n          <div class=\"flex field shade-selector__list-container\">\n            <select id=\"undertone\" class=\"shade-select__list\">\n              <option>All</option>\n              <option>Cool</option>\n              <option>Neutral</option>\n              <option>Warm</option>\n            </select>\n          </div>\n        </div>\n      </div>\n      <div><a href=\"/pages/shadefinder\" target=\"_blank\" class=\"link--underlined\">Find my shade</a></div>\n    </div>\n  </div>");
  };
  /**
   * Render back arrow in quick add modal
  */


  Product.prototype.renderPreviousArrow = function () {
    return "<div class=\"previous\">\n    <svg version=\"1.1\" class=\"previous__arrow\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n        viewBox=\"0 0 52.9 100.1\" style=\"enable-background:new 0 0 52.9 100.1;\" xml:space=\"preserve\">\n      <title>Previous</title>\n      <path d=\"M0.9,99.2c0.5,0.5,1.2,0.8,2,0.8c0.8,0,1.5-0.3,2-0.8l47.2-47.2c1.1-1.1,1.1-2.9,0-4c0,0,0,0,0,0L4.9,0.9\n        C3.8-0.2,2-0.3,0.9,0.8s-1.2,2.9-0.1,4c0,0,0.1,0.1,0.1,0.1l45.2,45.2L0.9,95.2C-0.2,96.3-0.2,98.1,0.9,99.2\n        C0.9,99.2,0.9,99.2,0.9,99.2z\"/>\n    </svg>\n  </div>";
  };

  Product.prototype.buildQuickAddCta = function (product, notifyCtaText, config, name) {
    var enableBis = config.enableBis ? config.enableBis : false;
    var buttonName = name || 'add';
    var html = "<button data-action=\"quickAddSubmit\" type=\"button\" name=\"".concat(buttonName, "\" class=\"add-to-cart cta btn\" ").concat(enableBis && theme.bisModal && !product.available ? 'style="display:none;"' : '', ">\n    ").concat(product.available ? 'Add to Cart' : 'Sold Out', "\n    </button>");

    if (enableBis && theme.bisModal) {
      html += "<button\n      type=\"button\"\n      data-bis-trigger\n      data-product-id=\"".concat(product.id, "\"\n      data-variant-id=\"").concat(product.variants[0].id, "\"\n      data-product-title=\"").concat(product.title, "\"\n      class=\"bis-trigger btn cta\" ").concat(product.available ? 'style="display:none;"' : '', ">\n      ").concat(notifyCtaText, "</button>\n    ");
    }

    return html;
  };

  Product.prototype.buildQtyInputHolder = function () {
    return "<div class=\"quantity\">\n    <label>Quantity</label>\n    <input class=\"qty-input\" type=\"number\" name=\"quantity-holder\" value=\"1\" min=\"1\" aria-label=\"".concat(this.bundleProduct.title, " quantity\">\n    </div>");
  };

  Product.prototype.quickAddHandlers = function ($html, config) {
    var context = this;

    if (this.bundleUpsells && this.bundleUpsells.length && !config.cartSucessCb && config.triggerUpsell) {
      config.cartSucessCb = this.listUpsells.bind(this);
    }

    $('[data-action="quickAddSubmit"]', $html).on('click', function (e) {
      e.preventDefault();
      var $form = $(this).closest('form');
      var $allHolders = $('[name="quantity-holder"]', $form);
      $allHolders.prop('disabled', true);

      if (config.beforeSubmit && typeof config.beforeSubmit === 'function') {
        config.beforeSubmit();
      }

      theme.rsCartListener.apply($form[0], [e, config.cartSucessCb, 'pdp']);
      context.initFeaturedProductsSlider();
    });
    $('.for--mobile--important [data-bis-trigger]', $html).on('click', function (e) {
      e.preventDefault();
      theme.bisModal.triggerAction($(this));
    });
  };

  Product.prototype.setQuickAddPanelHeight = function (selector) {
    var $modal = $('#FgModal.quickAdd_popup');
    var $panel = $modal.find(selector);
    var panelHeight = $panel.outerHeight(true);

    if ($modal.length) {
      if (panelHeight && panelHeight < $(window).height() && $(window).width() < 1025) {// $modal.css('height', panelHeight);
      } else if ($(window).width() < 1025) {// $modal.css('height', $(window).height());
      }
    }
  };
  /**
   * Quick Add modal
   */


  Product.prototype.quickAdd = function (e) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var formClass = arguments.length > 2 ? arguments[2] : undefined;
    e.preventDefault();
    if ($('#FgModal .quickAdd-container').length) return;
    var productImages = this.buildProductImagesHtml();

    var product = slate.utils._get(this.bundleProduct.variants, "".concat(this.currentShade, "&&").concat(this.currentType));

    var dataStep = this.numTypes > 1 ? 1 : 2;
    var notifyCtaText = theme.strings.notify_mobile || "Notify me when available";
    var enableHistoryState = config.enableHistoryState || false;
    var typeSelectorClass = 'types-selector';
    var shadeSelectorClass = 'shade-selector';
    var mobileShadeSelectorClass = 'shade-selector parent-selector';
    var mobileShadeSelectorClass2 = 'shade-selector__wrapper';
    var mobileTypeSelectorClass = 'types-selector';
    var containerClass = '';
    var titleClass = '';
    var subTitle = this.bundleProduct.step1SelectorTitle;

    if (this.numTypes > 1 && this.numShades <= 1) {
      typeSelectorClass = 'types-selector types-selector-enabled';
      shadeSelectorClass = 'shade-selector shade-selector-disabled';
      mobileShadeSelectorClass2 += ' disabled';
      mobileTypeSelectorClass += ' enabled';
      subTitle = this.bundleProduct.step2SelectorTitle;
    } else if (this.numTypes > 1 && this.numShades > 1) {
      typeSelectorClass = 'types-selector types-selector-enabled';
      shadeSelectorClass = 'shade-selector shade-selector-enabled';
      mobileShadeSelectorClass2 += ' disabled';
      mobileTypeSelectorClass += ' enabled'; // containerClass = 'hide-shade-on-mobile';
    } else if (this.numTypes <= 1 && this.numShades > 1) {
      typeSelectorClass = 'types-selector types-selector-disabled';
      shadeSelectorClass = 'shade-selector shade-selector-enabled';
      mobileShadeSelectorClass2 += ' enabled';
      mobileTypeSelectorClass += ' disabled';
    } else if (this.numTypes <= 1 && this.numShades <= 1) {
      typeSelectorClass = 'types-selector types-selector-enabled';
      shadeSelectorClass = 'shade-selector shade-selector-disabled';
      mobileShadeSelectorClass2 += ' disabled';
      mobileTypeSelectorClass += ' disabled always-disabled';
      titleClass = 'types-selector__header--show';
      subTitle = '';
    }

    var html = "<div class=\"quickAdd-container ".concat(config.componentClass || '', "\" data-quick-product=\"").concat(this.bundleProduct.title, "\" ").concat(enableHistoryState ? 'data-enable-history-state="true"' : '', ">\n    <form class=\"quickAdd__form ").concat(containerClass, " ").concat(formClass ? formClass : '', "\" action=\"/cart/add\" method=\"post\" enctype=\"multipart/form-data\">\n                        <label class=\"visually-hidden\">\n                      <input class=\"qty-input\" type=\"hidden\" name=\"quantity\" value=\"1\" min=\"1\">\n                    </label>  \n                  \n                    <select name=\"id\" class=\"no-js product-select\">\n                      ").concat(this.products.reduce(function (a, product) {
      a += "<option ".concat(!product.available ? 'disabled="disabled"' : '', " value=\"").concat(product.variants[0].id, "\">").concat(product.title, "</option>");
      return a;
    }, ""), "\n                    </select>\n\n                    <div class=\"").concat(mobileShadeSelectorClass, " for--mobile--important\">\n                      <div class=\"shade-selector__container\">\n                        <div class=\"shade-selector__header\">\n                          <div class=\"shade-selector__title shade-or-type__title h5\">").concat(this.bundleProduct.title, "</div>\n                          <div class=\"shade-selector__subtitle shade-or-type__subtitle label milano\">").concat(subTitle, "</div>                    \n                          <div class=\"modal__close--mobile \">\n                          <svg  class=\"close_icon\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 99.12 99.12\"><title>Close</title><line class=\"close__line close__line_1\" x1=\"1.06\" y1=\"1.06\" x2=\"98.06\" y2=\"98.06\" style=\"fill:none;stroke-miterlimit:10;stroke-width:6px\"></line><line class=\"close__line close__line_2\" x1=\"1.06\" y1=\"98.06\" x2=\"98.06\" y2=\"1.06\" style=\"fill:none;stroke-miterlimit:10;stroke-width:6px\"></line></svg>\n                          </div>\n                        </div>\n                        <div class=\"shade-selector__images medium-down--show medium-up--hide\">\n                          <div class=\"shade-selector__imageWrapper\">\n                          <div class=\"shade-selector__slider\">\n                            ").concat(productImages, "\n                          </div>\n                          <div class=\"shade-title shade-title--slider\">").concat(this.currentShade, "</div>\n                          </div>\n                        </div>\n                        <div class=\"").concat(mobileShadeSelectorClass2, "\">\n                          ").concat(this.bundleProduct.shadeFinder ? this.shadeFinderSelectList() : '', "\n                          <div class=\"flex shade-selector__field skin-tone\" style=\"").concat(!this.bundleProduct.shadeFinder ? 'display:none' : '', "\">\n                          <label class=\"shade-selector__label\" for=\"skin-tone\">Skin Tone:</label>\n                            <div class=\"label__container\">\n                              <span class=\"shade-selector__single--skin-tone selected\" data-skintone=\"All\">All</span>\n                              <span class=\"shade-selector__single--skin-tone\" data-skintone=\"Deep\">Deep</span>\n                              <span class=\"shade-selector__single--skin-tone\" data-skintone=\"Medium Dark\">Medium Dark</span>\n                              <span class=\"shade-selector__single--skin-tone\" data-skintone=\"Medium\">Medium</span>\n                              <span class=\"shade-selector__single--skin-tone\" data-skintone=\"Light\">Light</span>\n                            <span class=\"shade-selector__single--skin-tone\" data-skintone=\"Fair\">Fair</span>\n                            </div>\n                          </div>\n                          <div class=\"flex shade-selector__field undertone\" style=\"").concat(!this.bundleProduct.shadeFinder ? 'display:none' : '', "\">\n                            <label class=\"shade-selector__label\" for=\"undertone\">Undertone:</label>\n                            <span class=\"shade-selector__single--undertone selected\" data-undertone=\"All\">All</span>\n                            <span class=\"shade-selector__single--undertone\" data-undertone=\"Cool\">Cool</span>\n                            <span class=\"shade-selector__single--undertone\" data-undertone=\"Neutral\">Neutral</span>\n                            <span class=\"shade-selector__single--undertone\" data-undertone=\"Warm\">Warm</span>\n                          </div>\n                          <div class=\"shades flex\"></div>\n                          <div class=\"shade-info-container flex\"><div data-variant-title id=\"variant-title\" class=\"shade-title\">").concat(this.currentShade, "</div><div>\n                          <div class=\"shade-selector__link \" style=\"").concat(!this.bundleProduct.shadeFinder ? 'display:none' : '', "\" ><a href=\"#\" class=\"shadefinder-modal-opener link--underlined\">Find my shade</a></div></div></div>\n                          \n                          ").concat(dataStep !== 2 ? "<div class=\"continue-container center\">\n                                <button type=\"button\" name=\"continue\" class=\"continue cta btn\" ".concat(!this.currentShade ? 'disabled="disabled"' : '', "><span class=\"medium-up--show medium-down--hide\">Continue</span><span class=\"medium-down--show medium-up--hide\">Next</span></button>\n                              </div>") : "<div class=\"oos-message center\"></div><div class=\"flex flex-center atc-container\">\n                                ".concat(this.buildQtyInputHolder(), "\n                                ").concat(this.buildQuickAddCta(product, notifyCtaText, config, 'add_mobile1'), "\n                              </div>"), "\n                        </div>\n\n                        <div class=\"").concat(mobileTypeSelectorClass, "\" >\n                          <div class=\"types-selector__wrapper\">\n                            <div class=\"types-selector__swatches types flex\"></div>\n                            <div class=\"oos-message center\"></div>\n                            <div class=\"types-selector__tooltip center\">\n                              <span class=\"tooltip link--underlined\" data-tooltip-content=\"#tooltip_content_qickAdd\">More Information</span>\n                            </div>\n                            <div class=\"tooltip_templates\">\n                              <span id=\"tooltip_content_qickAdd\">\n                                  <p>\n                                  Our REFILL is available if you already own a case, and just need to refill the shade. \n                                  </p>\n                                  <p>\n                                  Our lightweight RED EDITION case is 100% recyclable. <br>Comes with refill & can be refilled 2-3 times.</p> \n                                  <p>Our ICONIC EDITION case is a metal case built for a lifetime. Comes filled with shade & can be refilled any time.\n                                  </p>\n                              </span>\n                            </div>\n\n                            <div class=\"flex flex-center atc-container\">\n                              ").concat(this.buildQtyInputHolder(), "\n                               ").concat(this.buildQuickAddCta(product, notifyCtaText, config, 'add_mobile2'), "\n                            </div>                      \n\n\n                          </div>\n                        </div>\n                        ").concat(this.numTypes <= 1 && this.numShades <= 1 ? "<div class=\"flex flex-center atc-container\">\n                              ".concat(this.buildQtyInputHolder(), "\n                              ").concat(this.buildQuickAddCta(product, notifyCtaText, config, 'add_mobile3'), "\n                            </div>") : '', "\n                      </div>\n                    </div>                    \n\n                    <div class=\"").concat(shadeSelectorClass, " for--desktop--important\">\n                      <div class=\"shade-selector__container\">\n                        <div class=\"shade-selector__header\">\n                          <div class=\"shade-selector__title h5\">").concat(this.bundleProduct.title, "</div>\n                          <div class=\"shade-selector__subtitle label milano\">").concat(this.bundleProduct.step1SelectorTitle, "</div>                    \n                          <div class=\"modal__close--mobile \">\n                          <svg  class=\"close_icon\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 99.12 99.12\"><title>Close</title><line class=\"close__line close__line_1\" x1=\"1.06\" y1=\"1.06\" x2=\"98.06\" y2=\"98.06\" style=\"fill:none;stroke-miterlimit:10;stroke-width:6px\"></line><line class=\"close__line close__line_2\" x1=\"1.06\" y1=\"98.06\" x2=\"98.06\" y2=\"1.06\" style=\"fill:none;stroke-miterlimit:10;stroke-width:6px\"></line></svg>\n                          </div>\n                        </div>\n                        <div class=\"shade-selector__images medium-down--show medium-up--hide\">\n                          <div class=\"shade-selector__imageWrapper\">\n                          <div class=\"shade-selector__slider\">\n                            ").concat(productImages, "\n                          </div>\n                          <div class=\"shade-title shade-title--slider\">").concat(this.currentShade, "</div>\n                          </div>\n                        </div>\n                        <div class=\"shade-selector__wrapper\">\n                          ").concat(this.bundleProduct.shadeFinder ? this.shadeFinderSelectList() : '', "\n                          <div class=\"flex shade-selector__field skin-tone\" style=\"").concat(!this.bundleProduct.shadeFinder ? 'display:none' : '', "\">\n                          <label class=\"shade-selector__label\" for=\"skin-tone\">Skin Tone:</label>\n                            <div class=\"label__container\">\n                              <span class=\"shade-selector__single--skin-tone selected\" data-skintone=\"All\">All</span>\n                              <span class=\"shade-selector__single--skin-tone\" data-skintone=\"Deep\">Deep</span>\n                              <span class=\"shade-selector__single--skin-tone\" data-skintone=\"Medium Dark\">Medium Dark</span>\n                              <span class=\"shade-selector__single--skin-tone\" data-skintone=\"Medium\">Medium</span>\n                              <span class=\"shade-selector__single--skin-tone\" data-skintone=\"Light\">Light</span>\n                            <span class=\"shade-selector__single--skin-tone\" data-skintone=\"Fair\">Fair</span>\n                            </div>\n                          </div>\n                          <div class=\"flex shade-selector__field undertone\" style=\"").concat(!this.bundleProduct.shadeFinder ? 'display:none' : '', "\">\n                            <label class=\"shade-selector__label\" for=\"undertone\">Undertone:</label>\n                            <span class=\"shade-selector__single--undertone selected\" data-undertone=\"All\">All</span>\n                            <span class=\"shade-selector__single--undertone\" data-undertone=\"Cool\">Cool</span>\n                            <span class=\"shade-selector__single--undertone\" data-undertone=\"Neutral\">Neutral</span>\n                            <span class=\"shade-selector__single--undertone\" data-undertone=\"Warm\">Warm</span>\n                          </div>\n                          <div class=\"shades flex\"></div>\n                          <div class=\"shade-info-container flex\"><div data-variant-title id=\"variant-title\" class=\"shade-title\">").concat(this.currentShade, "</div><div>\n                          <div class=\"shade-selector__link \" style=\"").concat(!this.bundleProduct.shadeFinder ? 'display:none' : '', "\" ><a href=\"/pages/shadefinder\" target=\"_blank\" class=\"link--underlined\">Find my shade</a></div></div></div>\n                          \n                          ").concat(dataStep !== 2 ? "<div class=\"continue-container center\">\n                                <button type=\"button\" name=\"continue\" class=\"continue cta btn\" ".concat(!this.currentShade ? 'disabled="disabled"' : '', "><span class=\"medium-up--show medium-down--hide\">Continue</span><span class=\"medium-down--show medium-up--hide\">Next</span></button>\n                              </div>") : "<div class=\"oos-message center\"></div><div class=\"flex flex-center atc-container\">\n                                ".concat(this.buildQtyInputHolder(), "\n                                ").concat(this.buildQuickAddCta(product, notifyCtaText, config), "\n                              </div>"), "\n                        </div>\n                      </div>\n                    </div>\n                    <div class=\"").concat(typeSelectorClass, " for--desktop--important\" >\n                      <div class=\"types-selector__wrapper\">\n\n                        <div class=\"types-selector__header ").concat(titleClass, " \">\n                          <div class=\"shade-selector__title h5\">").concat(this.bundleProduct.title, "</div>\n                          <div class=\"shade-selector__subtitle label milano\">").concat(this.bundleProduct.step2SelectorTitle, "</div>                      \n                          <div class=\"modal__close--mobile\">\n                          <svg  class=\"close_icon\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 99.12 99.12\"><title>Close</title><line class=\"close__line close__line_1\" x1=\"1.06\" y1=\"1.06\" x2=\"98.06\" y2=\"98.06\" style=\"fill:none;stroke-miterlimit:10;stroke-width:6px\"></line><line class=\"close__line close__line_2\" x1=\"1.06\" y1=\"98.06\" x2=\"98.06\" y2=\"1.06\" style=\"fill:none;stroke-miterlimit:10;stroke-width:6px\"></line></svg>\n                          </div>                      \n                        </div>          \n                              \n                        <div class=\"types-selector__swatches types flex\"></div>\n                        <div class=\"oos-message center\"></div>\n                        <div class=\"types-selector__tooltip center\">\n                          <span class=\"tooltip link--underlined\" data-tooltip-content=\"#tooltip_content_qickAdd\">More Information</span>\n                        </div>\n                        <div class=\"tooltip_templates\">\n                          <span id=\"tooltip_content_qickAdd\">\n                              <p>\n                              Our REFILL is available if you already own a case, and just need to refill the shade. \n                              </p>\n                              <p>\n                              Our lightweight RED EDITION case is 100% recyclable. <br>Comes with refill & can be refilled 2-3 times.</p> \n                              <p>Our ICONIC EDITION case is a metal case built for a lifetime. Comes filled with shade & can be refilled any time.\n                              </p>\n                          </span>\n                        </div>\n\n                        <div class=\"flex flex-center atc-container\">\n                          ").concat(this.buildQtyInputHolder(), "\n                          ").concat(this.buildQuickAddCta(product, notifyCtaText, config), "\n                        </div>                      \n                      \n                      </div>\n                    </div>\n                  </form>\n                </div>");
    var $html = $(html);
    var openModal = config.openModal === undefined ? false : config.openModal;
    var context = this;
    theme.adjusters($html);
    this.quickAddHandlers($html, config);
    this.skinToneHandlers();
    theme.modal.modal($html, 'quickAdd_popup', openModal);
    var quickAddModal = new theme.Product("#FgModal .quickAdd-container[data-quick-product='".concat(this.bundleProduct.title, "']"), [], {
      quickAddConfig: config,
      bundleUpsells: this.bundleUpsells
    }, {}, "quickAdd", this);
    this.quickAddModal = quickAddModal;
    $('.modal__close--mobile').on('click', function () {
      context.initFeaturedProductsSlider();
      theme.modal.hide();
    });
    setTimeout(function () {
      $('#FgModal').addClass('open-init');
      $('body').addClass('modal-open');
    }, 100);
  };

  Product.prototype.imagesLoaded = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator2( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(images) {
      var promiseArray, imageArray, _iterator, _step, _loop;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              promiseArray = [];
              imageArray = [];
              _iterator = _createForOfIteratorHelper2(images);

              try {
                _loop = function _loop() {
                  var image = _step.value;
                  promiseArray.push(new Promise(function (resolve) {
                    var img = new Image();

                    img.onload = function () {
                      resolve();
                    };

                    img.src = image;
                    imageArray.push(img);
                  }));
                };

                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  _loop();
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }

              _context2.next = 6;
              return Promise.all(promiseArray);

            case 6:
              return _context2.abrupt("return", imageArray);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  Product.prototype.toneFilter = function (e) {
    var _this8 = this;

    if (e) {
      e.preventDefault();
      var filter = $(e.currentTarget);
      this.skintone = filter.data('skintone') ? filter.data('skintone') : filter.attr('id') === 'skin-tone' && filter.val() ? filter.val() : this.skintone;
      this.undertone = filter.data('undertone') ? filter.data('undertone') : filter.attr('id') === 'undertone' && filter.val() ? filter.val() : this.undertone;
    }

    if (this.bundleProduct.shadeFinder) {
      if (this.undertone === "All" && this.skintone === "All") {
        $(selectors.shadeSelector, this.$container).show();
      } else if (this.skintone !== "All" && this.undertone !== "All") {
        $(selectors.shadeSelector, this.$container).hide();
        this.bundleProduct.shadeFinder[this.skintone][this.undertone].forEach(function (shade) {
          $("".concat(selectors.shadeSelector, "[data-shade=\"").concat(shade.shade, "\"]"), _this8.$container).show();
        });
      } else if (this.skintone !== "All" && this.undertone === "All") {
        $(selectors.shadeSelector, this.$container).hide();
        Object.keys(this.bundleProduct.shadeFinder[this.skintone]).forEach(function (undertone) {
          _this8.bundleProduct.shadeFinder[_this8.skintone][undertone].forEach(function (shade) {
            $("".concat(selectors.shadeSelector, "[data-shade=\"").concat(shade.shade, "\"]"), _this8.$container).show();
          });
        });
      } else {
        // this.skintone === "All" && this.undertone !== "All"
        $(selectors.shadeSelector, this.$container).hide();
        Object.keys(this.bundleProduct.shadeFinder).forEach(function (skintone) {
          _this8.bundleProduct.shadeFinder[skintone][_this8.undertone].forEach(function (shade) {
            $("".concat(selectors.shadeSelector, "[data-shade=\"").concat(shade.shade, "\"]"), _this8.$container).show();
          });
        });
      }

      var $firstShade = $("".concat(selectors.shadeSelector), this.$container).not(':hidden').first();
      if ($firstShade.length) $firstShade[0].click();
    }
  };

  Product.prototype.shadeFinder = function (e) {
    var _this9 = this;

    e.preventDefault();
    if ($('#FgModal .shadeFinder-container').length) return;

    var product = slate.utils._get(this.bundleProduct.variants, "".concat(this.currentShade, "&&").concat(this.currentType));

    if (this.skintone === "All") this.skintone = "Medium";
    if (this.undertone === "All") this.undertone = "Neutral";
    var initialRecommendations = '<p><i>Please choose your preferences</i></p>';
    this.recommendationsLoader = "<div class=\"loading\">\n                                    <div class=\"loading-image\"></div>\n                                    <div class=\"loading-recommendation\">\n                                      <div class=\"loading-circle\"></div>\n                                      <div class=\"loading-text\"></div>\n                                    </div>\n                                    <div class=\"loading-description\">\n                                      <div class=\"loading-text\"></div>\n                                      <div class=\"loading-text\"></div>\n                                      <div class=\"loading-text\"></div>\n                                      <div class=\"loading-text\"></div>\n                                    </div>\n                                  </div>\n                                  <div class=\"loading\">\n                                    <div class=\"loading-image\"></div>\n                                    <div class=\"loading-recommendation\">\n                                      <div class=\"loading-circle\"></div>\n                                      <div class=\"loading-text\"></div>\n                                    </div>\n                                    <div class=\"loading-description\">\n                                      <div class=\"loading-text\"></div>\n                                      <div class=\"loading-text\"></div>\n                                      <div class=\"loading-text\"></div>\n                                      <div class=\"loading-text\"></div>\n                                    </div>\n                                  </div>\n                                  <div class=\"loading\">\n                                    <div class=\"loading-image\"></div>\n                                    <div class=\"loading-recommendation\">\n                                      <div class=\"loading-circle\"></div>\n                                      <div class=\"loading-text\"></div>\n                                    </div>\n                                    <div class=\"loading-description\">\n                                      <div class=\"loading-text\"></div>\n                                      <div class=\"loading-text\"></div>\n                                      <div class=\"loading-text\"></div>\n                                      <div class=\"loading-text\"></div>\n                                    </div>\n                                  </div>";
    var html = "<div class=\"shadeFinder-container shadefinder-ui\">\n                  <form action=\"/cart/add\" method=\"post\" enctype=\"multipart/form-data\">\n                    <select name=\"id\" class=\"no-js product-select\">\n                      ".concat(this.products.reduce(function (a, product) {
      a += "<option ".concat(!product.available ? 'disabled="disabled"' : '', " value=\"").concat(product.variants[0].id, "\">").concat(product.title, "</option>");
      return a;
    }, ""), "\n                    </select>\n                    <div class=\"inner shade-finder\">\n                      <div class=\"shade-finder__title h3 center genre\">Find your shade</div>\n                      <div class=\"shade-finder__columns\">\n                        <div class=\"selections\">\n                        <div class=\"shade-finder__selectors\">\n                          <div class=\"shade-finder__slider\">\n                            <div class=\"shade-finder__subtitle\">Choose Skin Tone</div>\n                            <div class=\"shade-finder__description section-description\">The overall surface shade of your skin</div>\n                            <div class=\"skintone-labels flex\">\n                              <div class=\"skintone-label ").concat(this.skintone === 'Fair' ? 'selected' : '', "\">Fair</div>\n                              <div class=\"skintone-label ").concat(this.skintone === 'Light' ? 'selected' : '', "\">Light</div>\n                              <div class=\"skintone-label  ").concat(this.skintone === 'Medium' || this.skintone === 'All' ? 'selected' : '', "\">Medium</div>\n                              <div class=\"skintone-label ").concat(this.skintone === 'Medium Dark' ? 'selected' : '', "\">Medium Dark</div>\n                              <div class=\"skintone-label ").concat(this.skintone === 'Deep' ? 'selected' : '', "\">Deep</div>\n                            </div>\n                            <div class=\"skintone-gradient\">\n                              <div class=\"skintone ").concat(this.skintone === 'Fair' ? 'selected' : '', "\" data-skintone=\"Fair\"></div>\n                              <div class=\"skintone ").concat(this.skintone === 'Light' ? 'selected' : '', "\" data-skintone=\"Light\"></div>\n                              <div class=\"skintone ").concat(this.skintone === 'Medium' || this.skintone === 'All' ? 'selected' : '', "\" data-skintone=\"Medium\"></div>\n                              <div class=\"skintone ").concat(this.skintone === 'Medium Dark' ? 'selected' : '', "\" data-skintone=\"Medium Dark\"></div>\n                              <div class=\"skintone ").concat(this.skintone === 'Deep' ? 'selected' : '', "\" data-skintone=\"Deep\"></div>\n                            </div>\n                          </div>\n                          <div class=\"shade-finder__undertones\">\n                            <div class=\"shade-finder__subtitle\">Choose Undertone</div>\n                            <div class=\"shade-finder__description section-description\">Undertone is the overall hue that comes through from beneath your skin&rsquo;s surface</div>\n                            <div class=\"undertone-selectors flex\">\n                              <div class=\"undertone-selectors__wrapper\">\n                                <div class=\"undertone-selectors__single undertone ").concat(this.undertone === 'Cool' ? 'selected' : '', "\" data-undertone=\"Cool\">\n                                  <div class=\"undertone-selectors__text\">\n                                  <div class=\"undertone-selectors__title\">Cool</div>\n                                  <div class=\"undertone-selectors__description\">Pink, red or blue</div>\n                                  <div class=\"center\"><a class=\"undertone-selectors__link link--underlined link--uppercase\">Select</a></div>\n                                  </div>\n                                </div>                            \n                              </div>\n                            <div class=\"undertone-selectors__wrapper\">\n                              <div class=\"undertone-selectors__single undertone ").concat(this.undertone === 'Neutral' ? 'selected' : '', "\" data-undertone=\"Neutral\">\n                                <div class=\"undertone-selectors__text\">\n                                  <div class=\"undertone-selectors__title\">Neutral</div>\n                                  <div class=\"undertone-selectors__description\">Mixture of warm and cool</div>\n                                  <div class=\"center\"><a class=\"undertone-selectors__link link--underlined link--uppercase\">Select</a></div>\n                                </div>\n                              </div>                            \n                            </div>\n                            <div class=\"undertone-selectors__wrapper\">\n                              <div class=\"undertone-selectors__single undertone ").concat(this.undertone === 'Warm' ? 'selected' : '', "\" data-undertone=\"Warm\">\n                                <div class=\"undertone-selectors__text\">\n                                  <div class=\"undertone-selectors__title\">Warm</div>\n                                  <div class=\"undertone-selectors__description\">Golden or Yellow</div>\n                                  <div class=\"center\"><a class=\"undertone-selectors__link link--underlined link--uppercase\">Select</a></div>\n                                </div>\n                              </div>                            \n                            </div>\n                            </div>\n                          </div>\n                          <div class=\"center\"><a class=\"link--underlined link--uppercase shadefinder-show-all-btn\" href=\"#\">I'm not sure, show me all my options</a></div>\n                        </div>\n                        </div>\n                        <div class=\"recommendations\">\n                          <div>\n                            <div class=\"shade-finder__subtitle\">Recommended for you</div>\n                            <div class=\"shade-finder__description\">Based on your selections</div>\n                          </div>\n                          <div class=\"recommendation-selectors flex\">\n                          ").concat(initialRecommendations, "\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                  </form>\n                </div>");
    var $html = $(html);
    $('form', $html).on('submit', function () {
      theme.rsCartListener;
    });
    $('.shadefinder-show-all-btn', $html).on('click', function (e) {
      e.preventDefault();
      console.log('triggered');
      $('.undertone-selectors__single.undertone.selected').removeClass('selected');
      var $allOptions = Object.values(_this9.bundleProduct.shadeFinder[_this9.skintone]).reduce(function (concat2, undertones) {
        concat2 += undertones.reduce(function (concat3, variant) {
          concat3 += _this9.renderSingleRecommendation(variant);
          return concat3;
        }, '');
        return concat2;
      }, '');
      $("".concat(selectors.shadeFinder, " .recommendation-selectors")).empty().append($allOptions);

      if (window.innerWidth <= 1024) {
        //scroll to target
        $('#FgModal').animate({
          scrollTop: $("#FgModal .recommendations").position().top - $('#FgModal').position().top + $('#FgModal').scrollTop()
        }, 1000);
      }
    });
    $html.on('click', selectors.recommendedShade, this.selectRecommendation.bind(this));
    $html.on('click', selectors.skintone, this.skintoneSelector.bind(this));
    $html.on('click', selectors.undertone, this.undertoneSelector.bind(this));
    var $modal;

    if (this.component === 'quickAdd') {
      this.quickAdd = $('#FgModal .quickAdd-container');
      var $quickAdd = this.quickAdd;
      $quickAdd.append($html);
      $quickAdd.closest('.quickAdd_popup').addClass('hide-quick-add').removeClass('open-init');
      setTimeout(function () {
        $quickAdd.closest('.quickAdd_popup').addClass('show-shade-finder').addClass('open-init'); // set height of recommendations so it is the only div w scrollbar

        var modalHeight = $("#FgModal .selections").height();
        $("#FgModal .recommendations").css('height', modalHeight + 'px');
      }, 400);
      $modal = this.quickAdd;
    } else {
      theme.modal.modal($html, 'quickAdd_popup', false);
      $modal = $('#FgModal');
      $modal.addClass('shadeFinderUi');
      setTimeout(function () {
        $modal.addClass('open-init');
        $('body').addClass('modal-open'); // set height of recommendations so it is the only div w scrollbar

        var modalHeight = $("#FgModal .selections").height();
        $("#FgModal .recommendations").css('height', modalHeight + 'px');
      }, 400);
    }

    var context = this; //this.setShadeFinderHeight($modal, theme.modal, context, $html);
    // $(document).trigger('opened.shadeFinder', [$html]);
    // $(document).on('opened.shadeFinder', this.skintoneSelector.bind(this))
    // $(document).on('opened.shadeFinder', this.undertoneSelector.bind(this))
  };

  Product.prototype.renderSingleRecommendation = function (variant) {
    return "<div class=\"recommendation\">\n    <div class=\"shade-image ".concat(this.handelize(variant.shade), "-model\"></div>\n    <div class=\"shade-recommendation\">\n      <div class=\"shades\"><div class=\"shade\" data-shade=\"").concat(variant.shade, "\"><div class=\"shade-middle\"><div class=\"shade-inner\"><div class=\"shade-bg ").concat(this.handelize(variant.shade), "\" /></div></div></div></div>\n      <div class=\"shade-title\">").concat(variant.shade, "</div>\n    </div>\n    <div class=\"shade-description\">").concat(variant.description, "</div>\n    <div class=\"center\"><a class=\"link--underlined link--uppercase\" href=\"#\" class=\"shade\" data-recommended-shade=\"").concat(variant.shade, "\" data-shade=\"").concat(variant.shade, "\">Select</a></div>\n    </div>");
  };

  Product.prototype.setShadeFinderHeight = theme.debounce(function ($modal, modalObj, context, $html) {
    var $clone = $modal.clone().css({
      position: 'absolute',
      visibility: 'hidden',
      display: 'block'
    });
    $('body').append($clone);
    var $shadeElem = $('.shadeFinder-container', context.$container);
    var shadeHeight = $clone.find('.shadeFinder-container').outerHeight(true); //$modal.css('height', shadeHeight);

    if (context.component === 'quickAdd') {
      $('.quickAdd__form', context.$container).css('opacity', '0');
      $shadeElem.addClass('open');
    }

    $modal.addClass('open');
    modalObj.show($modal);
    $(document).trigger('opened.shadeFinder', [$html]);
    $clone.remove();
  }, 1000);

  Product.prototype.skintoneSelector = function (evt) {
    $("".concat(selectors.shadeFinder, " ").concat(selectors.skintone)).removeClass('selected');
    $(evt.currentTarget).addClass('selected');
    this.skintone = $(evt.currentTarget).data('skintone');
    this.renderRecommendations();
  };

  Product.prototype.undertoneSelector = function (evt) {
    $("".concat(selectors.shadeFinder, " ").concat(selectors.undertone)).removeClass('selected');
    $(evt.currentTarget).addClass('selected');
    this.undertone = $(evt.currentTarget).data('undertone');
    var hasResult = this.renderRecommendations();

    if (hasResult && window.innerWidth <= 1024) {
      //scroll to target
      $('#FgModal').animate({
        scrollTop: $("#FgModal .recommendations").position().top - $('#FgModal').position().top + $('#FgModal').scrollTop()
      }, 1000);
    }
  };

  Product.prototype.renderRecommendations = function () {
    var _this10 = this;

    var hasResults = true;

    if (this.skintone && this.undertone && this.skintone !== "All" && this.undertone !== "All" && $(selectors.shadeFinder).length) {
      var html = this.bundleProduct.shadeFinder[this.skintone][this.undertone].reduce(function (a, v) {
        a += _this10.renderSingleRecommendation(v);
        return a;
      }, '');

      if (html === '') {
        html = '<p><i>Achieving flawless-looking skin should be easy. We are committed to developing and growing our range to bring you shades that are perfect for you.</i></p>';
        hasResults = false;
      }

      var $html = $(html);
      $html.on('click', selectors.recommendedShade, this.selectRecommendation.bind(this));
      $("".concat(selectors.shadeFinder, " .recommendation-selectors")).empty().append($html);
    } else if (this.skintone && !this.undertone && $(selectors.shadeFinder).length) {
      var _html = this.bundleProduct.shadeFinder[this.skintone]['Neutral'].reduce(function (a, v) {
        a += _this10.renderSingleRecommendation(v);
        return a;
      }, '');

      if (_html === '') {
        _html = '<p><i>Achieving flawless-looking skin should be easy. We are committed to developing and growing our range to bring you shades that are perfect for you.</i></p>';
        hasResults = false;
      }

      var _$html = $(_html);

      _$html.on('click', selectors.recommendedShade, this.selectRecommendation.bind(this));

      $("".concat(selectors.shadeFinder, " .recommendation-selectors")).empty().append(_$html);
    } else if (!this.skintone && this.undertone && $(selectors.shadeFinder).length) {
      var _html2 = this.bundleProduct.shadeFinder['Medium'][this.undertone].reduce(function (a, v) {
        a += _this10.renderSingleRecommendation(v);
        return a;
      }, '');

      if (_html2 === '') {
        _html2 = '<p><i>Achieving flawless-looking skin should be easy. We are committed to developing and growing our range to bring you shades that are perfect for you.</i></p>';
        hasResults = false;
      }

      var _$html2 = $(_html2);

      _$html2.on('click', selectors.recommendedShade, this.selectRecommendation.bind(this));

      $("".concat(selectors.shadeFinder, " .recommendation-selectors")).empty().append(_$html2);
    } else {
      $("".concat(selectors.shadeFinder, " .recommendation-selectors")).empty().append(this.recommendationsLoader);
      hasResults = false;
    }

    return hasResults;
  };

  Product.prototype.selectRecommendation = function (evt) {
    this.currentShade = $(evt.currentTarget).data('recommended-shade');
    this.changer(evt);

    if (this.component === 'quickAdd' && this.quickAdd) {
      $('form', this.quickAdd).on('submit', theme.rsCartListener);
      this.quickAdd.on('click', selectors.shadeSelector, this.changer.bind(this));
      this.quickAdd.on('click', selectors.typeSelector, this.changer.bind(this));
      this.quickAdd.on('click', selectors.closeModal, this.onUnload.bind(this));
      this.quickAdd.on('click', selectors.shadeFinderTrigger, this.shadeFinder.bind(this));
      this.quickAdd.on('click change', selectors.skintoneFilter, this.toneFilter.bind(this));
      this.quickAdd.on('click change', selectors.undertoneFilter, this.toneFilter.bind(this));
      this.quickAdd.on('variantChange' + this.namespace, this.setAddToCartState.bind(this)); // fIND me 

      this.quickAdd.on('variantChange' + this.namespace, this.refreshOOSMessage.bind(this));
      this.quickAdd.on('variantTitleChange' + this.namespace, this.setVariantTitle.bind(this));
      this.quickAdd.on('variantTitleChange' + this.namespace, this.refreshQuickAddImages.bind(this));
      this.quickAdd.on('variantFromPriceChange' + this.namespace, this.setFromPrice.bind(this));
      this.quickAdd.on('variantTypesChange' + this.namespace, this.setProductTypes.bind(this));
      this.quickAdd.on('variantImageChange' + this.namespace, this.setProductImages.bind(this));
      var $modal = $('#FgModal.quickAdd_popup');
      var $shadeFinder = $modal.find('.shadeFinder-container');
      var $quickAdd = $modal.find('.quickAdd__form');
      if ($shadeFinder.length) $shadeFinder.removeClass('open');

      if ($quickAdd.length) {
        var height = $quickAdd.outerHeight(true); //$modal.css('height', height);

        $modal.removeClass('open-init').removeClass('show-shade-finder').removeClass('hide-quick-add');
        var timeout = setTimeout(function () {
          $modal.addClass('open-init');
          $quickAdd.css('opacity', '1');
          $shadeFinder.remove();
          clearTimeout(timeout);
        }, 500);
      } else {
        theme.modal.modal(this.quickAdd, 'quickAdd_popup');
      }
    } else {
      theme.modal.hide();
    }

    $(selectors.skintoneFilter, this.$container).removeClass('selected');
    $(selectors.undertoneFilter, this.$container).removeClass('selected');
    $("".concat(selectors.skintoneFilter, "[data-skintone=\"").concat(this.skintone, "\"]"), this.$container).addClass('selected');
    $("".concat(selectors.undertoneFilter, "[data-undertone=\"").concat(this.undertone, "\"]"), this.$container).addClass('selected');
    $(selectors.skintoneFilter, this.$container).val(this.skintone);
    $(selectors.undertoneFilter, this.$container).val(this.undertone);
    this.toneFilter();
  };

  Product.prototype.setTooltips = function () {
    $('.tooltip').tooltipster({
      maxWidth: 380,
      theme: ['tooltipster-shadow', 'tooltipster-shadow-customized'],
      trigger: 'click',
      distance: 20
    });
  };

  Product.prototype.setImageContainerHeight = function () {
    var width = $('.innerzoomer').outerWidth();
    $('.innerzoomer').css('min-height', width + 'px');
  };
  /* Initializes PDP desktop sticky sidebar that rides along product images */


  Product.prototype.initStickySidebar = function () {
    var configs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if ($('.stickySidebar').length > 0 && $('.sticky-block').length > 0 && $('.sidebar__inner').length > 0) {
      return new StickySidebar('.stickySidebar', {
        topSpacing: 130,
        bottomSpacing: 0,
        containerSelector: '.sticky-block',
        innerWrapperSelector: '.sidebar__inner',
        minWidth: 1023
      });
    }
  };

  Product.prototype.initStickySidebarHandlers = theme.debounce(function (e) {
    var windowHeight = $(window).height();
    var $this = $(this);
    var stickyHeight;
    stickyHeight = $this.outerHeight(true);

    if (stickyHeight > windowHeight) {
      if (theme.pdpStickySidebar) {
        theme.pdpStickySidebar.destroy();
      }
    } else {
      Product.prototype.initStickySidebar();
    }
  }, 800);

  Product.prototype.addBisModalHandlers = function () {
    var context = this;

    if (theme.bisModal) {
      context.$container.on('variantTitleChange' + context.namespace, theme.bisModal.updateBisTriggerAttrs.bind(context));
    } else {
      $(document).on('bisModal:loaded', function (e) {
        context.$container.on('variantTitleChange' + context.namespace, theme.bisModal.updateBisTriggerAttrs.bind(context));
        context.setAddToCartState(e);
      });
    }
  };

  Product.prototype.listUpsells = function listUpsells(event, cart) {
    var context = this;
    var countrySelected = sessionStorage.getItem('countrySelected');
    var inventoryHash = JSON.parse(sessionStorage.getItem('inventory'));
    var inventoryByLocation = {
      usa: "Axcess Point",
      europe: "Prime Cargo"
    };

    if (context.bundleUpsells.length > 0) {
      setTimeout(function () {
        var upsell_html = '';
        $.each(context.bundleUpsells, function (index, product) {
          var button = '<button type="button" class="btn">Add to Cart</button>';
          var upsellPrice = '<div class="upsell-single__price">$' + (product.price / 100).toFixed(2) + '</div>';

          if (countrySelected == 'europe') {
            upsellPrice = '<div class="upsell-single__price">€' + (product.compare_at_price / 100).toFixed(2) + '</div>';
          }

          var sku = product.variants[0].sku;
          var inventoryLocation = inventoryByLocation[countrySelected];
          var inventory = inventoryHash[sku].find(function (l) {
            return l.location === inventoryLocation;
          });
          var details = product.upsell_bundle.details.split(".");
          upsell_html += '<div class="upsell-single" >' + '<img class="upsell-single__image" src="' + product.images[0] + '" />' + '<div class="upsell-single__info">' + '<h2 class="upsell-single__title">' + product.title + '</h2>' + upsellPrice + '<div class="upsell-single__description">' + details[0] + '. ' + details[1] + '.</div>' + '<div class="upsell-single__description"><a href="' + product.url + '">' + product.upsell_bundle.description + '</a></div>';

          if (inventory.available > 0) {
            upsell_html += '<div class="upsell-single__forms"><div class="quantity"><input type="number" name="quantity" value="1" /></div><input name="id" type="hidden" value="' + product.variants[0].id + '" />' + button + '</div>';
            '</div>';
          } else {
            upsell_html += "<button\n              type=\"button\"\n              data-bis-trigger\n              data-product-id=\"".concat(product.id, "\"\n              data-variant-id=\"").concat(product.variants[0].id, "\"\n              data-product-title=\"").concat(product.title, "\"\n              class=\"bis-trigger btn cta\">\n              ").concat(theme.strings.notify_mobile || "Notify me when available", "</button>");
          }

          upsell_html += '</div> ';
        });

        if (upsell_html != '') {
          var div = '<div class="upsell-modal__wrapper">' + '<div class="upsell-modal__contents">' + upsell_html + '</div>' + '</div>';
          theme.modal.modal($(div), 'upsell-modal ingredient_popup', true, false, function () {
            $('.upsell-modal .quantity', 'body').not('.gift').each(function (i, o) {
              theme.adjusters($(o));
            });
            $('.btn', '.upsell-single__forms').on('click', function (e) {
              e.preventDefault();
              var $this = $(this);
              var qty = $this.closest('.upsell-single__forms').find('input[name="quantity"]').val();
              var variantID = $this.closest('.upsell-single__forms').find('input[name="id"]').val();
              var opts = {
                items: [{
                  "id": variantID,
                  "quantity": qty
                }]
              };
              theme.cart.addToCart(opts).then(function () {
                theme.cart.getCart();
                theme.modal.hide();
              });
            });
          });
        }
      }, 500);
    }
  };

  Product.prototype.initYotpoGallery = function () {
    var context = this;
    var $yotpoGallery = $(selectors.pdpYotpoGallery);

    if (this.component === 'pdp' && bundle.yotpo) {
      this.yotpo = {};
      this.yotpo.shopPdpGallerySettings = bundle.yotpo.shopPdpGallerySettings;
      this.yotpo.bundleGallerySettings = bundle.yotpo.bundleGallerySettings;
      this.cachedElems = _objectSpread2(_objectSpread2({}, this.cachedElems), {}, {
        yotpoGallery: $yotpoGallery
      });

      if (window.yotpo) {
        yotpo.on('ready', function () {
          context.displayYotpoGalleryHeading();
        });
      } else {
        $(document).on('yotpo:load', function () {
          yotpo.on('ready', function () {
            context.displayYotpoGalleryHeading();
          });
        });
      } // Resize triggers on scroll on mobile. Only update the gallery if the device
      // width changes


      $(window).on('resize', function () {
        var currentSize = $(window).width();

        if (currentSize !== context.windowSize) {
          context.debouceUpdateYotpoGallery(context);
          context.windowSize = currentSize;
        }
      });
    }
  };
  /**
   * buildPdpGallerySettings
   * @summary build the final pdp gallery settings used to build the Yotpo
   *  gallery.
   * @param {Object} settings - product or collection yotpo pdp gallery settings
   * @param {Object} defaultSettings - shop default pdp gallery settings.
   * @returns {Object} settings used to build the pdp Yotpo gallery component
  */


  Product.prototype.buildPdpGallerySettings = function () {
    var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var defaultSettings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var finalSettings = {};
    finalSettings.gallery_id = settings.gallery_id || defaultSettings.gallery_id;
    finalSettings.gallery_id_mobile = settings.gallery_id_mobile || defaultSettings.gallery_id_mobile || finalSettings.gallery_id;
    var is_product_gallery = settings.is_product_gallery;

    if (is_product_gallery === undefined) {
      is_product_gallery = defaultSettings.is_product_gallery;
      if (is_product_gallery === undefined) is_product_gallery = true;
    }

    finalSettings.is_product_gallery = is_product_gallery;
    var is_product_gallery_mobile = settings.is_product_gallery_mobile;

    if (is_product_gallery_mobile === undefined) {
      is_product_gallery_mobile = defaultSettings.is_product_gallery_mobile;
      if (is_product_gallery_mobile === undefined) is_product_gallery_mobile = is_product_gallery;
    }

    finalSettings.is_product_gallery_mobile = is_product_gallery_mobile;
    var enable_super_text = settings.enable_super_text;

    if (enable_super_text === undefined) {
      enable_super_text = defaultSettings.enable_super_text;
      if (enable_super_text === undefined) enable_super_text = false;
    }

    finalSettings.enable_super_text = enable_super_text;

    if (enable_super_text) {
      finalSettings.super_text = settings.super_text || defaultSettings.super_text;
      finalSettings.super_text_mobile = settings.super_text_mobile || defaultSettings.super_text_mobile || finalSettings.super_text;
    }

    var enable_main_text = settings.enable_main_text;

    if (enable_main_text === undefined) {
      enable_main_text = defaultSettings.enable_main_text;
      if (enable_main_text === undefined) enable_main_text = true;
    }

    finalSettings.enable_main_text = enable_main_text;

    if (enable_main_text) {
      finalSettings.main_text = settings.main_text || defaultSettings.main_text;
      finalSettings.main_text_mobile = settings.main_text_mobile || defaultSettings.main_text_mobile || finalSettings.main_text;
      finalSettings.main_text_link = settings.main_text_link || defaultSettings.main_text_link;
      finalSettings.main_text_link_target = settings.main_text_link_target || defaultSettings.main_text_link_target;
    }

    var enable_sub_text = settings.enable_sub_text;

    if (enable_sub_text === undefined) {
      enable_sub_text = defaultSettings.enable_sub_text;
      if (enable_sub_text === undefined) enable_sub_text = false;
    }

    finalSettings.enable_sub_text = enable_sub_text;

    if (enable_sub_text) {
      finalSettings.sub_text = settings.sub_text || defaultSettings.sub_text;
      finalSettings.sub_text_mobile = settings.sub_text_mobile || defaultSettings.sub_text_mobile || finalSettings.sub_text;
      finalSettings.sub_text_link = settings.sub_text_link || defaultSettings.sub_text_link;
      finalSettings.sub_text_link_target = settings.sub_text_link_target || defaultSettings.sub_text_link_target;
    }

    return finalSettings;
  };
  /**
   * renderYotpoGallery
   * @summary builds html string of the pdp Yotpo gallery
   * @param {Object} variant - Product object
   * @returns {String}
  */


  Product.prototype.renderYotpoGallery = function (variant) {
    var html = '';

    if (variant) {
      var productGallerySettngs = variant.metafields && variant.metafields.yotpo ? variant.metafields.yotpo.pdp_gallery_settings : '';
      var settings = productGallerySettngs || this.yotpo.bundleGallerySettings || {};
      var defaultSettings = this.yotpo.shopPdpGallerySettings;

      if (settings) {
        var finalSettings = this.buildPdpGallerySettings(settings, defaultSettings);
        var windowWidth = $(window).width();
        var gallery_id = windowWidth < 1024 ? finalSettings.gallery_id_mobile : finalSettings.gallery_id;
        var is_product_gallery = windowWidth < 1024 ? finalSettings.is_product_gallery_mobile : finalSettings.is_product_gallery;

        if (gallery_id) {
          html = "<div class=\"text--charcoal align--center text-center brow-text\">";

          if (finalSettings.enable_super_text && finalSettings.super_text) {
            html += "<div class=\"brow-text__brow small--hidden overlay__supertext\">".concat(finalSettings.super_text, "</div>\n            <div class=\"brow-text__brow large--hidden overlay__supertext\">").concat(finalSettings.super_text_mobile, "</div>");
          }

          if (finalSettings.enable_main_text && finalSettings.main_text) {
            html += "<h2 class=\"h2 brow-text__main small--hidden\">";

            if (finalSettings.main_text_link) {
              html += "<a\n                class=\"h2 brow-text__main-text-link\"\n                href=\"".concat(finalSettings.main_text_link, "\"\n                target=\"").concat(finalSettings.main_text_link_target ? finalSettings.main_text_link_target : '', "\"\n                ").concat(finalSettings.main_text_link_target === '_blank' ? 'rel="noopener noreferrer"' : '', ">\n                ").concat(finalSettings.main_text, "\n              </a>");
            } else {
              html += finalSettings.main_text;
            }

            html += "</h2><h2 class=\"h2 brow-text__main large--hidden\">";

            if (finalSettings.main_text_link) {
              html += "<a\n                class=\"h2 brow-text__main-text-link\"\n                href=\"".concat(finalSettings.main_text_link, "\"\n                target=\"").concat(finalSettings.main_text_link_target ? finalSettings.main_text_link_target : '', "\"\n                ").concat(finalSettings.main_text_link_target === '_blank' ? 'rel="noopener noreferrer"' : '', ">\n                ").concat(finalSettings.main_text_mobile, "\n              </a>");
            } else {
              html += finalSettings.main_text_mobile;
            }

            html += "</h2>";
          }

          if (finalSettings.enable_sub_text && finalSettings.sub_text) {
            html += "<div class=\"subheader brow-text__subheader small--hidden overlay__subtext\">";

            if (finalSettings.sub_text_link) {
              html += "<a\n                class=\"brow-text__sub-text-link\"\n                href=\"".concat(finalSettings.sub_text_link, "\"\n                target=\"").concat(finalSettings.sub_text_link_target ? finalSettings.sub_text_link_target : '', "\"\n                ").concat(finalSettings.sub_text_link_target === '_blank' ? 'rel="noopener noreferrer"' : '', ">\n                ").concat(finalSettings.sub_text, "\n              </a>");
            } else {
              html += finalSettings.sub_text;
            }

            html += "</div><div class=\"subheader brow-text__subheader large--hidden overlay__subtext\">";

            if (finalSettings.sub_text_link) {
              html += "<a\n                class=\"brow-text__sub-text-link\"\n                href=\"".concat(finalSettings.sub_text_link, "\"\n                target=\"").concat(finalSettings.sub_text_link_target ? finalSettings.sub_text_link_target : '', "\"\n                ").concat(finalSettings.sub_text_link_target === '_blank' ? 'rel="noopener noreferrer"' : '', ">\n                ").concat(finalSettings.sub_text_mobile, "\n              </a>");
            } else {
              html += finalSettings.sub_text_mobile;
            }

            html += "</div>";
          } // Must leave off 'data-product-id' for non-product galleries otherwise
          // Yotpo will only pull in images tagged with product into gallery.


          html += "</div><div class=\"yotpo yotpo-pictures-widget\"\n            data-gallery-id=\"".concat(gallery_id, "\"\n            ").concat(is_product_gallery ? 'data-product-id="' + variant.id + '"' : '', "\n            ></div>");
        }
      }
    }

    return html;
  };
  /**
   * displayYotpoGalleryHeading
   * @summary ShowHide Yotpo gallery based on if Yotpo gallery has images
  */


  Product.prototype.displayYotpoGalleryHeading = function () {
    var $gallery = this.cachedElems.yotpoGallery || $(selectors.pdpYotpoGallery);
    var $yotpoGallerySlider = $(selectors.yotpoGallerySlider, $gallery);

    if ($yotpoGallerySlider.length && $yotpoGallerySlider.attr('data-images') !== '0') {
      $(selectors.yotpoGalleryHeader, $gallery).fadeIn();
    } else {
      $(selectors.yotpoGalleryHeader, $gallery).fadeOut();
    } // Remove Yotpo inline styling


    $gallery.find('.yotpo-single-image-container').css({
      width: ''
    });
  };
  /**
   * updateYotpoGallery
   * @summary rebuilds pdp Yotpo gallery component with new variant & its gallery
   *  settings
   * @param {Object} evt
   * @returns {Undefined}
  */


  Product.prototype.updateYotpoGallery = function (evt) {
    var variant = evt.variant;
    var $gallery = this.cachedElems.yotpoGallery;
    var galleryHtml = this.renderYotpoGallery(variant);
    $gallery.html(galleryHtml); // Must wait a few seconds after updating the gallery html to ensure Yotpo
    // doesn't run before updated gallery attributes are set. 

    setTimeout(function () {
      var yotpoApi = new Yotpo.API(yotpo);
      yotpoApi.refreshWidgets($gallery);
    }, 1000);
  };

  Product.prototype.debouceUpdateYotpoGallery = theme.debounce(function (context) {
    context.updateYotpoGallery({
      variant: context.variants.currentVariant
    });
  }, 500);
  return Product;
}();

$(function () {
  $(document).on('change', '[name="quantity-holder"]', function (e) {
    var $this = $(this);
    var val = $this.val();
    var $form = $this.closest('form');
    var $qtyInput = $('[name="quantity"]', $form);
    var $allHolders = $('[name="quantity-holder"]', $form);
    $allHolders.val(val);
    $qtyInput.val(val);
  });
}); //load this instead:

/**
 * Related to the original sections/product.js, but more focused, and faster, like a weasel.
 * @namespace product
 */

theme.ProductFilter = function () {
  var selectors = {
    addToCart: '.add-to-cart',
    originalSelectorId: '.product-select',
    singleOptionSelector: '.single-option-selector',
    product_info: '.product_info'
  };

  function ProductFilter(container, rs_filter, product) {
    if (product == null) {
      console.error('codenullproductfilter');
      return;
    }

    this.$container = container;
    this.rs_filter = rs_filter;
    this.product = product;
    this.renderer = new theme.productRenderer();
    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId
    };
    this.variants = new slate.Variants(product, options);
    this.namespace = '.product';
    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this)); //listen for variant selected events

    this.$container.on('restriction.product', this.restrict.bind(this));
    this.$container.on('rs-filter.change', this.changer.bind(this));
    setTimeout(function () {
      //need this to run after the rest of the inits.
      this.variants._onSelectChange(); //might not have this bound either

    }.bind(this), 1);
  }

  ProductFilter.prototype.changer = function (evt, $item, tag) {
    evt.stopPropagation(); //update the fake select list
    //call with $home.trigger('rs-filter.change', [$this, etag($this)]);
    //to get it to auto-update select lists for you.
    //one smallish problem: if you clear a filter with only 1 item, the filter is unselected, but the addtocart bit is smart enough to see there's only one variant remaining, and selects it.

    if ($item) {
      var $list = $item.closest('.rs-and');

      if ($list.length) {
        if ($item.hasClass('filter-selected')) {
          $('#SingleOptionSelector-' + $list.data('tag'), this.$container).val(tag); //.change();//change doesn't seem to be happening with val change.
        } else {
          $('#SingleOptionSelector-' + $list.data('tag'), this.$container).val(''); //.change();
        }
      }
    }

    this.variants._onSelectChange();
  };

  ProductFilter.prototype.updateAddToCartState = function (evt) {
    evt.stopPropagation();
    var variant = evt.variant; //$container.addClass('select-needed');

    if (variant) {
      $(selectors.product_info, this.$container).html(this.renderer.renderProduct(this.product, [variant]));
      this.rs_filter.variantToFilters(variant);
    } else {
      $(selectors.addToCart, this.$container).prop('disabled', true).text(theme.strings.unavailable);
      return;
    }

    if (variant.available) {
      $container.removeClass('select-needed');
      $(selectors.addToCart, this.$container).prop('disabled', false).text(theme.strings.addToCart);
    } else {
      $(selectors.addToCart, this.$container).prop('disabled', true).text(theme.strings.soldOut);
    }
  };

  ProductFilter.prototype.restrict = function (evt) {
    evt.stopPropagation();
    var variants = evt.variants,
        cvariants = [];

    if (variants.length == this.product.variants.length) {
      //remove all the rs-disabled. there's still some number of rs-hidden, but those filters have already been judged not applicable to this product.
      $('.rs-disabled', this.$container).removeClass('.rs-disabled');
    }

    if (variants.length >= 1 && variants.length < this.product.variants.length) {
      //filter the options with the available variants.
      // In order, from the top: if you have 4 colors, with 4 sizes, selecting a color will disable all te sizes that color doesn't have available.
      var tags = [];

      if (variants[0].options.length > 1) {
        var level1 = $('#hidden-selectors select[data-index="option1"]').val();

        if (level1) {
          for (var i in variants) {
            if (variants[i].available && level1 === variants[i].options[0] && tags.indexOf(variants[i].options[1]) === -1) {
              tags.push(variants[i].options[1]);
              cvariants.push(variants[i]);
            }
          }

          var level2 = this.rs_filter.restrictFilterOptionStr(tags, 'rs-disabled', 2);

          if (level2 !== null) {
            $('#hidden-selectors select[data-index="option2"]').val(level2);
          }
        }
      }

      tags = [];

      if (variants[0].options.length > 2) {
        var level2 = $('#hidden-selectors select[data-index="option2"]').val();

        if (level2) {
          for (var i in variants) {
            if (variants[i].available && level2 === variants[i].options[1] && tags.indexOf(variants[i].options[2]) === -1) {
              tags.push(variants[i].options[2]);
            }
          }

          var level3 = this.rs_filter.restrictFilterOptionStr(tags, 'rs-disabled', 3);

          if (level3 !== null) {
            $('#hidden-selectors select[data-index="option3"]').val(level3);
          }
        }
      }
    } //variants.length === 1 || == 0 is also very important, but is the updateAddToCartState's problem


    if (cvariants) {
      var strs = [];
      cvariants.forEach(function (v) {
        var _ = theme.getImageCodeFromVariant(v);

        if (strs.indexOf(_) === -1) {
          strs.push(_);
        }
      }); //Prob: wanted the available/selected variant colors. If there is a selected size, variants also includes all the related colors, which should not override a color selection.
      //the cvariants thing assumes the color is option1.

      theme.filterThumbnails(strs, $('.pslider_big'), $('.pslider_small'));
    } else {
      theme.filterThumbnails(null, $('.pslider_big'), $('.pslider_small'));
    } //not sure if the big slider will control visibility on the small one.
    //  does not. In fact, there is no actual connection.
    //TODO: need to be able to run this on init: restrict the images based on the non-selectable swatches
    //There are issues with the slider being inited
    //probably too much to ask, but it would be sweet if this could change the price range as well.


    $(selectors.product_info, this.$container).html(this.renderer.renderProduct(this.product, variants));
  };

  return ProductFilter;
}();
/**
 * Collection Banner Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Collection template.
 *
   * @namespace collection
 */


theme.collectionBanner = {
  init: function init() {
    var isStatic = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var selectors = {
      header: '#shopify-section-header',
      heroBanner: '[data-sectiontype="hero_section"]',
      textWrapper: '.collection-banner__text_wrapper',
      img: '.collection-banner__img',
      mobileImg: '.collection-banner__img--mobile'
    };
    var $header = $(selectors.header),
        $heroBanner = $(selectors.heroBanner),
        $textWrapper = $(selectors.textWrapper),
        $img = $(selectors.img);

    if (!isStatic) {
      theme.collectionBanner.transparentHeader($heroBanner, $(window).width(), $header, $textWrapper); //theme.collectionBanner.resizeHandler($header, $heroBanner, $img, $textWrapper);
    }

    theme.collectionBanner.applyHeaderTheme($header, $img.not(':hidden'));
  },
  resizeHandler: function resizeHandler($header, $banner, $img, $textWrapper) {
    $(window).on('resize', function (e) {
      theme.collectionBanner.transparentHeader($banner, $(window).width(), $header, $textWrapper);
      theme.collectionBanner.applyHeaderTheme($header, $img.not(':hidden'));
    });
  },
  transparentHeader: function transparentHeader($banner, windowWidth, $header, $textWrapper) {
    $textWrapper.css('margin-top', '');
    $textWrapper.css('padding-top', '');
    var marginTop = $header.outerHeight();
    var headerMarginTop = windowWidth < 769 ? -marginTop + 'px' : '';
    var $textElem = $('.brow-text');
    var isTopAligned = $textElem.hasClass('v-top');
    var isCenterAligned = $textElem.hasClass('v-center');
    var textWrapperMarginTop = isTopAligned ? marginTop + 'px' : '';
    var textWrapperPaddingTop = isCenterAligned ? marginTop + 'px' : '';
    var textElemPosPrev = $textElem.position().top;
    var textElemPosNext, offset;
    $banner.css('margin-top', headerMarginTop);

    if (windowWidth < 769) {
      $textWrapper.css('margin-top', textWrapperMarginTop);
      $textWrapper.css('padding-top', textWrapperPaddingTop);

      if (isCenterAligned) {
        textElemPosNext = $textElem.position().top;
        offset = Math.abs(textElemPosPrev - textElemPosNext);
        $textWrapper.css('margin-top', "".concat(offset, "px"));
        $textWrapper.css('padding-top', '0');
      }
    }
  },
  applyHeaderTheme: function applyHeaderTheme($header, $img) {
    var header_text_theme = $img.data('themetext') || 'charcoal';
    var header_theme = $img.data('theme') || 'transparent';
    theme.header.setBackgroundColor(header_theme);
    theme.header.setTextColor(header_text_theme);
    console.log({
      theme: header_theme,
      text: header_text_theme
    }); //Set the background for the transparent header 

    var headerHeight = $header.height() + 2;
    $('.collection-banner__wrapper:not(.collection-banner__wrapper--static)').css({
      marginTop: -headerHeight
    });
  }
};
/*================ Templates ================*/

pReady.push(function () {
  //These use the IIFE as a "namespace", but don't return anything

  /**
   * Customer Addresses Script
   * ------------------------------------------------------------------------------
   * A file that contains scripts highly couple code to the Customer Addresses
   * template.
   *
   * @namespace customerAddresses
   */
  theme.customerAddresses = function () {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    } // Initialize observers on address selectors, defined in shopify_common.js


    if (Shopify) {
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
    } // Initialize each edit form's country/province selector


    $('.address-country-option:not(#AddressCountryNew)').each(function () {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    }); // Toggle new/edit address forms

    $('.address-new-toggle').on('click', function () {
      $('.address__container').toggleClass('hide');
      $newAddressForm.toggleClass('hide');
    });
    $('.address-edit-toggle').on('click', function () {
      var formId = $(this).data('form-id');

      if (formId) {
        $('.edit__form').addClass('hide');
        $('.address__container').addClass('hide');
        $('#EditAddress_' + formId).toggleClass('hide');
      } else {
        $('.edit__form').addClass('hide');
        $('.address__container').removeClass('hide');
      }
    });
    $('.address-delete').on('click', function () {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
        Shopify.postLink('/account/addresses/' + formId, {
          parameters: {
            _method: 'delete'
          }
        });
      }
    });
  }();
  /**
   * Password Template Script
   * ------------------------------------------------------------------------------
   * A file that contains scripts highly couple code to the Password template.
   *
   * @namespace password
   */


  theme.customerLogin = function () {
    var config = {
      recoverPasswordForm: '#RecoverPassword',
      hideRecoverPasswordLink: '#HideRecoverPasswordLink'
    };

    if (!$(config.recoverPasswordForm).length) {
      return;
    }

    checkUrlHash();
    resetPasswordSuccess();
    $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
    $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

    function onShowHidePasswordForm(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    }

    function checkUrlHash() {
      var hash = window.location.hash; // Allow deep linking to recover password form

      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }
    /**
     *  Show/Hide recover password form
     */


    function toggleRecoverPasswordForm() {
      $('#RecoverPasswordForm').toggleClass('hide');
      $('#CustomerLoginForm').toggleClass('hide');
    }
    /**
     *  Show reset password success message
     */


    function resetPasswordSuccess() {
      var $formState = $('.reset-password-success'); // check if reset password form was successfully submited.

      if (!$formState.length) {
        return;
      } // show success message


      $('#ResetSuccess').removeClass('hide');
    }
  }();
});
/*  =^>^=   ROSWELL STUDIOS LIB   =^<^=  */
//oddly, Slate does not have the option for an ajax cart.
//need to add/remove items by ID (definitely not line number)
//update note
//update an assortment of numbers and settings on cart update
//update the cart
//broadcast on cart add (to add/remove specials), cart update (so anything else can see the new cart)
//options: copy the ID number edited timber cart?
// has handlebar
//Use the liquid cart html?
// no other libs, places limits on the actual cart, which, because there's a link on the checkout page, can not be removed.
// possibly slower in that it involves another call (BUT: timber was making an update.js/cart.js anyway)
//use react, because the rest of the site is also in react.
// rest of site not currently in react
//Ideally, all these functions also apply equally to the real /cart

/**
To react to cart changes in client custom code, do this:
$('body').on('cartupdate', function(event, cart) {
  $('#cartCount').text(cart.item_count);
  if (cart is not visible) {
    myCart.showCart();
  }
})

*/

theme.rsCart = function () {
  function Cart() {
    this.cart = null;
  }
  /**
  opts is something like {id:123,quantity:1} or $('form').serialize()
  */


  Cart.prototype.addToCart = function (opts, trigger) {
    var that = this;
    return $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: opts,
      dataType: 'json',
      success: function success(item) {
        $(document).trigger('cart.product_added', item); //does not return a cart, a bit unexpected

        if (trigger == 'pdp') {
          that.getCart('addToCart');
        } else {
          that.getCart();
        }

        // Bing Add to cart Tracking 
        window.uetq = window.uetq || [];
        window.uetq.push ('event', 'add_to_cart', {'event_category': 'Cart', 'event_label': 'addToCart', 'event_value': 1 , 'productId': item.product_id, 'variantId': item.variant_id });

        that.gtm('cart_add', item, opts);
        that.cart = null; //invalidate cart
      },
      error: function error(XMLHttpRequest, textStatus) {},
      complete: function complete(jqxhr, text) {}
    });
  };

  Cart.prototype.removeFromCart = function (id) {
    this.changeQuantity(id, 0);
  };
  /**
  opts is something like {note:'note'} or "note=cart_notes_enable"
  */


  Cart.prototype.updateCart = function (opts) {
    var that = this;
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: opts,
      dataType: 'json',
      success: function success(cart) {
        //TODO: cart or item?
        that.cart = cart; //for some reason the cart here was ignored and cart.json was called again when finishing up with the next call...but the page was reloading before it returned....why is the page reloading anyway cant it redraw like ajax cart instead of reloading?

        $(document).trigger('cartupdate', cart);
        that.gtm('cart_update', cart, opts);
      },
      error: function error(XMLHttpRequest, textStatus) {},
      complete: function complete(jqxhr, text) {}
    });
  };
  /**
  Empty cart:
  */


  Cart.prototype.clearCart = function () {
    var that = this;
    $.ajax({
      type: 'POST',
      url: '/cart/clear.js',
      dataType: 'json',
      success: function success(cart) {
        //TODO: cart or item?
        that.cart = cart;
        $(document).trigger('cartupdate', cart);
        that.gtm('cart_update', cart, 'cleared cart');
      },
      error: function error(XMLHttpRequest, textStatus) {},
      complete: function complete(jqxhr, text) {}
    });
  };

  Cart.prototype.getCart = function (triggered_by) {
    var that = this;
    return $.Deferred(function (dfd) {
      if (that.cart != null) {
        return dfd.resolve(that.cart);
      } //not sure how you'd get a submit button without getting the cart set, but maybe?


      $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function success(cart) {
          that.cart = cart;
          cart.triggered_by = triggered_by;
          $(document).trigger('cartupdate', cart);
          dfd.resolve(that.cart);
        },
        error: function error(XMLHttpRequest, textStatus) {},
        complete: function complete(jqxhr, text) {}
      });
    });
  };

  Cart.prototype.gtm = function (event, cart, opts) {
    if (USE_DEFAULT_GTM) {
      dataLayer.push({
        'event': 'ecommerce_event',
        'eventCategory': 'ecommerce',
        'eventAction': event,
        'ecommerce': {
          'detail': {
            'new_cart': cart,
            'change': opts
          }
        }
      });
    }
  };
  /**
  id is cartItem.variant_id //TODO: //TEST: is on KA, but does that work with no variants?
  quant == 0 will remove the item from the cart
  */


  Cart.prototype.changeQuantity = function (id, quant) {
    var that = this;
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + quant + '&id=' + id,
      dataType: 'json',
      success: function success(cart) {
        //TODO: cart or item?
        that.cart = cart;
        $(document).trigger('cartupdate', cart); //MAYBE? not update the cart, if this is only used on +/- buttons, just let them update the quant content
        //will need to update the price totals, which is available in cart. Would need $()
        //would need formatted money. See slate.currency
        //if quant == 0, would need to remove the entire line. Could update that, then.

        that.gtm('cart_update', cart, {
          id: id,
          quant: quant
        });
      },
      error: function error(XMLHttpRequest, textStatus) {},
      complete: function complete(jqxhr, text) {}
    });
  };

  Cart.prototype.showCart = function (div) {
    $.ajax({
      type: 'GET',
      url: '/cart?view=sidebar',
      success: function success(html) {
        var cartTemplate = $(html).find('#cartContents').html(); //If there is other random stuff that needs to added to the ajax cart html, add it here

        $(div).html(cartTemplate);
        $('.quantity', $(div)).not('.gift').each(function (i, o) {
          theme.adjusters($(o));
        });
        /*
        The paypal button is present, but whatever code it needs is not running.
        Manually trigger it. It seems to be OK with running with no buttons to process.
        */
        // Shopify.StorefrontExpressButtons.initialize();
        //Klarna Render

        window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
        window.KlarnaOnsiteService.push({
          eventName: 'refresh-placements'
        });
        /* looking for gift cards to reearrange dollar sign */

        $(div).find('.item__info--title').each(function (i, v) {
          var itemTitleParts = $(this).text().split("-");
          var updatedTitlePart = slate.utils.checkShadeTitle(itemTitleParts[itemTitleParts.length - 1].trim());
          itemTitleParts[itemTitleParts.length - 1] = updatedTitlePart;
          var updatedTitle = itemTitleParts.join("- ");
          $(this).text(updatedTitle);
        });
      },
      error: function error(XMLHttpRequest, textStatus) {//$(div).html(textStatus)//shouldn't happen, but also doing  nothing is bad
      }
    });
  };

  return Cart;
}();
/**
intercept form submissions so it goes to the ajax cart above.
$('form', $container).on('submit', theme.rsCartListener)
*/


theme.rsCartListener = function (e, cb, addToCartTrigger) {
  e.preventDefault();
  theme.cart.addToCart($(this).serialize(), addToCartTrigger).then(function () {
    theme.RightDrawer.open(e);
    $(document).trigger('product.successfully_added');
  }) //open the drawer, get the html
  .then(function () {
    return theme.cart.getCart();
  }).then(function (cart) {
    if (cb && typeof cb === 'function') {
      cb(e, cart);
    }
  }); // }
  //get the JSON, so it can update stuff like the CartCount
  //Prob: without an event passed into .open(), it does different stuff.
  //Could manually call that stuff here, or just make it think it was the same as the cart icon click
  //the on cartupdate will reload the content, but .open() will display the old cart first.
  //animation might cover that naturally?
  //- seems to be too fast to see

  return false;
}; // move the fliter logic out of rs-navigator, so that the variants  can also use it.


theme.rs_filter = function ($home, CUSTOM_FILTERS, singleSelect) {
  //there might be more than one filter-set on the page. Stay inside $home
  //init
  //open/close submenu
  $home //too specific? use case for more than one at at a time?
  .on('click', '.submenupop', function (e) {
    e.stopPropagation();
    $(this).parent().toggleClass('close');
  }) //toggle selectable filters
  .on('click', '.filter-item', function (e) {
    e.stopPropagation();
    var $this = $(this);
    if ($this.hasClass('rs-hidden')) return; //if css is only grayed out, not actually hidden, would want this

    if ($this.hasClass('rs-disabled')) return; //is visible, but has an X on it or something.

    if (singleSelect) {
      $this.siblings('.filter-item').removeClass('filter-selected').data('aria-checked', 'false'); //all sibs might be faster.
    }

    $this.toggleClass('filter-selected').data('aria-checked', $(this).data('aria-checked') != 'true' ? 'true' : 'false'); //Issue: the dispatch is not getting picked up by the .on (works with addEventListener)
    //given that this is inside an on listerner, lets stick with that
    //$home.each(function(i,o){ o.dispatchEvent(new CustomEvent('rs-filter.change', {detail:{target: this, tag: etag($this)}))})

    $home.trigger('rs-filter.change', [$this, etag($this)]);
  })
  /** any button that triggers a re-filtering, like
  Min ___ Max ___ [Filter]
  */
  .on('click', '.rs-change-filter', function (e) {
    e.stopPropagation();
    $home.trigger('rs-filter.change');
  }) // reset filters:
  .on('click', '.clear-filter-item', function (e) {
    e.stopPropagation();
    var tag = $(this).data('tag');
    $('.filter-item.filter-selected').filter(function () {
      return etag($(this)) == tag;
    }).removeClass('filter-selected').data('aria-checked', 'false');
    $home.trigger('rs-filter.change', [$(this)]);
  }).on('click', '.rs-clearall-siblings', function (e) {
    e.stopPropagation();
    $(this).siblings('.filter-selected').removeClass('filter-selected').data('aria-checked', 'false');
    $home.trigger('rs-filter.change', [$(this)]);
  }).on('click', '.rs-clearall', function (e) {
    e.stopPropagation();
    $('.filter-selected', $home).removeClass('filter-selected').data('aria-checked', 'false');
    $('.rs-range input', $home).val('');
    $home.trigger('rs-filter.change', [$(this)]);
  });
  /** helper function for pFilter */

  function basicSearch(ortags, classes) {
    var or = false;
    $.each(_typeof2(ortags) == 'object' ? ortags : [ortags], function (i, tag) {
      if (classes.indexOf(tag) > -1) {
        or = true;
        return false;
      }
    });
    return or;
  }

  ;
  /** helper function for pFilter*/

  function basicTagSearch(ortags, object) {
    return object.tags ? basicSearch(ortags, object.tags) : false; //would not expect this, but it happens
  }

  function pFilter(filters, object) {
    var and = true;
    $.each(filters, function (i, ortags) {
      if (and && ortags && ortags.length) {
        and = and && (CUSTOM_FILTERS[i] || basicTagSearch)(ortags, object);
      }

      return and;
    });
    return and;
  }

  function etag($this) {
    return $this.data('tag') || $this.text().toLowerCase().replace(',', '').replace(',', '').trim();
  }

  return {
    filterProducts: function filterProducts(data, filters) {
      var output = [];

      if (filters && Object.keys(filters).length) {
        for (var i = 0; i < data.length; i++) {
          if (pFilter(filters, data[i])) {
            output.push(data[i]);
          }
        }
      } else {
        output = data.slice(0, data.length); //sort's concept of the original order can get messed up here if you return original flavor data
      }

      return output;
    },
    //given an array of variants and a list of strings
    //Kind of thinking this would be more efficient if it can apply the correct filters directly to the correct option
    filterVariants: function filterVariants(variants, filters) {
      var output = [],
          orz = null;

      if (filters && Object.keys(filters).length) {
        for (var i in filters) {
          for (var j in filters[i]) {
            orz.push(filters[i][j]);
          }
        }
      }

      if (orz && orz.length) {
        for (var i = 0; i < variants.length; i++) {
          for (var j = 0; j < orz.length; j++) {
            for (var k = 0; k < variants[i].options.length; k++) {
              //that looks horrifying, but 2 are <= at most 3
              if (orz[j] == variants[i].options[k]) {
                output.push(variants[i]);
              }
            }
          }
        }
      } else {
        output = variants;
      }

      return output;
    },
    setFilterOptions: function setFilterOptions(filters) {
      $('.rs-and', $home).each(function (k, andblock) {
        var key = $(this).data('tag');
        var andOptions = filters[key];

        if (andOptions && andOptions.length) {
          $(andblock).find('.rs-or').each(function (k, v) {
            if (andOptions.indexOf($(this).data('tag') || $(this).text().trim()) >= 0) {
              $(this).addClass('filter-selected').data('aria-checked', 'true');
            }
          });

          if ($(andblock).find('.rs-range').length > 0) {
            var explode = andOptions[0].split('-'); //this assumes there's only 1 range in the block. Nobody else does.
            //Should match the options array with -range array

            if (explode[0].length > 0) $(andblock).find('.rs-or-min').val(explode[0]);
            if (explode[1].length > 0) $(andblock).find('.rs-or-max').val(explode[1]);
          }
        }
      });
    },
    restrictFilterOptions: function restrictFilterOptions(allProducts, hideClass) {
      var hidden = hideClass || 'rs-hidden';

      function prodSearched(key, val) {
        //return as soon as you find a product that matches this filter option
        for (var x = 0; x < allProducts.length; x++) {
          //tricky: Custom filters
          if ((CUSTOM_FILTERS[key] || basicTagSearch)([val], allProducts[x])) {
            //better? create one array of all the basic tag searches and do the loop once.
            return false;
          }
        }

        return true;
      }

      $('.rs-and', $home).each(function (k, andblock) {
        var $andblock = $(andblock),
            key = $andblock.data('tag');
        $andblock.find('.rs-or').each(function (k, v) {
          var $v = $(v),
              tag = etag($v);

          if (prodSearched(key, tag)) {
            $v.addClass(hidden).removeClass('filter-selected').data('aria-checked', 'false');
          } else {
            $v.removeClass(hidden);
          }
        }); //if ($(andblock).find('.rs-range').length > 0) {}
        //set the min/max on a slider?
        //hide entire category if there's no point

        if ($andblock.find('.rs-or.filter-selected').length == 0) {
          var $ors = $andblock.find('.rs-or:not(.rs-hidden)');

          if ($ors.length < 1) {
            //:visible, or not(hidden), or whatever, above
            //.not('.rs-hidden') faster?
            $andblock.addClass(hidden);
          }

          if ($ors.length >= 1) {
            //1 and only 1 option, why make the user click it?
            //   $ors.addClass('filter-selected');
            // } else {
            // ^^ reported as "not a great user experience" when it shows up in the filter. (the original filter can be removed, leaving this one checked.)
            //may need to tweak this for both the filter and swatches, should they have different needs.
            $andblock.removeClass(hidden);
          }
        }
      });
    },

    /**
    restrictFilterOptions uses the custom filters, but also requires full products.
    If you just want tags/string filtered, use this.
    Is much faster!
    */
    restrictFilterOptionsStr: function restrictFilterOptionsStr(tags, hideClass) {
      var hidden = hideClass || 'rs-hidden';
      $('.rs-and', $home).each(function (k, andblock) {
        var $andblock = $(andblock),
            key = $andblock.data('tag');
        $andblock.find('.rs-or').each(function (k, v) {
          var $v = $(v);

          if (tags.indexOf(key, etag($v)) !== -1) {
            $v.addClass(hidden);
          } else {
            $v.removeClass(hidden);
          }
        });

        if ($andblock.find('.rs-or:not(' + hideClass + ')').length <= 1) {
          //might not want this.
          //:visible, or not(hidden), or whatever, above
          //.not('.rs-hidden') faster?
          $andblock.addClass(hidden);
        } else {
          $andblock.removeClass(hidden);
        }
      });
    },

    /**
    restrictFilterOptions uses the custom filters, but also requires full products.
    If you just want tags/string filtered, use this.
    Is much faster!
    */
    restrictFilterOptionStr: function restrictFilterOptionStr(tags, hideClass, optionKey) {
      var hidden = hideClass || 'rs-hidden';
      var search = optionKey ? '[data-option="' + optionKey + '"]' : '';
      var out = null; //empty option value

      $('.rs-and' + search, $home).each(function (k, andblock) {
        var $andblock = $(andblock),
            key = $andblock.data('tag');
        $andblock.find('.rs-or').each(function (k, v) {
          var $v = $(v);

          if (tags.indexOf(etag($v)) === -1) {
            $v.addClass(hidden);

            if ($v.hasClass('filter-selected')) {
              $v.removeClass('filter-selected').data('aria-checked', 'false');
              out = ''; //empty option value etag($v);
            }
          } else {
            $v.removeClass(hidden);
          }
        });

        if ($andblock.find('.rs-or:not(' + hideClass + ')').length <= 1) {
          //might not want this.
          //:visible, or not(hidden), or whatever, above
          //.not('.rs-hidden') faster?
          $andblock.addClass(hidden);
        } else {
          $andblock.removeClass(hidden);
        }
      });
      return out;
    },
    fillFilter: function fillFilter() {
      var andtags = {};
      $('.rs-and:not(rs-hidden)', $home).each(function (i, andblock) {
        var ora = [];
        $(andblock).find('.rs-or.filter-selected:not(rs-hidden)').each(function (i, orb) {
          ora.push(etag($(orb)));
        });
        $(andblock).find('.rs-range').each(function (i, orb) {
          var min = $(orb).find('.rs-or-min').val();
          var max = $(orb).find('.rs-or-max').val();

          if (min != '' || max != '') {
            ora.push(min + '-' + max);
          }
        });
        if (ora.length) andtags[$(andblock).data('tag')] = ora;
      });
      return andtags;
    },
    unsetFilterOption: function unsetFilterOption(options, ukey, uval) {
      $('.rs-and', $home).each(function (k, andblock) {
        var key = $(this).data('tag');
        if (key != ukey) return; //could search by tag...

        $(andblock).find('.rs-or').each(function (k, v) {
          var $v = $(v);

          if (options.indexOf($v.data('tag') || $v.text().trim()) >= 0) {
            var val = etag($v);
            if (val != uval) return;
            $v.removeClass('filter-selected').data('aria-checked', 'false');
            $v.siblings('label').find('i').toggle();
            return false;
          }
        });

        if ($(andblock).find('.rs-range').length > 0) {
          var explode = options[0].split('-'); //TEST? I don't remember how this works
          //see note about more than one range per block

          if (explode[0].length > 0) $(andblock).find('.rs-or-min').val('');
          if (explode[1].length > 0) $(andblock).find('.rs-or-max').val('');
        }
      });
    },
    searchToFilter: function searchToFilter(arr) {
      $('.rs-and', $home).each(function (i, andblock) {
        $(andblock).find('.rs-or').each(function (i, orb) {
          if (arr.indexOf(etag($(orb))) !== -1) {
            $(orb).addClass('filter-selected').data('aria-checked', 'true');
          } //ideally: expand the andblock. need a generic way of doing that.

        });
      });
    },

    /**
    turns the filter into a select list for easier compatibility with other plugins
    */
    filterToSelectList: function filterToSelectList() {
      var html = '';
      $('.rs-and', $home).each(function (k, andblock) {
        var $andblock = $(andblock),
            key = $andblock.data('tag');
        html += '<select id="SingleOptionSelector-' + key + '" class="single-option-selector" ' + '" data-index="option' + $andblock.data('option') + '"><option></option>';
        $andblock.find('.rs-or').each(function (k, v) {
          var $v = $(v);
          html += '<option value="' + etag($v) + '"' + ($v.hasClass('filter-selected') ? 'selected=selected' : '') + '>' + $v.text().trim() + '</option>';
        });
        html += '</select>';
      });
      return html;
    },

    /**
    assuming that the filters might already have some settings
    double check that the filter-options are selected.
    (could select a color with only 1 size, auto-select that size)
     also sets a SingleOptionSelector if available.
    */
    variantToFilters: function variantToFilters(variant) {
      //
      //Don't need to re-update anything, just set the data.
      $('.rs-and', $home).each(function (i, o) {
        var $andblock = $(o),
            $fs = $andblock.find('.filter-selected'),
            key = $andblock.data('tag'),
            option = 'option' + $andblock.data('option');

        if ($fs.length != 1) {
          $andblock.find('.rs-or').each(function (k, v) {
            var $v = $(v),
                tag = etag($v);

            if (tag === variant[option]) {
              $v.addClass('filter-selected').data('aria-checked', 'true'); //also the selector

              $('#SingleOptionSelector-' + key).val(tag);
            }
          });
        }
      });
    }
  };
}; //TODO: add history in a way that seems natural. Everything? only pagination clicks?
//eventually: be able to run more than one on a page. Not currently a need, but with a passed in collection url, and (root).find for the lookups, is possible and unique to shopify, or ecommerce in general.


theme.rs_navigator = function (collection_name, PRODUCTS_PER_PAGE, PRODUCT_RENDERER, CUSTOM_FILTERS, CUSTOM_FILTERS_STRINGS, filter_generator) {
  //TODO: find the one with the HOME var?
  var PRODUCTS_PER_AJAX = 100; //this has to be in sync with collection.json.liquid
  //TODO: if you expect a full page of items, and the count is not this number, do some sort of error message.
  //TODO: can it not take 100? RR got changed to 50.
  // GLOBAL VARIABLES:

  var allProducts = [],
      // all products in the collection/page
  products = [],
      totalPages = 0,
      sortParam = '',
      rs_filter = theme.rs_filter($('#filtermenu'), CUSTOM_FILTERS, false); //rather than constantly querying these, set it and forget it

  var gparams = {
    page: 1,
    q: undefined,
    //might override these off the url
    filterOptions: undefined,
    sortBy: undefined
  }; //random functions

  function splitParams(url) {
    if (!url) url = window.location.href; //.search would be shorter

    var parms = url.split('?'),
        out = [];

    if (parms.length != 2) {
      return out;
    }

    var a = parms[1].split('&');

    for (var i = 0; i < a.length; i++) {
      var _ = a[i].split('=');

      out[_[0]] = _[1];
    }

    return out;
  }

  function pushState() {
    var params = {},
        needsparams = false;

    if (gparams.page != 1) {
      params.page = gparams.page;
      needsparams = 1;
    }

    if (gparams.q) {
      params.q = gparams.q;
      needsparams = 1;
    }

    var url = location.pathname; //null/'' are ignored, meaning it won't replace an existing ?page

    if (needsparams) {
      url = "?" + $.param(params);
    }

    ;
    history.pushState({
      filterOptions: gparams.filterOptions
    }, ' ', //title, ignored
    url);
  } //PAGINATION DIV


  function pagination_init() {
    $("#pagination").on('click', 'a', function (e) {
      e.preventDefault();
      var page = $(this).attr('title');

      if (page === '') {
        page = '999';
      }

      if (page !== '999') {
        page = parseInt(page);
        $("html, body").animate({
          scrollTop: 0
        }, 500); //might also go to product-loop
      }

      if (page != gparams.page) {
        gparams.page = page;
        pushState();
      }

      paginateProducts(page);
    });
  }

  function setPaginator(currPage) {
    if (1 >= totalPages) {
      $('.rs-pagination').html('');
      return;
    }

    var paginator = "";

    if (currPage !== '999') {
      paginator += (currPage - 1 >= 1 ? '<a href="/collections/' + collection_name + '?page=' + (currPage - 1) + '" title="' + (currPage - 1) + '">Prev</a>' : '') + (currPage !== 1 ? '<a href="/collections/' + collection_name + '?page=1" title="1">1</a>' : '') + (currPage >= 4 ? '…' : '') + (currPage - 2 > 1 ? '<a href="/collections/' + collection_name + '?page=' + (currPage - 2) + '" title="' + (currPage - 2) + '">' + (currPage - 2) + '</a>' : '') + (currPage - 1 > 1 ? '<a href="/collections/' + collection_name + '?page=' + (currPage - 1) + '" title="' + (currPage - 1) + '">' + (currPage - 1) + '</a>' : '') + '<span class="current">' + currPage + '</span>' + (currPage + 1 < totalPages ? '<a href="/collections/' + collection_name + '?page=' + (currPage + 1) + '" title="' + (currPage + 1) + '">' + (currPage + 1) + '</a>' : '') + (currPage + 2 < totalPages ? '<a href="/collections/' + collection_name + '?page=' + (currPage + 2) + '" title="' + (currPage + 2) + '">' + (currPage + 2) + '</a>' : '') + (currPage <= totalPages - 4 ? '…' : '') + (currPage !== totalPages ? '<a href="/collections/' + collection_name + '?page=' + totalPages + '" title="' + totalPages + '">' + totalPages + '</a>' : '') + (currPage + 1 <= totalPages ? '<a href="/collections/' + collection_name + '?page=' + (currPage + 1) + '" title="' + (currPage + 1) + '">Next</a>' : '');
    } //TODO: decide if it is worth showing view all if there are more that X total pages. See also NN.


    if (totalPages <= 10 && currPage !== '999') {
      paginator += '<a href="/collections/' + collection_name + '?page=' + (currPage === '999' ? "1" : '999') + '" title="">' + (currPage === '999' ? theme.strings.vless : theme.strings.vall) + '</a>';
    }

    $('.rs-pagination').html(paginator).show();
  }

  function getPage(page) {
    gparams.page = page;
    pushState();
    paginateProducts(page);
  } // FILTERING


  function unsetFilterOption(ukey, uval) {
    if (gparams.filterOptions == undefined) return;
    rs_filter.unsetFilterOption(gparams.filterOptions, ukey, uval);
  }

  function setFilterOptions(options) {
    // sort by:
    if (options.sortBy) {
      $('select#SortBy').val(options.sortBy); //TODO: css, there's no sort by in the liquid
    } //TODO: search?


    if (options.filterOptions == undefined) return; // filter options:

    rs_filter.setFilterOptions(options.filterOptions);
    filtershown(options.filterOptions);
  }
  /** basic word matching search function
  */


  function searchText(qs, object) {
    return true; //IE (not edge) doesn't support this at all. worry about that later

    /*
    if (!qs.find) return true;
    return (qs.find((q)=>object.title.includes(q))!==undefined) && (qs.find((q)=>object.description.includes(q))!==undefined)
    (object.variants && object.variants.length &&
      qs.find((q)=>
        object.variants.find((v)=>v.title.includes(q))!==undefined
      ) &&
      (object.tags && object.tags.length &&
        qs.find((q)=>
          object.tags.find((t)=>tincludes(q))!==undefined
        )
      )
    )
    ;*/
  } // HISTORY STATE


  var filterProducts = function filterProducts(data) {
    var filters = gparams.filterOptions,
        output = rs_filter.filterProducts(data, filters); //use gparams.q to further reduce output.
    //Better: given that q is probably coming from the actual shopify search, this should probably only be used instead with a secondary filter-search.
    //would need to add that to setParam, gparams. Get business case first. Could be confusing with 2 different search options.

    if (false && gparams.q) {
      //need that as an array
      var output2 = [],
          qs = gparams.q.split(/\W+/);

      for (var i = 0; i < output.length; i++) {
        if (searchText(filters, output[i])) {
          output2.push(qs, output[i]);
        }
      }
    } //Would need to be nearly as useful as the built-in search, but would allow for better cached data.
    //Might also be able to: search by price ranges, variants without tags (does shopify do that?)


    return output;
  }; //PRODUCTS


  function product_init() {
    $('#product-loop').on('click', '.grid__item a', function () {
      //save the div id as the scroll state, instead of the pixels
      var state = history.state || {};
      state.scrollTo = $(this).closest('.grid__item').attr('id');
      history.replaceState(state, '', location.href); //TEST: that the div works the same as the scrollTop()
    });
    $('select#SortBy').on('change', function () {
      gparams.sortBy = $(this).val();
      paginateProducts(gparams.page);
    });
  }

  function product_sort(products) {
    var sortf = 0;
    if (gparams.sortBy == 'title-descending') sortf = function sortf(b, a) {
      return a.title.localeCompare(b.title);
    };else if (gparams.sortBy == 'title-ascending') sortf = function sortf(a, b) {
      return a.title.localeCompare(b.title);
    };else if (gparams.sortBy == 'price-ascending') sortf = function sortf(a, b) {
      return a.variant[0].price - b.variant[0].price;
    }; //handle/product.json does not return a product price
    else if (gparams.sortBy == 'price-descending') sortf = function sortf(b, a) {
        return a.variant[0].price - b.variant[0].price;
      };else if (gparams.sortBy == 'created-ascending') sortf = function sortf(a, b) {
        return a.published_at > b.published_at ? -1 : a.published_at == b.published_at ? a.title.localeCompare(b.title) : 1;
      };else if (gparams.sortBy == 'created-descending') sortf = function sortf(b, a) {
        return a.published_at > b.published_at ? 1 : a.published_at == b.published_at ? a.title.localeCompare(b.title) : -1;
      }; //else return natural, collection defined sort

    if (sortf) products.sort(sortf);
  }

  function paginateProducts(page) {
    products = filterProducts(allProducts);
    product_sort(products);
    totalPages = Math.ceil(products.length / PRODUCTS_PER_PAGE);
    $("#num-products").html("(" + products.length + ") items"); //live filter update
    //rs_filter.restrictFilterOptions(products);

    if (products.length > 0 && page) {
      if (page !== '999' && page > totalPages) {
        //TEST: the ==='' bit
        page = 1; //may need to reset the url here: was page 2, filter reduced that to 1 page, url is still page=2
      }

      var endNdx = products.length < page * PRODUCTS_PER_PAGE || page === '999' ? products.length : page * PRODUCTS_PER_PAGE; //is either all available products, or a single page

      var productGrid = '';
      var startIdx = page === '999' || endNdx < PRODUCTS_PER_PAGE ? 0 : (page - 1) * PRODUCTS_PER_PAGE; //is either 0, or the start of the page

      for (var i = startIdx; i < endNdx; i++) {
        productGrid += PRODUCT_RENDERER.renderGrid(i, products[i], gparams.filterOptions, endNdx);
      } // render HTML


      $('#rs-notfound').hide();
      $("#product-loop").html(productGrid).removeClass('no-results').show();
      setPaginator(page);
    } else {
      $('#rs-notfound').show();
      $('#pagination').hide();
      $("#product-loop").hide();
    } //document.dispatchEvent(new CustomEvent('rs-navigator.paginator'))


    $(document).trigger('rs-navigator.paginator', [page]);
  } //document.addEventListener('rs-filter.change', function() {


  $(document).on('rs-filter.change', function (e) {
    gparams.filterOptions = rs_filter.fillFilter();
    filtershown(gparams.filterOptions);

    if (gparams.page != '999') {
      gparams.page = 1;
    } //replace state for each filter change?
    //also, the original version did not reset the page number


    paginateProducts(gparams.page); //reset the url to reflect the new filters.
    //ideally, make this a separate bit so that you can deploy the filter more than once per page, or on pages where it shouldn't update the url
    //D had individual elements, but this abuses the pre-existing search fuction, hopefully looks cleaner, too.

    var q = Object.keys(gparams.filterOptions).map(function (o) {
      return gparams.filterOptions[o].map(function (o) {
        return encodeURIComponent(o);
      }).join(',');
    }).join(',');

    if (q) {
      q = location.pathname + '?q=' + q;
    } else {
      q = location.pathname;
    }

    history.replaceState(gparams, 'Filtered', q);
  });

  function filtershown(filterOptions) {
    //generate another list of shows filters
    var $filtershown = $('#filtershown');

    if ($filtershown.length === 0) {
      return;
    }

    $filtershown.html('');

    var defaultString = function defaultString(ortag) {
      return ortag;
    };

    $.each(filterOptions, function (key, ortags) {
      var _ = CUSTOM_FILTERS_STRINGS[key] || defaultString;

      $.each(ortags, function (i, ortag) {
        $filtershown.append('<li class="clear-filter-item" data-block="' + key + '" data-tag="' + ortag + '"><a>' + _(ortag) + '</a><span class="ion-close-round"></span></li>');
      });
    });
  }

  function pageInit() {
    //a way to drop products. I know this is terrible system design, (because it's public data.
    // hiding it doesn't make it secret) but 2 people have asked for it.
    // might filter out .available or tags==wholesale.
    if (PRODUCT_RENDERER.filterProduct) {
      var tmp = [];
      $.each(allProducts, function (i, o) {
        if (PRODUCT_RENDERER.filterProduct(o)) {
          tmp.push(o);
        }
      });
      allProducts = tmp;
    }

    setFilterOptions(gparams);
    paginateProducts(gparams.page);

    if (history.state && history.state.scrollTo) {
      var $scroll = $('#' + history.state.scrollTo);

      if ($scroll.length == 1) {
        //$('#product-loop').imagesLoaded().done( function( instance ) {
        $('html, body').animate({
          scrollTop: $scroll.offset().top
        }, 700); //});
      }
    }

    if (!filter_generator) {
      rs_filter.restrictFilterOptions(allProducts);
    }
  }

  function postload() {
    if (filter_generator) {
      filter_generator(allProducts);
    }

    pagination_init();
    product_init();

    if (gparams.q && history.state.scrollTo) {
      //Prob: scrollTo needs it filtered first
      //But if the products are generating the filters, the filters won't exist here.
      //might need to break up the pageInit function.
      rs_filter.searchToFilter(gparams.q.split(','));
      gparams.filterOptions = rs_filter.fillFilter();
    }

    pageInit(); //run this after the filter_generator

    if (gparams.q) {
      rs_filter.searchToFilter(gparams.q.split(','));
      $(document).trigger('rs-filter.change');
    }

    $("#num-products").html("(" + allProducts.length + ") items");
    $(document).trigger('rs-navigator.loaded');
  }

  function finishAjax() {
    postload();
    $('#ajaxLoader').hide();
  }

  function loadDataAPI(collection_id, c) {
    /*
    I didn't forget about this.
    Pros: is faster.
          has better interal caching (not sure why, though)
          automatically includes img, variant data
    Cons: requires modifying the collection's sales channels, private app
          is under active development. Documentations and options are not in sync
          does not return all items, anyway
          does not return totals, so it would have to get that from liquid, or keep asking until it gets less than 50.
          does not work with search strings
          does not include metafields
    
    https://help.shopify.com/api/storefront-api/getting-started
    http://www.codeshopify.com/blog_posts/the-javascript-sdk-part-1-displaying-products-on-an-external-site
    Add to theme:
    <script src="http://sdks.shopifycdn.com/js-buy-sdk/v0/latest/shopify-buy.umd.min.js" async="async" defer="defer"></script>
    (There's also a http://sdks.shopifycdn.com/js-buy-sdk/v0/latest/shopify-buy.umd.polyfilled.min.js
    I don't know what exactly the polyfill brings support down to, or if we still care about IE or old android)
    
    Add the setup to theme.liquid's site setup script:
    const shopClient = ShopifyBuy.buildClient({
        accessToken: 'efc42042e279a181b5d1e8c34313728f',
        domain: 'roswelldev.myshopify.com',
        appId: '6'
    })
    //The 6 may change. (first app?) I don't see how to get the real id.
    //access token is from creating a private app.
    */
    //setup global shopClient in theme.liquid
    if (typeof shopClient === 'undefined') {
      console.log('%cNOTE: the Collection page used the API method, but did not set up the shopClient', 'color: red; font-size: x-large');
      return;
    }

    var pagesCount = Math.ceil(c / PRODUCTS_PER_AJAX);
    var requests = [];

    var _loop2 = function _loop2() {
      var page = i;
      requests.push(shopClient.fetchQueryProducts({
        'collection_id': collection_id,
        'limit': PRODUCTS_PER_AJAX,
        'page': page
      }).then(function (products) {
        for (var j = 0; j < products.length; j++) {
          allProducts[(page - 1) * PRODUCTS_PER_AJAX + j] = items[j];
        }
      }));
    };

    for (var i = 1; i <= pagesCount; i++) {
      _loop2();
    }

    $.when.apply($, requests).done(function () {
      allProducts = allProducts.filter(function (v, i) {
        return v ? v : null;
      });
      finishAjax();
    });
  }

  function loadDataAsset(url) {
    $.get(url, function (data) {
      allProducts = JSON.parse(data);
      finishAjax();
    });
  } //var preloaded_page = 0;


  function loadDataJSON(productsCount, search_terms) {
    var pagesCount = Math.ceil(productsCount / PRODUCTS_PER_AJAX),
        search = '',
        //PROGRAMMER: pick one of these
    //view = "view=metafields&page=";//includes metadata
    view = "view=json&page="; //slightly simpler
    //TODO: need to be able to select this in the collection page.
    // - also, search?
    //TODO: does the pathname contain /tag? Could be very confusing, shouldn't
    //TODO: alt: use /collections/handle/products.json
    // - a lot of people hate that it reveals all their info, it doesn't seem to be documented.
    // + seems to be faster.

    if (search_terms) {
      search = 'view=json&q=' + escape(search_terms) + '&type=product&'; //note: far less likely to be cached. Ideally, do the search internally.
    } //TEST:search url


    var baseUrl = location.pathname + '?' + search + view;
    totalPages = Math.ceil(productsCount / PRODUCTS_PER_PAGE);

    if (gparams.sortBy) {
      sortParam = '&sort=' + gparams.sortBy;
    } //INIT VIA AJAX:


    var requests = [];

    var _loop3 = function _loop3() {
      // if (preloaded_page === i) {
      //  continue;
      // }
      //problem: the "paginate collection.products by" needs to match the page size in collection.json
      // for preload to save a JSON load
      // but if it is 100 all the time, the liquid pagination stops working as intended
      // what I need is to get the correct "page" the slice lives on
      // --could also be split across "pages"
      //--more trouble that it is worth to save 1 ajax load, given that the preload works correctly.
      var page = i;
      requests.push( //TODO: I want this to be cached, but doesn't seem to be. The api calls are cached. Some apps hack xhr, too.
      //There's window.fetch, which is what the api call is using, but it didn't seem to work. either.
      // Maybe? I note the size is much smaller, but it doesn't say "from memory"
      // also not supported in IE without the polyfill
      // fetch(baseUrl + page + sortParam,{
      //   credentials: 'same-origin'  //probably don't actually need this?
      // }).then((res)=>res.json()).then((items)=>{
      // for (var j = 0; j < items.length; j++) {
      //   allProducts[((page - 1) * PRODUCTS_PER_AJAX) + j] = items[j];
      // }
      // }});
      //fetch also always returns, which is nice.
      $.get(baseUrl + page + sortParam, function (data) {
        var items = JSON.parse(data);

        for (var j = 0; j < items.length; j++) {
          allProducts[(page - 1) * PRODUCTS_PER_AJAX + j] = items[j];
        }
      }));
    };

    for (var i = 1; i <= pagesCount; i++) {
      _loop3();
    }

    $.when.apply($, requests).done(function () {
      allProducts = allProducts.filter(function (v, i) {
        return v ? v : null;
      });
      finishAjax();
    });
  }

  window.addEventListener('popstate', function (e) {
    //popstate does not trigger on initial page load
    if (e.state) {
      gparams = e.state;
      pageInit();
    }
  }); //init has available to it only the variables passed in, and the page url
  // should not actually do anything

  function navinit() {
    var ps = splitParams();

    if (ps.q) {
      gparams.q = ps.q;
    }

    if (ps.page) {
      gparams.page = parseInt(ps.page);
    } //get the tags off the url? Will be in the setFilter/popstate, but would be nice for a reload

  }

  navinit();
  return {
    'find': function find(fn) {
      return allProducts.find(fn);
    },
    'loadDirectly': function loadDirectly(products, current_page) {
      allProducts = products;
      gparams.page = parseInt(current_page); //render 1 page, assuming liquid did all filtering.
      //Do not override the anchors, let it go back to Shopify
      //Maybe? set the pagition anchors to grab the products[] JSON out of the page render?
      // reset allProducts, the page number, then re-render. Faster than re-loading the entire page.

      pageInit();
    },
    'loadRemotely': function loadRemotely(src, asset_url, total_products, search_count) {
      $('#ajaxLoader').show(); //start the load the data from the url(s)
      //Init the anchor overrides

      if (src === 'json') {
        loadDataJSON(parseInt(total_products || search_count), gparams.q);
      } else {
        loadDataAsset(asset_url);
      }
    },
    'loadAPI': function loadAPI(collection_id, count_of_collection) {
      $('#ajaxLoader').show();
      loadDataAPI(collection_id, count_of_collection);
    },

    /**
    Need to call this first in order get the ajax call's filter options set up correctly
    */
    'setFiltering': function setFiltering(tags, search) {
      //filterOptions is an array (and-level) of arrays (or-level) of items.
      if (tags) {
        if (!(tags instanceof Array)) {
          gparams.filterOptions = tags;
        } else {
          //Tags is an array of options, but not attached to any particular and-level. Throw them at all the or-level options.
          setTimeout(function () {
            //bg this
            rs_filter.searchToFilter(tags);
          }, 3);
        }
      }

      if (search) {
        //automagically select any search terms.
        setTimeout(function () {
          //bg this
          rs_filter.searchToFilter(search.split(/\W+/));
        }, 3);
      }

      gparams.q = search; //setFilterOptions(gparams);
      //filtershown(gparams.filterOptions);
    },
    'setView': function setView(all) {
      if (all) {
        gparams.page = '999';
      } else {
        gparams.page = 1;
      }

      paginateProducts(gparams.page);
    },

    /**
    if you are looking at a page, dump that content directly and not wait for the ajax calls.
    //render that content. Assuming there's no custom sort ordering or filtering in place yet, it will be the real content. (so the ajax load is only waiting on the other pages' data, and the pagination.)
    //Prob: The ajax will eventually finish and call the same functions. Some (click inits) need to not be called twice.
    - Don't want this rendering to slow down starting the ajax load. (Might want to make this an add-on to remote, so it knows to skip the page, start theload, then process the data it has while it waits)
    */
    'preload': function preload(items, page) {
      //this is getting a bit messy, especially with pagination>1
      //but at least don't ever show filtered products.
      if (PRODUCT_RENDERER.filterProduct) {
        var tmp = [];
        $.each(items, function (i, o) {
          if (PRODUCT_RENDERER.filterProduct(o)) {
            tmp.push(o);
          }
        });
        items = tmp;
      }

      for (var j = 0; j < items.length; j++) {
        allProducts[(page - 1) * PRODUCTS_PER_PAGE + j] = items[j]; //note: _PER_PAGE, not _PER_AJAX. This uses the shopify pagination number.
      }

      gparams.page = parseInt(page);
      gparams.filterOptions = gparams.filterOptions || {};

      if (gparams.filterOptions.q) {
        rs_filter.searchToFilter(gparams.filterOptions.q.split(','));
      }

      paginateProducts(gparams.page); //TODO this will happen twice with postload
    },
    'postload': postload
  };
}; //TODO: test the "bg this" lines actually improve anything with a complicated page layout
//Ideally, rework all this so that the ajax setup occurs before any additional processing.
//- is currently the searchToFilter dom loops, the preload page layout (which, with an ajax loader, is entirely cosmetic!)
//- might reduce this to 1 function call, but with more params.

/*things are boiling down to:
accept the page data, show it now for snappy UI.
 - Ideally, hover, quickview, click, work at this point.
 - but not paginate or filter (maybe? If you click the filter, the filter options would be set for the main load).
 - it would be doubled work, but just rendering html in liquid is certainly good here.
 - - rendering all the html in liquid would make random filtering harder, but is do-able.
 - - certainly if you add data-tags={{tags}} data-price={{price}}
accept the filtering options, setup dom.
 is only really costly if there are filter options.
 (there's always a collection tag for liquid cached system)
 (tags, search, url (todo: pull more out of url, like /collections/spoopy?priceRange=2,3))
 -related: there's no way to bookmark advanced/non-shopify filter searches
 the page data already reflects filtering options, presumably
  but not if there are url based options.
if necessary start ajax loading product list
-wait for ajax loader
-if there's no flash or loss of hover status, could redraw after each ajax call
- also: quickview
filter product list
display page of products
 ideally the same list as the live page from point 1. might want to check to save dom redraw.
display pagination
 is usually offscreen, anyway.
Restrict available filter options to products
 -if this gets called on partial load, make sure it doesn't remove options.

*/
//Timber's drawer, more or less
// https://github.com/Shopify/Timber
// Source and Modifications to that source provided under the MIT license
//Simplify: don't need it to move the page over, doesn't need to to be directly clickable (though doing its own close is nice)


theme.Drawers = function () {
  var Drawer = function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };
    this.$nodes = {
      parent: $('body'),
      //adds class
      page: $('#shopify-section-header') // listen to events
      ,
      moved: $('.is-moved-by-drawer') //shove this over by the width of the drawer.

    };
    this.config = $.extend(defaults, options);
    this.position = position;
    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false; // Prevent following href if link is clicked

    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    } // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.


    if (evt && evt.stopPropagation) {
      evt.stopPropagation(); // save the source of the click, we'll focus to this on close

      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    } // Notify the drawer is going to open
    //timber.cache.$body.trigger('beforeDrawerOpen.timber', this);
    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    //this.$nodes.moved.addClass('is-transitioning');//what does this do for me?
    //this.$drawer.prepareTransition();


    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true; // Set focus on drawer

    this.trapFocus(this.$drawer, 'drawer_focus'); // Run function when draw opens if set

    if (this.config.onDrawerOpen && typeof this.config.onDrawerOpen == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    } // Lock scrolling on mobile
    // this.$nodes.page.on('touchmove.drawer', function () {
    //   return false;
    // });


    var closer = $.proxy(function () {
      this.close();
      return false;
    }, this); //this.$nodes.page.on('click.drawer', closer);//force them to click the close button?

    $('#BgDrawer').on('click.drawer', closer);
    theme.modal.hide(); // Notify the drawer has opened
    //timber.cache.$body.trigger('afterDrawerOpen.timber', this);
  };

  Drawer.prototype.close = function (evt) {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    } // Notify the drawer is going to close
    //timber.cache.$body.trigger('beforeDrawerClose.timber', this);
    // deselect any focused form elements


    $(document.activeElement).trigger('blur'); // Ensure closing transition is applied to moved elements, like the nav
    //this.$nodes.moved.prepareTransition({ disableExisting: true });
    //this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);
    this.drawerIsOpen = false; // Remove focus on drawer

    this.removeTrapFocus(this.$drawer, 'drawer_focus');
    this.$nodes.page.off('.drawer');
    $('#BgDrawer').off('.drawer'); // Notify the drawer is closed now
    //timber.cache.$body.trigger('afterDrawerClose.timber', this);
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';
    $container.attr('tabindex', '-1');
    $container.focus();
    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';
    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
}();

theme.validate = {
  email: function email(_email) {
    var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegex.test(String(_email).toLowerCase());
  },
  url: function url(_url) {
    var regex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/ig;
    return regex.test(String(_url));
  }
};

theme.modal = function () {
  var closer = function closer() {
    $('body').removeClass('modal-open');
    $('.rs-modal').removeAttr('tabindex');
    $(document).off('focusin').off('keydown', escaper); //not sure as the cleanup is particularly necessary

    $('#BgModal').hide().off('click', closer);
    $('#FgModal').removeClass('open');

    if ($('#FgModal').hasClass('open-init')) {
      $('#FgModal').removeClass('open-init');
    }

    setTimeout(function () {
      $('#FgModal').remove(); //may not exist  
    }, 200);
  };

  var escaper = function escaper(e) {
    e = e || window.event;

    if (e.key === 'Escape' || e.keyCode === 27) {
      closer();
    }
  };

  function show($container) {
    $('body').addClass('modal-open');
    $container.addClass('rs-modal'); //is that enough to bump it up to the page's positioning? Move the content into BgModal, otherwise

    $('#BgModal').show().on('click', closer);
    $container.focus();
    $container.attr('tabindex', '-1');
    $(document).on('focusin', function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
    $(document).on('keydown', escaper);
    $(document).trigger('opened.modal', [$container]);
  }

  return {
    /** shows modal with a title and an X button. (nobody has ever wanted a title.) */
    modal: function modal($container, className) {
      var isOpen = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var customClose = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var callback = arguments.length > 4 ? arguments[4] : undefined;
      $('body').append('<div id="FgModal" role="dialog"><span class="closer"><svg id="modal__close" class="close_icon" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99.12 99.12"><title>Close</title><line class="close__line close__line_1" x1="1.06" y1="1.06" x2="98.06" y2="98.06" style="fill:none;stroke-miterlimit:10;stroke-width:6px"></line><line class="close__line close__line_2" x1="1.06" y1="98.06" x2="98.06" y2="1.06" style="fill:none;stroke-miterlimit:10;stroke-width:6px"></line></svg></span><div></div></div>');
      var $modal = $('#FgModal');
      if (isOpen) $('body').addClass('modal-open');
      $container.appendTo($('#FgModal > div')); //was insert, doesn't seem to exist

      if (!customClose) $('#FgModal > .closer').on('click', closer);
      $modal.addClass(className);
      if (isOpen) $modal.addClass('open');
      if (isOpen) show($modal);
      if (isOpen) $('#BgModal').show();
      $('#BgModal').on('click', closer);

      if (callback && typeof callback == "function") {
        callback();
      }
    },

    /** shows containers without an X or title */
    show: show,
    hide: function hide() {
      closer();
    }
  };
}();

theme.wishlist = function () {
  var keyname = 'rs_wishlist';
  /* local storage version:
  pros:
    doesn't require customer tracking
  cons:
    doesn't follow the user around
    public manchine?
  */

  var getList = function getList() {
    var a = localStorage.getItem(keyname),
        b = [];

    if (a && a.length) {
      b = JSON.parse(a);
    }

    return b;
  };

  return {
    /** returns an array of Products
      note: while this may contain available:true, inventory data, don't use that info in displaying a wishlist list, as it may not be up to date.
    */
    load: function load() {
      //might also lookup the current product info now
      return getList();
    },

    /** stores that product */
    save: function save(product) {
      //could possibly store the product id only, and then lookup the product later.
      var b = getList();

      if (b) {
        b.append(product);
        localStorage.setItem(keyname, JSON.stringify(b));
      } //TODO: GTM?

    },

    /** remove this product from the list */
    remove: function remove(product) {
      var b = getList();

      if (b) {
        localStorage.setItem(keyname, JSON.stringify(b.filter(function (o) {
          return o.id != product.id;
        })));
      } //TODO: GTM?

    },

    /** is this product on the list? */
    isWished: function isWished(product) {
      var b = getList(),
          found = 0;

      if (b) {
        found = b.find(function (o) {
          return o.id == product.id;
        }); //TODO: no IE support for find
      }

      return found;
    }
  };
}();
/* CUSTOM.JS
Provide client-customized JS code.
This is mostly a library for the theme. code used by code inside individual pages.

this could also be directly in theme.liquid & save a download,
or as a separate asyc load

If we have a build process that is always git->slate->theme.min.js, this is fine here.
If it is a min lib, but leaving something editable for end user, this needs to be separate.

Don't actually execute code in here. If you want to run it on start-up, wrap it
pReady.push(function(){
});
Mostly, though, this is just defining functions that will be used by the
theme's code or by the code on a page.
*/

/*
Developer checklist:

Create filters
  Either manually, or tweak the generators to meet client needs
  Note there are 2 locations with filters:
Tweak Product Renderer to taste



*/


theme.productRenderer =
/** produce the html for the grid. This is the missing product-grid.liquid.
This is generally standardized, but consider adding new functionality here.
This is also a unique feature of the theme, and can be extended far beyond a grid of products.
Such as:
 reduce lists of related products to a single product
 expand product with complex variants into multiple listings
 produce filterable images (front-view, back-view)
 a buy now button
 rows, with 1 product but X number of images displayed
 tables, for spec driven products

This is both a lot of standard stuff and a big point of customization.
If we don't have a nice build system, this should not be in the .min.
*/
function (isBundle) {
  function renderSwatches(product, variants) {
    var html = "";

    if (product.bundleProduct.variants && !slate.utils.isObjEmpty(product.bundleProduct.variants)) {
      html = Object.keys(product.bundleProduct.variants).reduce(function (a, shade) {
        var shadeHandle = shade.replace(/\s+/g, '-').toLowerCase();
        a += "<div class=\"rs-swatch shade shadeHandle ".concat(shade === product.currentShade ? 'selected' : '', "\" data-shade=\"").concat(shade, "\"><div class=\"shade-middle\"><div class=\"shade-inner\"><div class=\"shade-bg ").concat(shadeHandle, "\" /></div></div></div>");
        return a;
      }, "");
    }

    return html;
  } //Alt swatch function, use for buy now tech


  function renderSwatchesBuyNow(product, variants) {
    //one variant option only with this code:
    var html = '<ul class="rs-swatch submenu rs-and" data-option="1" data-tag="' + product.id + '">';
    $.each(variants, function (i, variant) {
      var o = variant.option1;

      if (variant.available) {
        html += '<li class="rs-or swatch-item filter-item ' + o.toLowerCase() + '"'; //|handle

        html += ' data-tag="' + o + '"><span><span class="visually-hidden">' + o + '</span></span></li>';
      }
    });
    html += '</ul>';
    return html;
  } //kind of confusing: while it is not possible to have the noJS form here, the select list is the ultimate storage of the variant id
  //Buy now tech


  function renderNoJS(product) {
    var html = '<select name="id" class="no-js product-select" id="SingleOptionSelector-' + product.id + '">';
    $.each(product.variants, function (i, variant) {
      html += '<option value=' + variant.id + '>' + variant.title + '</option>';
    });
    html += '</select>';
    return html;
  }

  function renderSticker(product) {
    var html = '';

    if (product.bundleProduct.variants[product.currentShade][product.currentType].metafields.sticker && product.bundleProduct.variants[product.currentShade][product.currentType].metafields.sticker.length) {
      html = "<div class=\"sticker badge badge-kwred\">".concat(product.bundleProduct.variants[product.currentShade][product.currentType].metafields.sticker, "<div class=\"stickerMinus\"></div></div>");
    } else {
      html = '<div class="notsticker"></div>';
    }

    return html;
  }

  function renderSale(product) {
    var html = '';

    if (product.available) {
      if (product.price < product.compare_at_price) {
        html += '<div class="sale-item icn">' + theme.strings.sale + '</div>';
      }
    } else {
      html += '<div class="so icn">' + theme.strings.soldOut + '</div>';
    }

    if (product.template_suffix == 'pre-order') {
      html += '<div class="pre-order icn">' + theme.strings.preorder + '</div>';
    }

    return html;
  }

  function fetchImgRendition(imgUrl, size) {
    // use slate.Image.getSizedImageURL. I'm not sure what this actually does. Seems to be the same thing.
    if (imgUrl) {
      var urlParts = imgUrl.split('/');
      var imgParts = urlParts.length ? urlParts[urlParts.length - 1].split('.') : '';
      if (imgParts[imgParts.length - 2]) imgParts[imgParts.length - 2] = imgParts[imgParts.length - 2] + '_' + size;
      urlParts[urlParts.length - 1] = imgParts.join('.');
      return urlParts.join('/');
    }

    return false;
  }

  function renderPriceByVariant(product, filterOptions) {
    var PriceUSD = product.bundleProduct.priceRanges['USA'][product.currentType].min;
    var PriceEUR = product.bundleProduct.priceRanges['EUR'][product.currentType].min;
    var ComparePrice = product.bundleProduct.variants[product.currentShade][product.currentType].compare_at_price;
    return "<offer itemprop=\"offers\" itemscope itemtype=\"http://schema.org/Offer\">\n              <meta itemprop=\"priceCurrency\" content=\"".concat(theme.currency, "\">\n              <div itemprop='price' class='variantPrice' data-price-element data-price-usd=\"from ").concat(slate.Currency.formatMoney(PriceUSD, theme.moneyFormat), "\">from ").concat(slate.Currency.formatMoney(PriceUSD, theme.moneyFormat), "</div>\n            </offer>");
  }

  function renderPrice(product, variants) {
    var PriceUSD = product.bundleProduct.priceRanges['USA'][product.currentType].min;
    var PriceEUR = product.bundleProduct.priceRanges['EUR'][product.currentType].min;
    var ComparePrice = product.bundleProduct.variants[product.currentShade][product.currentType].compare_at_price;
    return "<offer itemprop=\"offers\" itemscope itemtype=\"http://schema.org/Offer\">\n              <meta itemprop=\"priceCurrency\" content=\"".concat(theme.currency, "\">\n              <span itemprop=\"price\" class=\"product-price\" data-price-element data-price-usd=\"from ").concat(slate.Currency.formatMoney(PriceUSD, theme.moneyFormat), "\">from ").concat(slate.Currency.formatMoney(PriceUSD, theme.moneyFormat), "</span>\n            </offer>");
  }

  function renderAnchor(product) {
    return "href=\"/products/".concat(product.bundleProduct.variants[product.currentShade][product.currentType].handle, "\" title=\"").concat(product.bundleProduct.title, "\"");
  }

  function renderAnchorKit(product) {
    return "href=\"/collections/".concat(product.bundleProduct.variants[product.currentShade][product.currentType].handle, "\" title=\"").concat(product.bundleProduct.title, "\"");
  }

  function renderVariantInfo(product) {
    return "<div class='variantInfo'>".concat(product.currentShade, "</div>");
  }

  function filterImgs(product) {
    //now return all images of the first product in the variants object
    var variants = product.bundleProduct.variants[product.currentShade];
    return variants[Object.keys(variants)[0]].images; //this returned the first images of the first and second product in the variant
    // return Object.keys(product.bundleProduct.variants[product.currentShade]).reduce((a, type) => {
    //   let p = product.bundleProduct.variants[product.currentShade][type];
    //   if (p && p.media) a.push(p.media[0].src);
    //   return a;
    // }, []);
  }

  function getVariantImages(product, variant_id) {
    var selected_variant = $(product.variants).filter(function (i, variant) {
      return variant.id == variant_id;
    });
    if (selected_variant.length == 0) return [];
    selected_variant = selected_variant[0];
    if (!(selected_variant && selected_variant.featured_image && selected_variant.featured_image.src)) return [];
    var thisFeatured = imageFileName(selected_variant.featured_image.src);
    var otherFeatureds = $(product.variants).filter(function (i, variant) {
      return variant.id != variant_id;
    });
    otherFeatureds = $(otherFeatureds).map(function () {
      if (this.featured_image) return imageFileName(this.featured_image.src);
    });
    otherFeatureds = $.makeArray(otherFeatureds);
    var foundFirst = false;
    var foundLast = false;
    var imgs = [];
    $(product.images).each(function (i, img) {
      var thisImg = imageFileName(img);
      if (thisFeatured == thisImg) foundFirst = true;
      if (foundFirst && otherFeatureds.indexOf(thisImg) > -1) return false; //foundLast = true;

      if (foundFirst && !foundLast) {
        imgs.push(img);
      }
    });
    return imgs;
  }

  function imageFileName(image) {
    var firstpartofImageUrl = '/products/'; //find more reliable way to get name of image to match

    var lastpartofImageUrl = ['.jpg', '.gif', '.png'];
    var sindex = image.indexOf(firstpartofImageUrl);
    if (sindex == -1) return image;
    var imgP = image.substring(sindex + firstpartofImageUrl.length);
    $(lastpartofImageUrl).each(function () {
      sindex = imgP.indexOf(this);
      if (sindex != -1) return false;
    });
    if (sindex == -1) return image;
    imgP = imgP.substring(0, sindex);
    return imgP;
  }

  function filterVars(product, filterOptions) {
    var out = [];

    if (product.variants.length && filterOptions != null) {
      //will need custom code here
      //sample, assuming variant.option1 is color, and there is a matching color filter.
      //note the similarity to filter images.
      var cs = filterOptions['color'];

      if (cs === undefined || cs.length == 0) {
        return product.variants;
      }

      for (i in product.variants) {
        for (j in cs) {
          if (cs[j] == product.variants[i].option1) {
            out.push(product.variants[i]);
            break;
          }
        }
      }
    }

    return out;
  }

  function renderQuickAdd(product) {
    return "<a class=\"quickadd link--underlined\" onclick=\"\">Quick Add</a>"; //should not be an a href to the quickview, or at least rel=nofollow
  }

  function renderStarRatings(product) {
    var currentVariant = product.bundleProduct.variants[product.currentShade][product.currentType].id;
    return "<div class=\"collection-item__ratings star-ratings\" data-initRating=\"".concat(currentVariant, "\"></div>");
  }

  function getVariantId(product) {
    var selectedVariant = product.bundleProduct.variants[product.currentShade][product.currentType].variants[0];
    var _variantId = selectedVariant.id;
    return _variantId;
  }

  function renderQuickviewButton(product) {
    return "<button class=\"quickview\" onclick=\"theme.quickviewer.showurl(".concat(renderAnchor(product), "?view=quick)\">Quick View</button>"); //should not be an a href to the quickview, or at least rel=nofollow
  }

  function renderMeta(product, imgs) {
    return "<meta itemprop=\"name\" content=\"".concat(product.bundleProduct.title, "\">\n            <meta itemprop=\"url\" content=\"").concat('https://' + location.host + '/products/' + product.bundleProduct.variants[product.currentShade][product.currentType].handle, "\">\n            <meta itemprop=\"brand\" content=\"").concat(product.bundleProduct.variants[product.currentShade][product.currentType].vendor, "\">\n            <meta itemprop=\"image\" content=\"").concat(fetchImgRendition(imgs[0], '600x600'), "\">\n            <meta itemprop=\"description\" content=\"").concat(product.bundleProduct.description ? product.bundleProduct.description.replace(/"|<.*?>/g, '') : '', "\">");
  }

  function renderFavorite(product) {
    return "<button \n    data-with-epi=\"true\" \n    data-variant-id=\"".concat(product.bundleProduct.variants[product.currentShade][product.currentType].variants[0].id, "\"  \n    class=\"\" \n    data-swaction=\"addToWishlist\" \n    data-product-id=\"").concat(product.bundleProduct.variants[product.currentShade][product.currentType].id, "\"\n  >                  \n  <svg class=\"icon icon-bookmark-checked\"><use href=\"#icon-bookmark-checked\"></use></svg>\n  <svg class=\"icon icon-bookmark\"><use href=\"#icon-bookmark\"></use></svg>\n  </button>");
  }

  function renderStars(product) {
    return "<div class=\"yotpo bottomLine\" style=\"display:inline-block\"\n        data-appkey=\"".concat(theme.yotpo_key, "\"\n        data-product-id=\"").concat(product.bundleProduct.variants[product.currentShade][product.currentType].id, "\">\n      </div>");
  }

  function renderBuyNow(product, variants) {
    if (!product.available) {
      return '';
    }

    if (variants && variants.length > 1) {
      return "<div class=\"buynow select-needed\" data-option=\"1\">\n                <form data-product-id=\"'+product.id+'\">\n                  ".concat(renderSwatches(product, variants), "\n                  <div style=\"display:none\" class=\"hidden-selectors\"></div>'\n                  <input type=hidden value=1 name=quantity>'\n                  ").concat(renderNoJS(product), "\n                  <button type=\"submit\" name=\"add\" class=\"add-to-cart cta disabled\">").concat(theme.strings.addToCart, "</button>\n                </form>\n              </div>");
    } else {
      return "<div class=\"buynow1\">\n                  <form>\n                    <input type=hidden name=id value=\"".concat(variants[0].id, "\">\n                    <input type=hidden value=1 name=quantity>\n                    <button type=\"submit\" name=\"add\" class=\"add-to-cart cta\">").concat(theme.strings.addToCart, "</button>\n                  </form>\n                </div>");
    }
  }

  function renderMain(product, imgs) {
    if (!imgs[0]) {
      return '';
    }

    return "<div class=\"default\">\n              <img src=\"".concat(fetchImgRendition(imgs[0], 'large'), "\" alt=\"").concat(product.bundleProduct.title.replace('"', '&quote;'), "\">\n            </div>");
  }

  function renderReveal(product, imgs) {
    if (!imgs[1]) {
      return '';
    }

    return "<div class=\"reveal\">\n              <img src=\"".concat(fetchImgRendition(imgs[1], 'large'), "\" alt=\"").concat(product.bundleProduct.title.replace('"', '&quote;'), "\">\n            </div>");
  }

  return {
    /**
    requires the js product, + an optional array of filtered variants (product.variants) to produce a price range
    */
    renderPrice: renderPrice,
    //could be used a lot of places
    renderGrid: function renderGrid(index, product, filterOptions, productCount) {
      //BETTER: get the filtered variant(s), change PRICE with the images.
      // maybe add a (3 variants) label?
      console.log(product);

      if (!product.bundleProduct.variants || slate.utils.isObjEmpty(product.bundleProduct.variants)) {
        return '';
      }

      var imgs = filterImgs(product, filterOptions);
      var variants = filterVars(product, filterOptions);
      var gridItem = "<div class=\"product-index f4-12 small--f6-12 collection-item\" data-product=\"".concat(product.bundleProduct.title, "\">\n        <div class=\"prod-container\" itemscope itemtype=\"http://schema.org/Product\">\n          ").concat(renderMeta(product, imgs), "\n          ").concat(renderSticker(product), "\n          <div class=\"prod-image\">\n            <a class=\"variantLink\" ").concat(renderAnchor(product), ">").concat(renderMain(product, imgs)).concat(renderReveal(product, imgs), "</a>\n          </div>\n        </div>\n        <div class=\"product-index__info\">\n        <div class=\"product-info collection-item__info\">\n          <div class=\"collection-item__variantTitle\">").concat(renderVariantInfo(product, filterOptions), "</div>\n          <a ").concat(renderAnchor(product), "><h3 class=\"collection-item__title\">").concat(product.bundleProduct.title, "</h3></a>\n          ").concat(renderStarRatings(product), "\n          <div class=\"collection-item__swatches shades flex\"></div>\n          <div class=\"collection-item__price price\">").concat(renderPriceByVariant(product, filterOptions), "</div>\n          <a class=\"collection-item__quickadd\"><div class=\"quickAdd  link--underlined\">Quick Add</div></a>\n        </div>              \n        <div class=\"product-favorite\">").concat(renderFavorite(product), "</div>\n        </div>\n        </div>");

      if (product.bundleProduct.is_kit) {
        gridItem = "<div class=\"product-index f4-12 small--f6-12 collection-item\" data-product=\"".concat(product.bundleProduct.title, "\">\n            <div class=\"prod-container\" itemscope itemtype=\"http://schema.org/Product\">\n              ").concat(renderMeta(product, imgs), "\n              ").concat(renderSticker(product), "\n              <div class=\"prod-image\">\n                <a class=\"\" ").concat(renderAnchorKit(product), ">").concat(renderMain(product, imgs)).concat(renderReveal(product, imgs), "</a>\n              </div>\n            </div>\n            <div class=\"product-index__info\">\n            <div class=\"product-info collection-item__info\">\n              <div class=\"collection-item__variantTitle\"><div class='variantInfoKit'>").concat(product.bundleProduct.subtitle, "</div></div>\n              <a ").concat(renderAnchorKit(product), "><h3 class=\"collection-item__title\">").concat(product.bundleProduct.title, "</h3></a>\n              <div class=\"collection-item__price price\">").concat(renderPriceByVariant(product, filterOptions), "</div>\n            </div>              \n            </div>\n          </div>");
      }

      if (isBundle) {
        gridItem = "\n          <div class=\"accordion-panel ".concat(index > 0 ? 'locked' : '', "\" data-index=\"").concat(index, "\">\n            <div class=\"accordion-banner space-between\">\n              <div class=\"accordion-title\">").concat(index + 1, ". <a ").concat(renderAnchor(product), " class=\"accordion-title__type\">").concat(product.bundleProduct.title, "</a> - <span class=\"accordion-title__cta\">Choose Shade</span></div>\n              <div class=\"toggle-icon\"> \n                <div class=\"horizontal\"></div>\n                <div class=\"vertical\"></div>\n              </div>\n            </div>\n            <div class=\"accordion-body shades-container enabled\">\n\n\n            <div class=\"product-index\"  data-product=\"").concat(product.bundleProduct.title, "\">\n              <div class=\"kit-item\" data-variant=\"").concat(getVariantId(product), "\">\n                <div class=\"kit-item__description\">").concat(product.bundleProduct.description, "</div>\n                <div class=\"prod-container\" itemscope itemtype=\"http://schema.org/Product\">\n                  <div class=\"prod-image\">\n                    <a class=\"variantLink\" ").concat(renderAnchor(product), ">").concat(renderMain(product, imgs), "</a>\n                  </div>\n                  <div class=\"shades flex\"></div>             \n                  <div class=\"kit-item__variantTitle collection-item__variantTitle\">").concat(renderVariantInfo(product, filterOptions), "</div>\n                </div>\n                <button class=\"btn button-primary kit-item__nextStep\">Continue</button>\n              </div>\n            </div><!-- .kit-item --> \n\n            \n\n            </div>\n          </div>");
      }

      return gridItem;
    },
    renderProduct: function renderProduct(product, variants) {
      return "<h1>".concat(product.bundleProduct.title, "</h1>\n            <p>").concat(product.vendor || "Kjaer Weis", "</p>\n            <div class=\"price\">").concat(renderPrice(product, variants), "</div>");
    },
    renderSwatchList: function renderSwatchList(swatchlist, classes) {} //TODO: given what we know about swatches, produce a full list of Swatches
    //such as turning theme.swatches into a UL automatically, then putting this into the filter-menu
    //could also be a linked list? MWK has 4 lists, 2 swatches, 2 checkboxes.
    // the swatch block can only do 1? YAML? JSON?
    // could always add the checkbox(es), just hide it for swatches...
    // need 2 or 3 columns, more than you can put in a menu.
    //  put the commas in the title?
    //TODO: put the json in the swatch section, but also provide an app to generate that json out of spreadsheet text.
    //sample:
    //foreach swatchlist as (readable, tag, color) {
    //  '<li class="'+classes+' '+color+'" data-tag="'+tag+'">'+readable+'</li>';

    /* - optional (even if empty, this will run for every product, so leave it commented)
    As noted, this is a less than ideal way of making sure people don't see things, so try to do this
    before doing this.
    ,
    /**
    stop downloaded products from showing up on the list
    Remember, obscurity is not security. Just because poeple can't see the product
    in the collection doesn't mean they won't see the data in the network log.
    *  /
    filterProduct: function(product) {
      if (!product.images || product.images.length === 0) {return false}
      if (!product.available && (product.variants.map(function(o){return o.inventory_policy === 'deny'}).reduce(function(a, c){return a || c}, false))) {return false;}
      return true;
    }
    */

  };
};

theme.CUSTOM_FILTERS = {
  /*
  function tags, product
  return true if the product is acceptable to _any_ of the selected tags
  
  By default, the filtering only looks at product.tag equality
  Other options include looking at other strings, or ranges,
  or conditions like "low stock" or "recently added".
  Anything added here is something no other Shopify theme has!
  
  sample:
    function sampleVariantSearch(ortags, obj){
      var or = false;
      $.each(typeof ortags == 'object' ? ortags : [ortags], function (i, tag) {
        $.each(obj.variants, function (j, v) {
          if (v.available == false) {
            return true;//exclude this variant
          }
          if (tag == v.option1||tag == v.option2) {
            or = true;
            return false;//won't break out of the outer loop :(
          }
        });
      });
      return or;
    }
    function samplePriceSearch(ortags, obj){
      var or = false;
      $.each(typeof ortags == 'object' ? ortags : [ortags], function (i, tag) {
        var explode = tag.split('-') //where tags are in the form of "20-40"
        if ((explode[0] == '' || obj.price >= explode[0]+'00') && (explode[1] == '' || obj.price <= explode[1]+'00')) {
          or = true;
          return false;
        }
      });
      return or;
    }
    define that, then put this here:
  
    price: samplePriceSearch,
    size: sampleVariantSearch,
    color: sampleVariantSearch
  
  
  
  Other fun filters:
  Inventory management
  function hide_unavilable(tags, product) {
    return product.available;
    //no tags! this only gets run if the one and only tag gets checked.
  }
  function inventory(tags, product) {
    //this might have in-stock(checked by default)/back-order/out-of-stock
    if (product.available && tags.includes('in-stock'){
      return true;
    }
    if (!product.available && tags.includes('back-order') {
      return true;
    }
    if (!product.available && tags.includes('out-of-stock')
    && (product.variants.map(function(o){return o.inventory_policy === 'deny'}).reduce(function(a, c){return a || c}, false))) {return '';}
      return true;
    }
    return false;
  }
  Color: function (ortags, obj){
    //use the generic colors
    var or = false;
    $.each(typeof ortags == 'object' ? ortags : [ortags], function (i, tag) {
      $.each(obj.variants, function (j, v) {
        if (v.available == false) {
          return true;//exclude this variant
        }
        if (tag == v.option1) {
          or = true;
          return false;//won't break out of the outer loop :(
        }
  
        if (theme.shades) {
        var generic = theme.shades[v.option1];
          if (generic && v.option1 == tag) {
            or = true;
            return false;
          }
        }
      });
    });
  
    Don't forget to remove dev comments for production!
    */
  //
  //Thought: return count of or matches, sort accordingly.
};
theme.CUSTOM_FILTERS_STRINGS = {
  /* If you have a list of selected filters that is not the filter menu items themselves,
  you may want customized labels. Add that here.
  See also section.settings.show_filters
  
  sample:
     'price':function(ortag){//where the tags are in the form 'XX-YY'
       if (ortag == '-250') return 'Under $250'
       if (ortag == '5000-') return 'Over $5000'
       var _ = ortag.split('-');
       return '$'+_[0]+' - $'+_[1];
   }
   */
};
/**
 * does this image match the color?
 * This is very client specific and may involve a certain amount of magic
 @param str
 @param img_url
 @return boolean
 */

theme.isImageStrRelated = function (str, img_url, img_alt) {
  return img_alt == str || img_url.includes('-' + encodeURIComponent(str) + '.jpg'); //rules on how to handle ' ', would need to adapt to the specific files.
  //rules for -color- or _color.jpg
  //could be variant sku, color->code lookup table, etc.
  //could also look at the href, variant.option1, variant.sku, etc.
};
/**
 * Something about this variant is related to the product image urls.
 * Probably the option with the color in it, but could be name, sku, a table lookup.
 * Don't need to worry about encoding it, as it gets passed into isImageStrRelated
 @param variant
 @return string
 */


theme.getImageCodeFromVariant = function (variant) {
  //will need to match client specific data
  //Using generic color images->
  // if (theme.shades) {
  //   for (var swatch in theme.shades) {
  //     if (swatch == variant.option1) {
  //       return theme.shades[swatch].color;
  //     }
  //   }
  // }
  return variant.option1; //Assumes: the variant images are the only ones the product has, and they don't have related names: return the variant image name
  //return variant.featured_image.src.match(/products\/(.*?)\.jpg/)[1];
};

theme.initTooltip = function () {
  var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.tooltip';
  var theme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['tooltipster-shadow', 'tooltipster-shadow-customized'];
  $(selector).tooltipster({
    maxWidth: 380,
    theme: theme,
    trigger: 'click',
    distance: 20
  });
};

pReady.push(function () {
  if (sessionStorage.getItem("promo-state") == "closed") {
    $(".promo-bar").hide();
  } //Validate input data footer newsletter


  function validateEmail(email, showError) {
    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;

    if (!emailReg.test(email) || email.length < 6) {
      $('.subscribe_bdate').hide('fast');
      $('.subscribe_bdate input').val('');

      if (showError) {
        $('.email__error').css('display', 'block');
      }
    } else {
      $('.subscribe_bdate').show('slow');
      $('.email__error').hide('slow');
    }
  }

  $(document).on('keyup click', '.footer__newsletter input[name="email"]', function () {
    var $email = this.value;
    validateEmail($email);

    if ($('.footer__newsletter.focused').length > 0) {
      validateEmail($email, true);
    }
  }).on("focusout", '.footer__newsletter input[name="email"]', function () {
    $('.footer__newsletter ').addClass('focused');
    var $email = $('.footer__newsletter input[name="email"]').val();
    validateEmail($email, true); // Do Checking accordingly 
  });
  $(document).on('click', '#email_subscribe input[type="submit"]', function () {
    if ($('.newsletter_condition input').is(":checked")) {
      $('.condition__error').hide('slow');
    } else {
      $('.condition__error').css('display', 'block');
    }
  });
  $(document).on('click', '.newsletter_condition input', function () {
    if ($('.newsletter_condition input').is(":checked")) {
      $('.condition__error').hide('slow');
    } else {
      $('.condition__error').css('display', 'block');
    }
  });

  if (screen.width <= 749 && window.matchMedia("(orientation: portrait)").matches) {
    $(".newsletter_condition").insertAfter(".subscribe_bdate");
    $(".footer_menu_2").insertAfter(".footer__newsletter form");
    $(".footer_menu_3").insertAfter(".footer_menu_2");
  } //Handling Promobar height change


  $('#promo__close').on('click', function () {
    $('[data-section-id="header"] .promo-bar').slideUp('fast', function () {
      adjustMobileNavHeight();
      sessionStorage.setItem("promo-state", "closed");
    });
  });

  function adjustMobileNavHeight() {
    var height_of_header = $('[data-section-id="header"]').height();
    $('#NavDrawer').css({
      'top': height_of_header
    });
  }

  adjustMobileNavHeight(); //Making mobile menu

  $('#NavDrawer li.has-submenu').on('click', function (e) {
    var $this = $(this);
    $this.addClass('submenu__opened');
    $this.parents('.mobile__menu_ham').addClass('menu_first_open');
  });
  $(document).on('click', '#NavDrawer .for__back', function (e) {
    event.stopPropagation();
    var $this = $(this);
    $this.parents('.submenu__opened').removeClass('submenu__opened');
    $this.parents('.mobile__menu_ham').removeClass('menu_first_open');
  });
});
/***
 * PDP IMAGE ZOOM
 */

pReady.push(function () {
  var ZoomModal = {
    open: function open(html) {
      $('body').css('overflow', 'hidden');
      $('.zoom__modal').addClass('is--opened');
    },
    close: function close() {
      $('body').css('overflow', 'auto');
      $('.zoom__modal').removeClass('is--opened');
    }
  };
  $(document).on('click', '.pslider_big img', function () {
    var ZoomHtml = '';

    if ($('.js-zoom-items').is(':empty')) {
      if (screen.width < 1024) {
        $('.pslider_big .slick-slide:not(.slick-cloned) img').each(function () {
          var getImageSrc = $(this).attr('src');
          ZoomHtml += '<div class="zoom__modal--item">';
          ZoomHtml += '<img src="' + getImageSrc + '" alt="Image" />';
          ZoomHtml += '</div>';
        });
      } else {
        $('.pslider_big img').each(function () {
          var getImageSrc = $(this).attr('src');
          ZoomHtml += '<div class="zoom__modal--item">';
          ZoomHtml += '<img src="' + getImageSrc + '" alt="Image" />';
          ZoomHtml += '</div>';
        });
      }

      $('.js-zoom-items').html(ZoomHtml);
      ZoomModal.open();
    } else {
      $(".zoom__modal").scrollTop(0);
      ZoomModal.open();
    }
  });
  $(document).on('click', '.js-zoom-close', function () {
    ZoomModal.close();
  });
});
/* end custom.js */

theme.yotpo = {
  refreshWidgets: function refreshWidgets(cb, delay) {
    var yotpoApi = new Yotpo.API(yotpo);
    yotpoApi.refreshWidgets();

    if (cb && typeof cb === 'function') {
      if (!delay) delay = 300;
      setTimeout(function () {
        cb();
      }, delay);
    }
  },
  updateGalleryId: function updateGalleryId($container, mobileMaxWidth) {
    var galleryIdDesktop = $container.attr('data-yotpo-gallery-id');
    var galleryIdMobile = $container.attr('data-yotpo-gallery-id-mobile');
    var $gallery = $('.yotpo-pictures-widget', $container);
    var galleryId;

    if ($(window).width() > mobileMaxWidth) {
      galleryId = galleryIdDesktop;
    } else {
      galleryId = galleryIdMobile ? galleryIdMobile : galleryIdDesktop;
    }

    $gallery.attr('data-gallery-id', galleryId);
    theme.yotpo.refreshWidgets();
  },
  debounceUpdateGalleryId: theme.debounce(function ($container, mobileMaxWidth) {
    theme.yotpo.updateGalleryId($container, mobileMaxWidth);
  }, 500),
  galleryIdUpdateResizeHandler: function galleryIdUpdateResizeHandler($container, mobileMaxWidth) {
    $(window).on('resize', function () {
      theme.yotpo.debounceUpdateGalleryId($container, mobileMaxWidth);
    });
  }
};

theme.bisModalFactory = function () {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var BisModal = {};
  var cachedElems = {};
  var defaults = {
    container: '#bisModal',
    selectors: {
      global: {
        body: 'body',
        bgModal: '#bisModalBg',
        bisModalClose: '[data-action="close-bis-modal"]'
      },
      modal: {
        modalContent: '.bis-modal__contents',
        bisModalCloseIcon: '#bis-modal__close',
        form: '#bisForm',
        email: '[name="email"]',
        productTitle: '.bis-modal__title',
        productId: '[name="product"]',
        variantId: '[name="variant"] option:selected',
        errorMsg: '#error_message',
        successMsg: '#completed_message',
        ctaContainer: '.bis-modal__cta-container',
        submit: '[data-action="submit-bis"]',
        validations: '[data-validate-msg]'
      }
    }
  };
  var selectors = config.selectors ? config.selectors : defaults.selectors;
  var containerSelector = config.container ? config.container : defaults.container;
  /**
   * init
   * @summary calls all methods necessary to initialize BisModal
   * @returns {Undefined}
  */

  BisModal.init = function () {
    BisModal.initCachedElems(containerSelector, selectors);
    BisModal.triggerHandler();
    BisModal.submitHandler();
  };
  /**
   * initCachedElems
   * @summary set the modal container element and add to cachedElems object. Add
   *  modal elements and non-modal elements to cachedElems object
   * @param {String} modalContainer - jQuery selector for modal element
   * @param {Object} selectors - jQuery element selectors. Object keys used as
   *  cachedElems object keys
   * @returns {Undefined}
  */


  BisModal.initCachedElems = function (modalContainer) {
    var selectors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    cachedElems.$bisModal = $(modalContainer);
    BisModal.initElems(selectors.global);
    BisModal.initElems(selectors.modal, cachedElems.$bisModal);
  };
  /**
   * initElems
   * @summary Add elements to the cachedElems object.
   * @param {Object} selectors - jQuery element selectors
   * @param {Object} $container - A DOM Element, Document, or jQuery to use as context
   * @returns {Undefined}
  */


  BisModal.initElems = function () {
    var selectors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var $container = arguments.length > 1 ? arguments[1] : undefined;
    var keys = Object.keys(selectors);
    keys.forEach(function (key) {
      var $elem = $(selectors[key], $container);
      if ($elem && $elem.length) cachedElems['$' + key] = $elem;
    });
  };
  /**
   * open
   * @summary modal open handler
   * @param {Object} product - current product info to pass to BisModal.updateForm
   * @param {String} product.productId - product id
   * @param {String} product.variantId - product variant id
   * @param {String} product.productTitle - product title
   * @returns {Undefined}
  */


  BisModal.open = function (product) {
    var $bisModal = cachedElems.$bisModal; // Update modal with product info

    if (product) BisModal.updateForm(product); // Register click handler on modal background & close

    $(document).on('click', selectors.global.bisModalClose, BisModal.close);
    $(document).on('click', selectors.modal.bisModalCloseIcon, BisModal.close);
    $bisModal.attr('tabindex', '0');
    cachedElems.$bgModal.show('fast', function () {
      cachedElems.$bgModal.addClass('bis-modal--open');
    });
    $bisModal.show('fast', function () {
      $bisModal.addClass('bis-modal--open'); // Focus & trap focus inside modal for keyboard accessibilty

      $bisModal.focus();
      slate.a11y.altTrapFocus({
        $container: $bisModal,
        handlerTarget: selectors.bisModal,
        focusFirst: false
      }); // Can't focus on elements that aren't visible, so use setTimeout to wait
      // for modal and elements to be visible. The opacity transition of the modal
      // is 6 seconds.

      setTimeout(function () {
        cachedElems.$email.focus();
      }, 700);
    });
  };
  /**
   * close
   * @summary modal close handler
  */


  BisModal.close = function () {
    var $bisModal = cachedElems.$bisModal;
    var $bgModal = cachedElems.$bgModal;
    $bgModal.fadeOut('fast', function () {
      $bisModal.removeClass('bis-modal--open');
      $bgModal.removeClass('bis-modal--open'); // Remove trap focus from modal

      slate.a11y.altRemoveTrapFocus($bisModal, selectors.bisModal);
      BisModal.resetFormStates(); // Use setTimeout so smooth transition can happen

      setTimeout(function () {
        $bgModal.removeAttr('style');
        $bisModal.hide().removeClass('bis-modal--open').removeAttr('style').removeAttr('tabindex', '0'); // Unregister click handler on modal background

        $(document).off('click', selectors.bisModalClose, BisModal.close);
        $(document).off('click', selectors.bisModalCloseIcon, BisModal.close);
      }, 700);
    });
  };
  /**
   * triggerHandler
   * @summary register trigger handler for BIS
   * @returns {Undefined}
  */


  BisModal.triggerHandler = function () {
    $(document).on('click', '[data-bis-trigger]', function (e) {
      e.preventDefault();
      var $this = $(this);
      BisModal.triggerAction($this);
    });
  };
  /**
   * triggerAction
   * @summary trigger action for BIS
   * @returns {Undefined}
  */


  BisModal.triggerAction = function ($elem) {
    if ($elem && $elem.length) {
      BisModal.open({
        productId: $elem.attr('data-product-id'),
        variantId: $elem.attr('data-variant-id'),
        productTitle: $elem.attr('data-product-title')
      });
    }
  };
  /**
   * submitHandler
   * @summary BIS modal submit handler
   * @returns {Undefined}
  */


  BisModal.submitHandler = function () {
    var $submit = cachedElems.$submit;
    $submit.on('click', function () {
      var $form = cachedElems.$form;
      var $email = cachedElems.$email;
      var emailVal = $email.val();
      var $validation = $('[data-validate-msg="email"]', $form);
      var formData = $form.serializeArray();
      BisModal.clearMsgElems(); // Email validation

      if (!emailVal || !theme.validate.email(emailVal)) {
        $validation.fadeIn();
        $email.focus();
      } else {
        BIS.create($email.val(), $form.find('[name="variant"]').val(), $form.find('[name="product"]').val(), {
          accepts_marketing: $form.find('[name="subscribe_for_newsletter"]').is(':checked')
        }).then(function (resp) {
          console.log(resp);

          if (resp.status == 'OK') {
            cachedElems.$ctaContainer.fadeOut(400, function () {
              cachedElems.$successMsg.fadeIn();
            });
          } else if (resp.status == 'Error') {
            $('#error_message').text(resp.errors.base[0]).fadeIn(function () {
              setTimeout(function () {
                $('#error_message').fadeOut();
              }, 1000);
            });
          }
        });
        /*         $.ajax({
                  type: "POST",
                  url: 'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe',
                  data: formData,
                  error: function(jqXHR, textStatus, errorThrown) {
                    BisModal.formSubmitErrorHandler(jqXHR, textStatus, errorThrown);
                  },
                  success: function(data) {
                    cachedElems.$ctaContainer.fadeOut(400, function() {
                      cachedElems.$successMsg.fadeIn();
                    });
                  }
                }); */
      }
    });
  };
  /**
   * formSubmitErrorHandler
   * @summary error handler for modal form submission
   * @param {Object} jqXHR - jQuery jqXHR object
   * @param {String} textStatus - jQuery ajax textStatus string
   * @param {String} errorThrown - jQuery ajax errorThrown string
  */


  BisModal.formSubmitErrorHandler = function (jqXHR, textStatus, errorThrown) {
    console.log({
      jqXHR: jqXHR
    });
    console.log({
      textStatus: textStatus
    });
    console.log({
      errorThrown: errorThrown
    }); // Default error message

    var message = 'An error occurred while processing your request.'; // Set message to response error if exists

    if (jqXHR.responseJSON && jqXHR.responseJSON.message) {
      message = jqXHR.responseJSON.message;
    } // Update element text & display


    cachedElems.$errorMsg.html(message);
    cachedElems.$submit.attr('disabled', 'true');
    cachedElems.$errorMsg.fadeIn();
  };
  /**
   * updateForm
   * @summary updates form field values
   * @param {Object} product - current product info to pass to BisModal.updateForm
   * @param {String} product.productId - product id
   * @param {String} product.variantId - product variant id
   * @param {String} product.productTitle - product title
  */


  BisModal.updateForm = function () {
    var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var title = theme.klaviyoBisSettings.modal_title || product.productTitle;
    cachedElems.$productTitle.text(title);
    cachedElems.$productId.val(product.productId);
    cachedElems.$variantId.val(product.variantId);
  };
  /**
   * clearMsgElems
   * @summary hide error, success, & validation messages
   * @returns {Undefined}
  */


  BisModal.clearMsgElems = function () {
    cachedElems.$successMsg.hide();
    cachedElems.$errorMsg.hide();
    cachedElems.$validations.hide();
  };
  /**
   * resetFormStates
   * @summary hide modal messages, enable cta & display
   * @returns {Undefined}
  */


  BisModal.resetFormStates = function () {
    BisModal.clearMsgElems(); // Redisplay cta if hidden

    cachedElems.$ctaContainer.show();
    cachedElems.$submit.removeAttr('disabled');
  };
  /**
   * updateBisTriggerAttrs
   * @summary updates the bis trigger element with modal dependent attributes.
   *  Use with event handler (i.e. 'variantTitleChange' event).
   * @returns {Undefined}
  */


  BisModal.updateBisTriggerAttrs = function (e) {
    var variant = e.variant;

    if (variant && !variant.available) {
      var $trigger = $('[data-bis-trigger]', this.$container);
      $trigger.attr('data-product-title', variant.title);
      $trigger.attr('data-product-id', variant.id);
      $trigger.attr('data-variant-id', variant.variants[0].id);
    }
  };

  BisModal.init();
  return BisModal;
};
/**
 * initThemebisModal
 * @summary use to initialize single theme instance of bisModalFactory
 * @param {Object} config - config for bisModalFactory
 * @returns {Undefined}
*/


theme.initThemebisModal = function () {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (theme.bisModal === undefined) {
    theme.bisModal = theme.bisModalFactory(config);
    $(document).trigger('bisModal:loaded');
  }
};
/**
 Uses the browser's concept of currency instead of the string settings coming from the Shopify
 */


theme.toMoney = function (str) {
  //Eventually: currency translation?
  return parseFloat(str / 100).toLocaleString(undefined, {
    style: 'currency',
    currency: theme.currency,
    currencyDisplay: theme.currencyDisplay
  }); //locale is kind-of slow.
};

theme.toMoneyWhole = function (str) {
  //Eventually: currency translation?
  return parseFloat(str / 100).toLocaleString(undefined, {
    style: 'currency',
    currency: theme.currency,
    currencyDisplay: theme.currencyDisplay,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }); //locale is kind-of slow.
};
/** add +/- buttons around an input
 * requires that the inputs not be siblings
 */


theme.adjusters = function ($container) {
  //decorate the number inputs
  $('input[type="number"]', $container).each(function (i, o) {
    var $o = $(o);
    $o.before('<button class="rs-quant minus">-</button>'); //accessibility?

    $o.after('<button class="rs-quant plus">+</button>'); //accessibility?
  });
  $container.addClass('rs-quant-home'); //test: better, a or b?

  $('.rs-quant', $container).on('click', function (e) {
    //< much better
    //$container.on('click','.rs-quant', function(e) {
    e.preventDefault(); //maybe not a button?

    var $this = $(this),
        $input = $this.siblings('input'),
        value = parseInt($input.val()),
        out;
    !isNaN(value) && (out = value + ($this.hasClass('plus') ? 1 : -1)) >= 0 && $input.val(out);
    value != out && $input.trigger('change'); //This did not seem to be happening automatically.
  });
};
/**
 * Uses theme.isImageStrRelated to check if the image url is visibly.
 * Presumably, the strs is the ['color'] from a selected variant.
 * Bonus feature: if you have x variants, but all the blue are OutOfStock,
 * passing in ['red','green'], the available variants, will nuke any blue imgs.
  @param strs - the selected option for a pre-specified filter
  @param $container jQuery obj which has been initialized with .slick.
  @param $container second jQuery obj which has been initialized with .slick, presumably the "asNavFor" for the first one.
  @return null
 */


theme.filterThumbnails = function (strs, $container, $navFor) {
  //Is very slick dependent, but doesn't have local deps.
  $navFor.slick('slickUnfilter');
  $container.slick('slickUnfilter'); //slick doesn't just filter things, it removes them.

  $navFor.find('.slick-slide.filtered').removeClass('filtered');
  $container.find('.slick-slide.filtered').removeClass('filtered');
  if (strs && strs.length) $container.find('img.js').each(function (i, o) {
    var $o = $(o);
    strs.forEach(function (str) {
      if (theme.isImageStrRelated(str, $o.attr('src') || $o.attr('data-lazy'), $o.attr('alt'))) {
        $o.closest('.slick-slide').addClass('filtered');
      }
    });
  }); //this could probably be done at the same time: the images/slides have the same index

  if (strs && strs.length) $navFor.find('img.js').each(function (i, o) {
    var $o = $(o);
    strs.forEach(function (str) {
      if (theme.isImageStrRelated(str, $o.attr('src') || $o.attr('data-lazy'), $o.attr('alt'))) {
        $o.closest('.slick-slide').addClass('filtered');
      }
    });
  }); //if no matches, show everything rather than nothing.

  if ($container.find('.slick-slide.filtered').length != 0) {
    $container.slick('slickFilter', '.filtered');
    $navFor.slick('slickFilter', '.filtered');
  } //Slider is getting this index value, then going to the actual[index] in the new slides array
  //https://github.com/kenwheeler/slick/issues/515
  //remove this if it ever gets fixed


  $('.slick-slide', $navFor).not('.slick-cloned').each(function (i) {
    $(this).attr('data-slick-index', i); // .data() does NOT work
  });
  $('.slick-slide', $container).not('.slick-cloned').each(function (i) {
    //probably unnessary, but I would like the main image to move the nav slider, should the nav slider ever get big enough.
    $(this).attr('data-slick-index', i); // .data() does NOT work
  }); //even if the image they were looking at was filtered, go to first element.

  $container.slick('slickGoTo', 0); //move the other one?
};

pReady.push(function () {
  //var sections = new slate.Sections();
  //sections.register('product', theme.Product);
  //Does a search for data-section-type="product", then inits theme.Product
  //my preference would be to init product on the product page.
  //more, the first thing product does on init;
  // Stop parsing if we don't have the product json script tag when loading
  // section in the Theme Editor
  //so Sections exists for theme editing, but product does nothing when theme editing?
  // Don't need sections if there's no product here.
  //I'd like to beable to pass more things into Product, but this makes it impossible.
  //Not sure what having this in the Theme editor gets me. I want to do a lot with sections,
  // but I use the schema. Same? Better?
  //remove?
  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));
  $('.in-page-link').on('click', function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  }); // Target tables to make them scrollable

  var tableSelectors = '.rte table';
  slate.rte.wrapTable({
    $tables: $('.rte table'),
    tableWrapperClass: 'rte__table-wrapper'
  }); // Target iframes to make them responsive

  slate.rte.wrapIframe({
    $iframes: $('.rte iframe[src*="youtube.com/embed"],.rte iframe[src*="player.vimeo"]'),
    iframeWrapperClass: 'rte__video-wrapper'
  }); // Apply a specific class to the html element for browser support of cookies.

  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  $('.promo-bar__desktop-text , .promo-bar__mobile-text ').slick({
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000
  });
  setTimeout(function () {
    //background
    //this whole bit might be removed, though I do like being able to throw a slider on random pages, like blog or the home.
    //slick sliders for homepage sections, related products, etc.
    $('.slider_responsive').slick({
      //TODO: port over the old homepage sections, make sure it uses this.
      dots: true,
      //TODO: adjust this accordingly
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [{
        breakpoint: 1024,
        //probably don't need this one
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          //CSS: make mobile full sized, no main image
          slidesToScroll: 1
        }
      }]
    });
    $('.zoomer').zoom(); //not entirely sure about that zoom lib.
    // - also needs integration with thumb clicker
    //MAYBE: both zoom and carousel.
    //- disadvantages: would need to gut the Featured and thumbnail things.
    //  Would need lazy load, given that it is all large images.
    //  Would need to be filterable for variant selection changes
    //  People might also want the thumbnails, need to sync both 2-way
    // could actually have all 3 in the lib, and switch tech based on the settings/css?
    //https://codepen.io/hagiang1305/pen/YpXVgO
    //Could have 2! sliders, one big, lazy loaded, one small thumbnail that can drive the big one. Could filter them both.
    //if the product.js updateProductImage can not update the zoomed image, definitely do this,  remove the featured_image from the js
    // possible problem: zoom on lazy load? Each of the slider items needs to be zoomed separately.
    //  - add/remove zoom on slide switch? Would integrate with the lazy load, too.
    //   - could have med, lg lazy load, depending on screen size. Good for mobile.
    //Make header non transparent 

    function disableTransparent() {
      if ($('.template-index').length || $('.template-404').length || $('.template-collection').length || $('.template-shadefinder-landing').length) {
        $('#shopify-section-header').attr('data-backgroundcolor', 'transparent');
      } else {
        $('#shopify-section-header').attr('data-backgroundcolor', 'white');
        $('#shopify-section-header').attr('data-textcolor', 'charcoal');
      }

      $(document).trigger('header.set');
    } //Making header Sticky


    window.stickyHeader = new StickySidebar('#shopify-section-header', {});
    disableTransparent(); //Reinit Header for device rotation and foldable device if they exist it should work.

    $(window).resize(function () {
      window.stickyHeader.destroy();
      setTimeout(function () {
        window.stickyHeader = new StickySidebar('#shopify-section-header', {});
        disableTransparent();
      }, 500);
    });
  }, 10); //TDOO: modal system
  //Re-use nav drawer's focus code?
  // background layer in theme
  // escape key listener
  // close event.
  //boot up libraries

  theme.cart = new theme.rsCart();
  theme.LeftDrawer = new theme.Drawers('NavDrawer', 'left'); //eventually: consistant caps

  theme.RightDrawer = new theme.Drawers('CartDrawer', 'right', {
    'onDrawerOpen': function onDrawerOpen() {
      theme.cart.showCart('#ajaxcart');
    }
  }); // Header Controllers 

  theme.header = {
    selector: '#shopify-section-header',
    setTextColor: function setTextColor(_textColor) {
      $(this.selector).attr('data-textcolor', _textColor);
    },
    setBackgroundColor: function setBackgroundColor(_backgroundColor) {
      $(this.selector).attr('data-backgroundcolor', _backgroundColor);
    }
  }; //Integrate libraries with page.
  //In general, libraries emit something you need to listen for here, or listen to buttons in the UI to call lib functions.
  //Ideally, don't do actual work here.

  if (window.location.pathname !== '/cart') {
    $('#CartDrawerB').on('click', function (e) {
      e.preventDefault();
      theme.RightDrawer.open(e);
    });
  }

  $('#NavDrawerB').on('click', function (e) {
    e.preventDefault(); //Calculate the height of the header and open the small drawer 

    var height_of_header = $('[data-section-id="header"]').height();
    $('#NavDrawer').css({
      'top': height_of_header
    });
    theme.LeftDrawer.open(e);
  }); //Ajax cart support.

  var cartupdater = function cartupdater($event, cart) {
    bundleBuilder.updateCartCounter(); //$('.CartCount').text((cart.item_count) || 0);//IS line items, not total quantity

    cart.item_count > 0 ? $('#CartDrawerB').removeClass('empty') : $('#CartCount').addClass('empty');
    $('.CartCost').text(theme.toMoney(cart.total_price));

    if (theme.RightDrawer.drawerIsOpen) {
      //theme.cart.showCart('#ajaxcart');
      // - will not want this with a live update
      //are we editing the ajax cart
      if ($('#ajaxcart').length) {
        //while we looking at the cart page?
        theme.cart.showCart('#ajaxcart');
      }
    } else if ($('#shopify-section-cart').length) {
      theme.cart.showCart('#shopify-section-cart');
    }
  };

  $(document).on('cartupdate', cartupdater).on('cartfail', function () {
    $('.carterror').show();
  }); // bind cart submit button
  // $('#cartTemplate').on('submit', 'form', function(e){//form needed? who else is submitting things?
  //   e.preventDefault();
  //   theme.cart.addToCart($(this).serialize())
  //   theme.RightDrawer.open()
  // })
  //intercept the checkout button so it can be logged first.

  $('#ajaxcart, #shopify-section-cart').on('click', 'input[name=checkout]', function (e) {
    console.log('form submitted checkout');
    e.preventDefault(); //submit to GTM first, wait for it to do it's thing.
    //could also add this to the chekout page script

    var doneFunc = function doneFunc() {
      console.log('done func triggered'); //$('#ajaxcart form').append("<input type=hidden name=checkout value=Checkout>");//simulate submitting the checkout button. //TEST: May not be necessary.

      $('#ajaxcart form, #shopify-section-cart form').trigger('submit'); //location.href = '/checkout';
      //smallish issue: if this goes directly to checkout, it isn't submitting changes in the cart.
      //this isn't an issue with traditional RS carts, but it is certainly possible to put notes, editable quantity fields in the cart.
      //could listen to the button, then submit the form
      //smallish issue: the form has both update and checkout buttons, auto-submit isn't actually clicking either.
      //test this actually works, then remove these comments and pretend I actually know what is going on.
    };

    if (USE_DEFAULT_GTM) {
      $.when(theme.cart.getCart()).done(function (cart) {
        console.log({
          "cartObject": cart,
          "name": 'cartTriggered'
        });
        dataLayer.push({
          'event': 'ecommerce_event',
          'eventCategory': 'ecommerce',
          'eventAction': 'checkout',
          'ecommerce': {
            'detail': {
              'cart': cart
            }
          }
        });
        doneFunc();
      });
    } else {
      doneFunc();
    }
  }) //cart button
  .on('click', '.cartremover', function (e) {
    e.preventDefault();
    theme.cart.removeFromCart($(this).data('variant-id'));
  }).on('change', '.quantity input', function (e) {
    e.preventDefault();
    var $val = $(this);
    var variant = $val.data('variant-id');
    var qty = parseInt($val.val());
    var cartupdate = "updates[" + variant.toString() + "]=" + qty.toString();
    theme.cart.updateCart(cartupdate);
  }); //Utility block for things that can't be disabled properly, such as still requiring mouse-overs
  // don't use no-events css! Same as prop('disabled')

  $('body').on('click', '.disabled', function (e) {
    e.preventDefault();
    return false;
  });

  if (theme.finish_loading) {
    theme.finish_loading();
  }

  $(document).trigger('loaded.theme');
});
pReady.push(function () {
  $('.js-video-popup').magnificPopup({
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });
}); // $(document).ready(function () {

$(function () {
  $('.tooltip').tooltipster({
    maxWidth: 380,
    theme: ['tooltipster-shadow', 'tooltipster-shadow-customized']
  });
});
pReady.push(function () {
  // NOTE: init inventory fetch:
  // NOTE: leave the sessionStorage check commented out to refresh the inventory JSON on every page load:
  // if ( !sessionStorage.getItem('inventory') ) {
  $.getJSON("https://kjaerweis.roswellstudios.com/inventory/all", function (resp) {
    theme.inventory = resp;
    sessionStorage.setItem('inventory', JSON.stringify(resp));
  }); // }
});
/**================================
 * Currency Change Functions
 ================================*/

pReady.push(function () {
  //Currency on change
  var CountryName;


  // if currency/location not found in localStorage
  if (!localStorage.getItem('countrySelected')) {
    theme.currencyModal.open();
  }  
  else if (!sessionStorage.getItem('countrySelected')) {
    // if currency/location found in local storage but not sessionStorage
    // the sessionStorage value is used everywhere else in the theme
    CountryName = localStorage.getItem('countrySelected');
    sessionStorage.setItem('countrySelected', CountryName);
    theme.currencyChange(CountryName);
    $(document).trigger('locale.changed');
  }
  else {
    CountryName = sessionStorage.getItem('countrySelected');
    theme.currencyChange(CountryName);
    $(document).trigger('locale.changed');
  }

  var CountrySelector = $('.js-country-select');
  if (CountrySelector.length) {
    CountrySelector.on('click', function (e) {
      e.preventDefault();

      CountryName = $(this).attr('data-country-name');
      theme.currencyChange(CountryName);

      // set currency in localStorage and session storage
      // setting a value localStorage prevents the currency selection popup from appearing on page load
      // setting the same value in sessionStorage lets that value be used throughout the theme
      localStorage.setItem('countrySelected', CountryName);
      sessionStorage.setItem('countrySelected', CountryName);

      $(document).trigger('locale.changed');
      theme.cart.clearCart();
    })
  }

  //Modal Open and Close
  var CurrencyModalOpener = $('.js-currency-changer');
  var CurrencyModalCloser = $('.js-currency-close');
  CurrencyModalOpener.on('click', function (e) {
    e.preventDefault();
    theme.currencyModal.open();
  });
  CurrencyModalCloser.on('click', function (e) {
    e.preventDefault();
    theme.currencyModal.close();
  });
}); // Smooth Scroll Achors 

$(function () {
  $(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();
    $('html, body').animate({
      scrollTop: $($.attr(this, 'href')).offset().top
    }, 500);
  });
});